let app = angular.module('galilai.creator', ['ngSanitize']);

function uuidV4() {
    const uuid = new Array(36);
    for (let i = 0; i < 36; i++) {
        uuid[i] = Math.floor(Math.random() * 16);
    }
    uuid[14] = 4; // set bits 12-15 of time-high-and-version to 0100
    uuid[19] = uuid[19] &= ~(1 << 2); // set bit 6 of clock-seq-and-reserved to zero
    uuid[19] = uuid[19] |= (1 << 3); // set bit 7 of clock-seq-and-reserved to one
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    return uuid.map((x) => x.toString(16)).join('');
}

const DEBUG = false
const IS_APP = window.IS_APP || false
let CURRENT_OS = 'web'
if (IS_APP && window.navigator && window.navigator.userAgent) {
    CURRENT_OS = window.navigator.userAgent.toLowerCase().indexOf('android') > -1 ? 'android' : 'ios'
}
const IS_IOS = CURRENT_OS == 'ios'
const IS_ANDROID = CURRENT_OS == 'android'

const SMART_LAYOUTS_PREFIX = 's-'
window.BASE_URL = window.origin
window.RUN_ID = uuidV4()


function openOrReplaceURL(url) {
    if (IS_APP) {
        window.open(url, '_system')
    } else {
        window.location = url
    }
}
window.addEventListener('message', function (e) {
    if (e.data.name === 'redirectURL') {
        openOrReplaceURL(e.data.url)
    }
    if (e.data.name === 'reloadLocation') {
        window.location.reload()
    }
})

function changeURL(url) {
    if (window.self !== window.top) {
        window.parent.postMessage({
            name: 'redirectURL',
            url: url
        }, '*')
    } else {
        openOrReplaceURL(url)
    }
}

function goToEditor() {
    if (window.location.origin == 'https://galilai.com.br') {
        changeURL('https://galilai.com.br/editor-magico')
    } else {
        changeURL(window.BASE_URL + '/magic-editor')
    }
}

function reloadLocation(shouldWait) {
    function doReload() {
        if (window.self !== window.top) {
            window.parent.postMessage({
                name: 'reloadLocation'
            }, '*')
        } else {
            window.location.reload()
        }
    }

    if (shouldWait) {
        setTimeout(doReload, 500)
    } else {
        doReload()
    }
}

function configureBaseURL() {
    if (!IS_APP) {
        return
    }
    const fullLanguage = navigator.language || navigator.userLanguage
    const language = fullLanguage.split('-')[0]
    if (language == 'pt') {
        window.BASE_URL = 'https://galilai.com.br'
    } else {
        window.BASE_URL = 'https://galil.ai'
    }
}
configureBaseURL()

function safeSetStorage(key, value) {
    try {
        localStorage.setItem(key, value)
    } catch (e) { }
}

function safeGetStorage(key) {
    try {
        return localStorage.getItem(key)
    } catch (e) {
        return null
    }
}

// Function to get a cookie by name
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

// Function to set a cookie with a specific expiration date
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
}

function getLocaleDate(date) {
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2)
}

function detectCountry() {
    try {
        if (!getCookie("galilai.country")) {
            fetch("https://ipinfo.io?token=622b57e2fb326a")
                .then(response => response.json())
                .then(data => {
                    const country = data.country;
                    if (country) {
                        setCookie("galilai.country", country, 30);
                    }
                })
                .catch(error => console.error("Error fetching country:", error));
        }
    } catch (error) {
        console.error("Error detecting country:", error);
    }
}

function getCurrentCurrency() {
    if (!getCookie("galilai.country")) {
        return
    }
    const country = getCookie("galilai.country");

    return countriesToCurrency[country]?.currency
}

function getCurrentCountry() {
    if (!getCookie("galilai.country")) {
        return
    }
    return getCookie("galilai.country")
}

detectCountry()

function sendMessageWithCallback(message) {
    return new Promise((resolve) => {
        // Generate a unique message ID
        var messageId = Math.random().toString(36).substring(10);
        message.id = messageId;

        let container = window
        if (window.self !== window.top) {
            container = window.parent
        }
        // Send the message
        container.postMessage(message, '*');

        // Define the callback listener
        function callbackListener(event) {
            // Check if the response matches the message ID and kind
            if (event.data.id === messageId && event.data.kind === 'response') {
                // Remove the listener once we get the response
                window.removeEventListener('message', callbackListener);
                // Resolve the promise with the response data
                resolve(event.data);
            }
        }

        // Add the listener for message events
        window.addEventListener('message', callbackListener);
    });
}

function fullcopy(obj) {
    return JSON.parse(JSON.stringify(obj))
}

function toBinary(string) {
    return window.btoa(encodeURIComponent(string))
}

function fromBinary(encoded) {
    return decodeURIComponent(window.atob(encoded))
}
function isValidNumber(value) {
    if (typeof value === 'undefined' && value !== null) {
        return false
    }
    if (isNaN(parseFloat(value))) {
        return false
    }
    return true
}

function getValidNumber(value, defaultValue) {
    if (!isValidNumber(value)) {
        return defaultValue
    }
    return parseFloat(value)
}

let lastDebugMessageTime = {}
function _d(message) {
    if (!DEBUG) {
        return
    }
    document.getElementById('debug').innerHTML += 'Info: ' + message + '<br>'
}
function _dstart(message) {
    if (!DEBUG) {
        return
    }
    lastDebugMessageTime[message] = performance.now()
    document.getElementById('debug').innerHTML += 'Start: ' + message + '<br>'
}
function _dend(message) {
    if (!DEBUG) {
        return
    }
    let time = performance.now() - lastDebugMessageTime[message]
    document.getElementById('debug').innerHTML += 'Finish: ' + message + ' [' + time.toFixed(0) + 'ms]<br>'
}
function chooseWithHash(array, seed) {
    seed = seed + '' // Ensure seed is a string
    let hash = seed.split('').reduce(function (a, b) { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0)
    hash = Math.abs(hash)
    return array[hash % array.length]
}

function getLayoutParentId(layout) {
    if (!layout) {
        return null
    }
    let label = layout.label
    if (!label) {
        return null
    }
    if (!label.startsWith('d-')) {
        return null
    }
    let parentId = label.substring(2).split('.')[0]
    return parentId
}

function getUserLoginForm(email) {
    let inputForm = {
        email: email,
        meta: {},
    };

    try {
        inputForm.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
        console.log(e);
    }

    let instagram = localStorage.getItem('auth.user.instagram');
    if (instagram) {
        inputForm.meta.instagram = instagram;
    }

    let area = localStorage.getItem('auth.user.area');
    if (area) {
        inputForm.meta.area = area;
    }

    try {
        let uuid = localStorage.getItem('galilai.uuid');
        if (uuid) {
            inputForm.meta.uuid = uuid;
        }
    } catch (e) {
        console.log(e);
    }

    try {
        let coupon = localStorage.getItem('galilai.coupon');
        if (coupon) {
            inputForm.meta.coupon = coupon;
        }
    } catch (e) {
        console.log(e);
    }

    return inputForm;
}

const BASE_THEME = {
    pallete: {
        main: '#03a9f4',
        text: '#e1f5fe',
        highlight: '#033349'
    },
    fonts: {
        primary: 'Manrope',
        secondary: 'Open Sans',
    },
    size: {
        width: 1,
        height: 1.25
    },
    defaults: {
        titleSize: 2,
        descriptionSize: 1,
        titleMinSize: 1.5,
        descriptionMinSize: 0.8,
    },
    settings: {},
}

const MAP_POST_SIZES = {
    'reels': {
        width: 1,
        height: 1.777777777778
    },
    'story': {
        width: 1,
        height: 1.777777777778
    },
    'post': {
        width: 1,
        height: 1.25
    }
}

function getBaseTheme() {
    return fullcopy(BASE_THEME)
}

const _PLANS = {
    BASIC: 'basic',
    PLUS: 'pro',
    PRO: 'premium',
    MAX: 'max',
    SHOP: 'shop',
    ADS: 'ads',
    INFINITE: 'infinite',
}

function getPlansName(plan) {
    switch (plan) {
        case _PLANS.BASIC:
            return 'Basic'
        case _PLANS.PLUS:
            return 'Plus'
        case _PLANS.PRO:
            return 'Pro'
        case _PLANS.MAX:
            return 'Max'
        case _PLANS.SHOP:
            return 'Shop'
        case _PLANS.ADS:
            return 'Ads'
        case _PLANS.INFINITE:
            return 'Infinite'
    }
    return 'Unknown'
}

String.prototype.stripHtml = function () {
    return this.replace(/<[^>]*>?/gm, '');
}

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

const specialAttributes = {
    'cta': '👉',
    'badge': "\\.",
    'address': '📍',
    'phone': '📞',
    'discount': '🏷️',
    'price': '💰',
}

function fixCommonEmailTypos(email) {
    const commonTypos = {
        'gmail.com': ['gamil.com', 'gmai.com', 'gmail.co', 'gmailcom', 'gmil.com', 'gmal.com', 'gmaill.com', 'gmaillcom', 'gmaill.co', 'gmaillco', 'gmai.co', 'gmail.con', 'gmail', 'gamil', 'gmil', 'gmal', 'gmaill', 'gmial.com', 'gmial'],
        'yahoo.com': ['yaho.com', 'yaoo.com', 'yahoi.com', 'yahho.com', 'yahooo.com', 'yahoo.co', 'yahoo.con', 'yahoo'],
        'outlook.com': ['outlok.com', 'outloook.com', 'outlook.co', 'outlokcom', 'outloookcom', 'outlookco', 'outlook.con', 'outlook'],
        'hotmail.com': ['hotmai.com', 'hotmal.com', 'hotmail.con', 'hotmail', 'hotmai', 'hotmal'],
    };

    const emailParts = email.split('@');
    if (emailParts.length !== 2) {
        return null
    }

    const domain = emailParts[1];
    for (const correctDomain in commonTypos) {
        if (commonTypos[correctDomain].indexOf(domain) !== -1) {
            return emailParts[0] + '@' + correctDomain;
        }
    }
    // If emails end with .con, replace with .com
    if (domain.endsWith('.con')) {
        return emailParts[0] + '@' + domain.replace('.con', '.com');
    }

    return email;
}

app.config(function ($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
});

app.filter('trusted', function ($sce) {
    return function (html) {
        return $sce.trustAsHtml(html)
    }
})

app.factory('experiments', function () {
    let experiments = {}

    let activeExperiments = [
        //'improved-headlines',
        'calendar',
        'show-plans-instead-trial',
        'plans-period-monthly',
    ]

    experiments.isVariant = function (name) {
        // Force result
        /* if (name == 'show-plans-instead-trial') {
            return 'b'
        } */
        // Check if name is in active experiments
        if (activeExperiments.indexOf(name) == -1) {
            return false
        }
        try {
            let variant = localStorage.getItem('galilai.experiment.' + name)
            if (variant) {
                return variant.toLowerCase() == 'b'
            }
        } catch (e) {
            logError({
                messsage: 'Experiment error',
                error: e
            })
        }
        return false
    }

    experiments.setupExperiments = function () {
        try {
            // For all active experiments save local storage Math.random weather the user is in the variant or not
            for (let experiment of activeExperiments) {
                let variant = localStorage.getItem('galilai.experiment.' + experiment)
                if (!variant) {
                    variant = Math.random() < 0.5 ? 'A' : 'B'
                    localStorage.setItem('galilai.experiment.' + experiment, variant)
                }
            }
        } catch (e) {
            logError({
                messsage: 'Setup experiments error',
                error: e
            })
        }
    }
    experiments.getTrackInfo = function () {
        let info = {}
        try {
            for (let experiment of activeExperiments) {
                let variant = localStorage.getItem('galilai.experiment.' + experiment)
                if (!variant) {
                    variant = 'none'
                }
                info[experiment] = variant
            }
        } catch (e) {
            logError({
                messsage: 'Get track info error',
                error: e
            })
        }
        return info
    }
    return experiments
})

app.filter("reverse", function () {
    return function (items) {
        return items.slice().reverse();
    };
});

app.directive('stopPropagation', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            // Listen for the specified events (default is click and focus)
            element.on(attrs.stopPropagation || 'click focus', function (event) {
                event.stopPropagation(); // Stop the event from propagating
            });
        }
    };
});

app.directive('radioGroup', function () {
    return {
        restrict: 'E',
        scope: {
            inputs: '=',
            multiple: '=?', // Optional multiple selection, defaults to false,
            change: '&?', // Optional change event handler
        },
        require: 'ngModel',
        template: `
            <div class="radio-group">
                <label class="form-label text-muted d-block mb-0">
                    {{inputs.label}}
                    <tooltip-icon ng-if="inputs.tooltip" tooltip="[[inputs.tooltip]]"></tooltip-icon>
                </label>
                <div class="btn-group" role="group">
                    <button
                        type="button"
                        class="btn btn-xs btn-outline-primary"
                        ng-class="{ 'active': isSelected(value.value) && !multiple }"
                        ng-repeat="value in inputs.values"
                        ng-click="toggleValue(value.value, $event)">
                        <span ng-if="multiple && isSelected(value.value)" class="mdi mdi-checkbox-marked-circle"></span>
                        <span ng-if="multiple && !isSelected(value.value)" class="mdi mdi-checkbox-blank-circle-outline"></span>
                        {{value.label}}
                    </button>
                </div>
            </div>
        `,
        link: function (scope, element, attrs, ngModelCtrl) {
            // Default multiple to false if not specified
            scope.multiple = scope.multiple || false;

            // Initialize the model value
            ngModelCtrl.$render = function () {
                scope.ngModel = ngModelCtrl.$viewValue;
            };

            scope.isSelected = function (value) {
                if (scope.multiple) {
                    return Array.isArray(scope.ngModel) && scope.ngModel.includes(value);
                }
                return scope.ngModel === value;
            };

            scope.toggleValue = function (value, event) {
                let oldValue = angular.copy(scope.ngModel); // Capture the old model value

                if (scope.multiple) {
                    let selectedValues = Array.isArray(scope.ngModel) ? [...scope.ngModel] : [];
                    let index = selectedValues.indexOf(value);
                    if (index > -1) {
                        selectedValues.splice(index, 1); // Deselect
                    } else {
                        selectedValues.push(value); // Select
                    }
                    ngModelCtrl.$setViewValue(selectedValues);
                } else {
                    ngModelCtrl.$setViewValue(value);
                }
                ngModelCtrl.$render();

                if (scope.change && !angular.equals(oldValue, ngModelCtrl.$viewValue)) {
                    scope.change({ newValue: ngModelCtrl.$viewValue, oldValue: oldValue });
                }

                if (event && event.currentTarget) {
                    event.currentTarget.blur();
                }
            };
        }
    };
});

app.directive('setAttrs', function () {
    return {
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs) {
            scope.$watch(attrs.setAttrs, function (newAttrs) {
                // Remove all previous dynamic attributes
                angular.forEach(element[0].attributes, function (attr) {
                    if (newAttrs && newAttrs.hasOwnProperty(attr.name)) {
                        element[0].removeAttribute(attr.name);
                    }
                });

                if (newAttrs) {
                    // Set new attributes
                    angular.forEach(newAttrs, function (value, key) {
                        element[0].setAttribute(key, value);
                    });
                }
            }, true);
        }
    };
});

app.directive('carouselSlide', function () {
    return {
        restrict: 'E',
        scope: {
            images: '='
        },
        template: `
            <div class="carousel-container" ng-if="images && images.length > 0">
                <img ng-src="[[getCurrentImage()]]" class="carousel-image">

                <div class="carousel-controls d-flex gap-1 mt-1" ng-if="images.length > 1">
                    <button class="btn btn-primary btn-xs w-100 carousel-btn" ng-disabled="currentIndex === 0" ng-click="prev()">
                        <i class="mdi mdi-chevron-left"></i>
                    </button>

                    <button class="btn btn-primary btn-xs w-100 carousel-btn" ng-disabled="currentIndex === images.length - 1" ng-click="next()">
                        <i class="mdi mdi-chevron-right"></i>
                    </button>
                </div>
            </div>
        `,
        controller: function ($scope) {
            $scope.currentIndex = 0;

            $scope.prev = function () {
                if ($scope.currentIndex > 0) {
                    $scope.currentIndex--;
                }
            };

            $scope.next = function () {
                if ($scope.currentIndex < $scope.images.length - 1) {
                    $scope.currentIndex++;
                }
            };

            $scope.getCurrentImage = function () {
                return $scope.images[$scope.currentIndex];
            }
        },
        link: function (scope, element, attrs) {
            if (!Array.isArray(scope.images)) {
                scope.images = [];
            }
        }
    };
});


app.directive('help', function ($rootScope) {
    return {
        restrict: 'E',
        scope: {
            id: '@?',
            group: '@?',
            ids: '@?',
        },
        template: `
        <span role="button" class="ms-2 text-primary" style="cursor: pointer!important;z-index:10000000"
              ng-click="triggerHelp()">
          <i class="bi bi-question-circle"></i>
        </span>
      `,
        link: function (scope) {
            scope.triggerHelp = function () {
                var data = {};
                if (scope.help) data.help = scope.help;
                if (scope.group) data.group = scope.group;
                if (scope.ids) data.ids = scope.ids.split(',').map(function (id) { return id.trim(); });
                $rootScope.$broadcast('help.show', data);
            };
        }
    };
});

app.directive('contentRender', function ($timeout, api) {
    return {
        restrict: 'E',
        scope: {
            content: '=?',
            contentId: '=',
            onActivate: '=?',
        },
        link: function ($scope, element, attrs) {
            $scope.activeTabs = {}
            $scope.activeTab = null
            $scope.activeCard = null
            $scope.activeCardContent = null
            $scope.breadcrumbs = []

            $scope.activateTab = function (section, tab) {
                $scope.activeTabs[section.id] = tab.id
                $scope.activeTab = tab
            }

            $scope.init = function () {
                function setTabs(content) {
                    for (let section of content) {
                        if (section.type == 'tabs') {
                            $scope.activateTab(section, section.sections[0])
                            setTabs(section.sections)
                        }
                    }
                }
                setTabs($scope.content)
                $timeout(angular.noop)
            }

            $scope.$watch('contentId', function (newVal) {
                if (newVal) {
                    $scope.activeTabs = {}
                    $scope.activeTab = null
                }
                if (!newVal) {
                    return
                }
                $scope.loading = true
                api.getHelpContent(newVal).then(function (response) {
                    $scope.content = response.data
                })
                    .catch(function () {
                        // TASK - No handling
                    })
                    .finally(function () {
                        $scope.loading = false
                        $timeout(angular.noop)
                    })
            })

            $scope.$watch('content', function (newVal) {
                if (!newVal || newVal.length == 0 || newVal.filter(item => item).length == 0) {
                    return
                }
                $scope.init()
            })

            $scope.getActiveCardContent = function () {
                if (!$scope.activeCard) {
                    return
                }
                $scope.loading = true
                api.getHelpContent($scope.activeCard.link).then(function (response) {
                    $scope.activeCardContent = response.data
                })
                    .catch(function () {
                        // TASK - No handling
                    })
                    .finally(function () {
                        $scope.loading = false
                        $timeout(angular.noop)
                    })
            }

            $scope.activateCard = function (card) {
                if (card == null) {
                    $scope.breadcrumbs = []
                    $scope.activeCard = null
                    $scope.activeCardContent = null
                    return
                }
                // Check if card is already on breadcrumbs if so remove all after it
                let index = $scope.breadcrumbs.indexOf(card)
                if (index != -1) {
                    $scope.breadcrumbs = $scope.breadcrumbs.slice(0, index + 1)
                } else {
                    $scope.breadcrumbs.push(card)
                }
                $scope.activeCard = card
                $scope.getActiveCardContent()
            }

            if (!$scope.onActivate) {
                $scope.onActivate = function (card) {
                    $scope.activateCard(card)
                }
            }
        },
        template: `
            <div ng-if="loading" class="text-center">
                <i class="mdi mdi-loading mdi-spin" style="font-size: 40px;margin: 30px"></i>
            </div>
            <!-- breadcrumbs -->
            <div ng-if="breadcrumbs.length > 0" class="mb-2">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0">
                        <!-- Add home help -->
                        <li class="breadcrumb item" ng-click="activateCard(null)" style="cursor: pointer">
                            <i class="mdi mdi-home"></i>
                        </li>
                        <li class="breadcrumb item" ng-repeat="item in breadcrumbs">
                            <a href="javascript:void(0)" ng-click="activateCard(item)">{{item.title}}</a>
                        </li>
                    </ol>
                </nav>
            </div>
            <div ng-repeat="section in content" class="mb-2" ng-show="!activeCard">
                <div ng-if="section.type == 'p' || section.content.length > 0">
                    <div class="mb-1" ng-repeat="element in section.content track by $index">
                        <p style="margin:0px 0px 3px 0px" ng-bind-html="element.content | trusted" ng-if="element.type == 'text'"></p>
                        <img ng-src="{{element.src}}" ng-if="element.type == 'image'" style="max-width: 100%">
                        <video ng-src="{{element.src}}" ng-if="element.type == 'video'" muted autoplay style="max-height: 500px" controls></video>
                    </div>
                </div>
                <div ng-if="section.type == 'tabs'">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" ng-repeat="tab in section.sections">
                            <a
                                class="nav-link" ng-class="{active: activeTabs[section.id] == tab.id}"
                                ng-click="activateTab(section, tab)" href="javascript:void(0)">
                                {{tab.title}}
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content mt-1">
                        <div class="tab-pane active">
                            <content-render content="[activeTab]"></content-render>
                        </div>
                    </div>
                </div>
                <div ng-if="section.type == 'cards'">
                    <div class="row">
                        <div class="col-md-4" ng-repeat="card in section.sections">
                            <div class="card mb-2" ng-click="onActivate(card);">
                                <div class="card-body" style="padding: 12px;min-height: 90px; cursor: pointer; user-select: none; text-align: center">
                                    <!-- add icon mdi -->
                                    <i ng-if="card.icon" class="mdi mdi-{{card.icon}}" style="font-size: 30px; color: #744ffe"></i>
                                    <h5 class="card-title mb-1">{{card.title}}</h5>
                                    <p class="card-text" ng-bind-html="card.content"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div ng-if="section.type == 'accordion'">
                    <div class="accordion">
                        <div class="accordion-item" ng-repeat="tab in section.sections">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button" type="button"
                                    ng-click="activateTab(section, tab)" ng-class="{collapsed: activeTabs[section.id] != tab.id}">
                                    {{tab.title}}
                                </button>
                            </h2>
                            <div class="accordion-collapse" ng-class="{show: activeTabs[section.id] == tab.id, 'd-none': activeTabs[section.id] != tab.id}">
                                <div class="accordion-body">
                                    <content-render content="[activeTab]"></content-render>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div ng-if="section.type == 'container'">
                    <content-render content="section.sections"></content-render>
                </div>
            </div>
            <content-render ng-if="activeCardContent" content="activeCardContent" on-activate="onActivate"></content-render>
        `
    }
})

// Create a content-render-modal, it accepts content-id and opens a modal with the content-render. It also has a show parameter to open the modal. also whenever the modal hides it resets the content and the param
app.directive('contentRenderModal', function () {
    return {
        restrict: 'E',
        scope: {
            contentId: '=',
            title: '=',
            show: '=?',
        },
        link: function ($scope, element, attrs) {
            $scope.gettext = gettext
            $scope.$watch('show', function (newVal) {
                if (typeof newVal == 'boolean' && element && element.find('.modal') && element.find('.modal').modal) {
                    element.find('.modal').modal(newVal ? 'show' : 'hide')
                    let modal = element.find('.modal')
                    modal.css('z-index', 100000000)
                }
            })

            if (element) {
                element.find('.modal').on('hidden.bs.modal', function () {
                    $scope.show = false
                    $scope.contentId = null
                })
            }
        },
        template: `
            <div class="modal modal-lg" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{title || gettext('label.help_modal')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <content-render content-id="contentId"></content-render>
                        </div>
                    </div>
                </div>
            </div>
        `
    }
})


app.directive('buttonSplit', function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            main: '=',
            items: '=',
            dropdownPosition: '@',
            btnSize: '@?',
            disabled: '=?'  // Added disabled attribute
        },
        template: `
            <div ng-class="{'btn-group': main, 'dropdown mt-2': !main}">
                <button ng-if="main" type="button" class="btn btn-outline-primary"
                    ng-class="'btn-' + btnSize"
                    ng-click="!disabled && doAction(main)"
                    ng-disabled="disabled">
                    <i ng-if="main.icon" class="mdi mdi-{{main.icon}}"></i>
                    {{main.label}}
                </button>
                <button type="button" class="btn btn-outline-primary dropdown-toggle dropdown-toggle-split"
                    data-bs-display="static"
                    ng-class="['btn-' + btnSize, {'show': showDropdown}]"
                    ng-click="!disabled && toggleDropdown($event)"
                    ng-disabled="disabled">
                    <span class="visually-hidden">Toggle Dropdown</span>
                </button>
                <ul class="dropdown-menu"
                    ng-class="{'show': showDropdown}"
                    style="{{dropdownPosition === 'top' ? 'bottom: 100%;' : 'top: 100%;'}}">
                    <li ng-repeat="item in items" ng-if="isVisible(item)">
                        <a class="dropdown-item" href="javascript:void(0)"
                            ng-click="!disabled && doAction(item)"
                            ng-class="{'disabled': disabled}">
                            <i ng-if="item.icon" class="{{item.icon}}"></i>
                            {{item.label}}
                        </a>
                    </li>
                </ul>
            </div>
        `,
        link: function ($scope, element, attrs) {
            $scope.btnSize = attrs.btnSize || 'sm';
            $scope.showDropdown = false;

            $scope.toggleDropdown = function (event) {
                if ($scope.disabled) return;  // Prevent action when disabled
                event.stopPropagation();
                $scope.showDropdown = !$scope.showDropdown;
            }

            $scope.isVisible = function (item) {
                return typeof item.visible === 'undefined' || item.visible;
            }

            $scope.doAction = function (item) {
                if ($scope.disabled) return;  // Prevent action when disabled
                $scope.showDropdown = false;
                if (item.args) {
                    item.action(...item.args);
                } else {
                    item.action();
                }
            }

            document.addEventListener('click', function (event) {
                if ($scope.showDropdown && !element[0].contains(event.target)) {
                    $timeout(() => {
                        $scope.showDropdown = false;
                    })
                }
            });
        }
    };
});

app.directive('draggable', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.attr('draggable', true);

            element.bind('dragstart', function (event) {
                event = event.originalEvent || event;
                if (!event.dataTransfer) {
                    event.dataTransfer = new DataTransfer()
                }

                event.dataTransfer.setData('text', attrs.itemid);
            });
        }
    };
})

app.directive('checkbox', function () {
    return {
        restrict: 'E',
        scope: {
            ngModel: '=',
            trueValue: '@?',
            falseValue: '@?',
            trueLabel: '@',
            falseLabel: '@?',
            tooltipText: '@',
            onChange: '&?'
        },
        template: `
            <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input" ng-model="checked" ng-change="handleChange()">
                <label class="form-check-label" for="flexSwitchCheckDefault">{{ label }}</label>
                <tooltip-icon ng-if="tooltipText" class="ms-1" tooltip="{{ tooltipText }}"></tooltip-icon>
            </div>
        `,
        link: function (scope, element, attrs) {
            // Fallback to boolean true/false if no values are provided
            if (typeof scope.trueValue === 'undefined') {
                scope.trueValue = true;
            }
            if (typeof scope.falseValue === 'undefined') {
                scope.falseValue = false;
            }

            scope.updateModel = function () {
                scope.ngModel = scope.checked ? scope.trueValue : scope.falseValue;
                scope.label = scope.checked ? scope.trueLabel : (scope.falseLabel || scope.trueLabel);
            };

            scope.handleChange = function () {
                scope.updateModel();
                if (scope.onChange) {
                    scope.onChange({ value: scope.ngModel });
                }
            };

            scope.$watch('ngModel', function (newVal) {
                scope.checked = newVal == scope.trueValue;
                scope.label = scope.checked ? scope.trueLabel : (scope.falseLabel || scope.trueLabel);
            });
        }
    };
});

app.directive('droppable', function () {
    return {
        restrict: 'A',
        scope: {
            droppable: '=',
            drop: '&'
        },
        link: function (scope, element, attrs) {
            element.bind('dragover', function (event) {
                event.preventDefault();
            });

            element.bind('drop', function (event) {
                event.preventDefault();
                event = event.originalEvent || event;
                var data = event.dataTransfer.getData('text');
                scope.$apply(function () {
                    scope.drop()(data, scope.droppable);
                });
            });
        }
    };
});

app.directive('editable', function ($timeout) {
    return {
        restrict: 'A', // Attribute only
        scope: {
            contentId: '@', // Bind the id attribute from the parent scope
            change: '=' // Bind the callback function from the parent scope
        },
        link: function (scope, element, attrs) {
            var debounce;

            element.attr('contenteditable', attrs.contenteditable || 'true');

            function triggerChange() {
                if (debounce) {
                    $timeout.cancel(debounce);
                }
                debounce = $timeout(function () {
                    var html = element.html();
                    scope.change({ content: html, id: scope.contentId });
                }, 150);
            }

            element.on('input keyup paste', function () {
                scope.$apply(triggerChange);
            });

            // Optional: Clean up the event listener and the timeout when the element is destroyed
            scope.$on('$destroy', function () {
                element.off('input keyup paste');
                if (debounce) {
                    $timeout.cancel(debounce);
                }
            });
        }
    };
});

app.directive('defaultCheckbox', function ($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            function isModelInvalid() {
                return ngModelCtrl.$modelValue === undefined || typeof ngModelCtrl.$modelValue === 'undefined' || isNaN(ngModelCtrl.$modelValue)
            }
            // Listen for changes to the model value
            element.on('change', function () {
                $timeout(function () {
                    if (isModelInvalid()) {
                        ngModelCtrl.$setViewValue(true)
                        ngModelCtrl.$setViewValue(false);
                        ngModelCtrl.$render();
                        return
                    }
                    ngModelCtrl.$setViewValue(element.prop('checked'));
                    ngModelCtrl.$render();
                })
            });

            // Watch the ngModel value and update the element's checked state
            scope.$watch(function () {
                return ngModelCtrl.$modelValue;
            }, function (newVal) {
                if (isModelInvalid()) {
                    element.prop('checked', true);
                    return
                }
                element.prop('checked', !!newVal);
            });
        }
    };
});

// Define the module
app.directive('mediaPicker', function () {
    return {
        restrict: 'E',
        scope: {
            config: '=',
            onSelect: '=',
        },
        controller: 'MediaController',
        templateUrl: 'media-picker-template.html'
    };
});

app
    .directive('pxEdit', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {
                // Function to parse the value from the model to the view
                ngModelController.$parsers.push(function (value) {
                    return value + 'px';
                });

                // Function to format the value from the view to the model
                ngModelController.$formatters.push(function (value) {
                    return Math.round(parseFloat(value) * 10) / 10;
                });

                // Watch for changes on the element to update the model with 'px'
                element.on('blur keyup change', function () {
                    var viewValue = element.val();
                    // Only update when the view value is a valid number
                    if (!isNaN(viewValue)) {
                        ngModelController.$setViewValue(viewValue);
                        ngModelController.$render();
                    }
                });
            }
        };
    });
app.directive('autocomplete', function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            items: '=',
            selected: '=',
            empty: '=',
            allowCustom: '=',
            change: '&',
            size: '@',
        },
        template: `
           <div style="position: relative;">
                <input type="text" class="form-control form-control-{{size || 'md'}}" ng-model="selectedItem" ng-change="filterItems()" placeholder="{{labelSearch}}" ng-blur="onBlur()" ng-focus="startAutocomplete()">
                <i ng-if="empty && selectedItem" class="mdi mdi-close-circle" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;" ng-click="clearSelection()"></i>
                <ul class="dropdown-menu" style="display:block;" ng-show="filteredItems.length">
                    <li ng-repeat="item in filteredItems" ng-click="selectItem(item, $event)" class="dropdown-item" style="cursor: pointer">
                        <a href="javascript:void(0)">{{getLabel(item)}}</a>
                    </li>
                </ul>
            </div>
        `,
        link: function ($scope) {
            $scope.keySearch = 'label';
            $scope.labelSearch = gettext('label.type_search');
            const valueKey = 'value';

            $scope.fillInitialValue = function (value) {
                if (!value) {
                    $scope.selectedItem = null;
                    return;
                }
                if (!$scope.items || !$scope.items.length) {
                    return;
                }
                let items = $scope.items.filter(item => item[valueKey] == value);
                if (items.length > 0) {
                    $scope.selectedItem = items[0][$scope.keySearch];
                }
            };

            $scope.clearSelection = function () {
                $scope.selectedItem = '';
                $scope.selected = null;
                $scope.filteredItems = [];
                $timeout(angular.noop);
                $scope.change();
            };

            $scope.$watch('selected', function (newVal) {
                $scope.fillInitialValue(newVal);
            });
            $scope.$watch('items', function (newVal) {
                if ($scope.selected) {
                    $scope.fillInitialValue($scope.selected);
                }
            });

            $scope.startAutocomplete = function () {
                $scope.selectedItem = '';
                if ($scope.items && $scope.items.length) {
                    $scope.filteredItems = $scope.items.slice(0, 20);
                }
            };
            $scope.getLabel = function (item) {
                return item[$scope.keySearch];
            };
            $scope.filterItems = function () {
                if (!$scope.items || !$scope.items.length) {
                    return;
                }
                $scope.filteredItems = $scope.items.filter(function (item) {
                    if (!$scope.selectedItem) {
                        return false;
                    }
                    return item[$scope.keySearch].toLowerCase().includes($scope.selectedItem.toLowerCase());
                });
            };

            let timerBlur = null;
            $scope.onBlur = function () {
                if (timerBlur) {
                    $timeout.cancel(timerBlur);
                }
                timerBlur = $timeout(function () {
                    let noItemsFound = !$scope.items || !$scope.items.length || $scope.items.filter(item => item[$scope.keySearch] == $scope.selectedItem).length == 0;
                    if (($scope.selectedItem && noItemsFound) || !$scope.selectedItem) {
                        if ($scope.allowCustom && $scope.selectedItem) {
                            $scope.selected = $scope.selectedItem;
                        } else {
                            $scope.fillInitialValue($scope.selected);
                        }
                    }
                    $scope.filteredItems = [];
                    if ($scope.selected) {
                        $scope.change();
                    }
                }, 100);
            };

            $scope.selectItem = function (item, $event) {
                $event.stopPropagation();
                $event.preventDefault();
                $scope.selectedItem = item[$scope.keySearch];
                $scope.filteredItems = [];
                $scope.selected = item[valueKey];
                $timeout(angular.noop);
                $scope.change();
            };

            $scope.filterItems();
        }
    };
});

app.directive('tooltipIcon', ['$timeout', function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            tooltip: '@'
        },
        template: `
            <div class="tooltip-container" ng-click="toggleTooltip()" ng-class="{'show-tooltip': tooltipVisible}">
                <i class="mdi mdi-information"></i>
                <div class="tooltip-content">{{tooltip}}</div>
            </div>
        `,
        link: function (scope) {
            let timer = null
            scope.tooltipVisible = false;
            scope.toggleTooltip = function () {
                if (timer) {
                    $timeout.cancel(timer);
                }
                if (scope.tooltipVisible) {
                    if (timer) {
                        $timeout.cancel(timer);
                    }
                    scope.tooltipVisible = false;
                } else {
                    scope.tooltipVisible = true;

                    const minDuration = 4000
                    // Calculate the duration based on the tooltip number of words and the average reading speed
                    let words = scope.tooltip.split(' ').length
                    // Average reading speed is 200 words per minute
                    let duration = Math.max(minDuration, words / 200 * 60 * 1000)
                    timer = $timeout(function () {
                        scope.tooltipVisible = false;
                    }, duration);
                }
            };
        }
    };
}]);

app.directive('colorpickeritem', function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            pallete: '=',
            colors: '=',
            editing: '=',
            change: '&',
            remove: '&',
            cancelAdd: '&',
            onEdit: '&',
            onEditEnd: '&',
            apply: '&'
        },
        template: `
            <div ng-if="!editing" class="picker-preview v-align d-flex flex-wrap">
                <div ng-repeat="(key, value) in pallete track by $index"
                    ng-show="key == 'main' || key == 'text' || key == 'highlight'"
                    style="background-color: {{value}};"
                    class="picker-item-color"
                    ng-click="toggleEditing()">
                </div>
                <!-- add edit, use, and remove button -->
                <a href="javascript:void(0)"  ng-click="apply()" class="me-2">
                    <i class="mdi mdi-format-color-fill"></i>
                    {{gettext('label.apply_pallete')}}
                </a>
                <a href="javascript:void(0)"  ng-click="toggleEditing()" class="me-2">
                    <i class="mdi mdi-pencil"></i>
                    {{gettext('label.generic_edit')}}
                </a>
                <a href="javascript:void(0)" ng-click="remove()" class="me-2">
                    <i class="mdi mdi-delete"></i>
                    {{gettext('label.generic_remove')}}
                </a>
            </div>
            <div ng-if="editing" class="picker-edit">
                <div class="row">
                    <label class="col-12 col-md-3 col-form-label">{{gettext('label.main_color')}}</label>
                    <div class="col-12 col-md-9 v-align">
                        <input id="main-input-color" type="color" ng-model="tempPallete.main" ng-model-options="{ debounce: 100 }">
                        <a href="javascript:void(0)" ng-click="showColor('main')" class="picker-show-color-btn">
                            [[gettext('label.click_to_edit_color')]]
                        </a>
                        <div>
                            <div ng-repeat="color in colors track by $index"
                                ng-click="selectColor(color.value, 'main')"
                                style="background-color: {{color.value}};"
                                class="picker-item-color">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label class="col-12 col-md-3 col-form-label">{{gettext('label.text_color')}}</label>
                    <div class="col-12 col-md-9 v-align">
                        <input id="text-input-color" type="color" ng-model="tempPallete.text" ng-model-options="{ debounce: 100 }">
                        <a href="javascript:void(0)" ng-click="showColor('text')" class="picker-show-color-btn">
                            [[gettext('label.click_to_edit_color')]]
                        </a>
                        <div>
                            <div ng-repeat="color in colors track by $index"
                                ng-click="selectColor(color.value, 'text')"
                                style="background-color: {{color.value}};"
                                class="picker-item-color">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label class="col-12 col-md-3 col-form-label">{{gettext('label.accent_color')}}</label>
                    <div class="col-12 col-md-9 v-align">
                        <input id="highlight-input-color" type="color" ng-model="tempPallete.highlight" ng-model-options="{ debounce: 100 }">
                        <a href="javascript:void(0)" ng-click="showColor('highlight')" class="picker-show-color-btn">
                            [[gettext('label.click_to_edit_color')]]
                        </a>
                        <div>
                            <div ng-repeat="color in colors track by $index"
                                ng-click="selectColor(color.value, 'highlight')"
                                style="background-color: {{color.value}};"
                                class="picker-item-color">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-wrap mt-2">
                    <a href="javascript:void(0)" ng-click="save()" class="me-2 btn btn-outline-primary btn-xs">
                        <i class="mdi mdi-content-save"></i>
                        {{gettext('label.generic_save')}}
                    </a>
                    <a href="javascript:void(0)" ng-click="cancel()" class="me-2 btn btn-outline-secondary btn-xs">
                        <i class="mdi mdi-close"></i>
                        {{gettext('label.generic_cancel')}}
                    </a>
                </div>
            </div>
        `,
        link: function (scope) {
            scope.gettext = gettext
            // Temporary palette to store editing changes
            scope.tempPallete = angular.copy(scope.pallete);

            // Toggles editing mode
            scope.toggleEditing = function () {
                scope.editing = true;
                scope.tempPallete = angular.copy(scope.pallete);
                scope.onEdit()
            };

            // Save changes
            scope.save = function () {
                delete scope.tempPallete.editing
                delete scope.tempPallete.isNew
                angular.copy(scope.tempPallete, scope.pallete);
                scope.editing = false;
                scope.change();
                scope.onEditEnd()
            };

            // Cancel changes
            scope.cancel = function () {
                if (scope.tempPallete.isNew) {
                    scope.cancelAdd();
                }
                scope.tempPallete = angular.copy(scope.pallete);
                scope.editing = false;
                scope.onEditEnd()
            };

            // Select a color from the palette
            scope.selectColor = function (color, key) {
                scope.tempPallete[key] = color;
            };

            // Show color editing (stubbed for future expansion)
            scope.showColor = function (key) {
            };
        }
    };
});

app.directive('fontsize', function ($rootScope) {
    return {
        restrict: 'E',
        scope: {
            settings: '=',
            change: '='
        },
        link: function ($scope) {
            $scope.gettext = gettext
            $scope.formatRemToPX = $rootScope.formatRemToPX
        },
        template: `
            <div class="alert alert-info">
                {{gettext('label.font_size_info')}}
            </div>
            <div class="row">
                <div class="fs-3">
                    {{gettext('label.title_font_header')}}
                </div>
                <div class="col-md-6 col-xs-12">
                    <div class="input-group mb-3">
                        <!-- Range for font size-->
                        <label class="form-label w-100">
                            {{gettext('label.text_max_size')}}
                            <span style="float:right;font-weight: bold;">
                                [[formatRemToPX(settings.titleSize)]]
                            </span>
                            <tooltip-icon tooltip="{{gettext('label.text_max_size_tooltip')}}"></tooltip-icon>
                        </label>
                        <input ng-change="change('titleSize')" type="range" ng-model-options="{ debounce: 100 }" class="form-range" min="0" max="4" step="0.1" ng-model="settings.titleSize">
                    </div>
                </div>
                <div class="col-md-6 col-xs-12">
                    <div class="input-group mb-3">
                        <!-- Range for font size-->
                        <label class="form-label w-100">
                            {{gettext('label.text_min_size')}}
                            <span style="float:right;font-weight: bold;">
                                [[formatRemToPX(settings.titleMinSize)]]
                            </span>
                            <tooltip-icon tooltip="{{gettext('label.text_min_size_tooltip')}}"></tooltip-icon>
                        </label>
                        <input ng-change="change('titleMinSize')" type="range" ng-model-options="{ debounce: 100 }" class="form-range" min="0" max="4" step="0.1" ng-model="settings.titleMinSize">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="fs-3">
                    {{gettext('label.description_font_header')}}
                </div>
                <div class="col-md-6 col-xs-12">
                    <div class="input-group mb-3">
                        <!-- Range for font size-->
                        <label class="form-label w-100">
                            {{gettext('label.text_max_size')}}
                            <span style="float:right;font-weight: bold;">
                                [[formatRemToPX(settings.descriptionSize)]]
                            </span>
                            <tooltip-icon tooltip="{{gettext('label.text_max_size_tooltip')}}"></tooltip-icon>
                        </label>
                        <input ng-change="change('descriptionSize')" type="range" ng-model-options="{ debounce: 100 }" class="form-range" min="0" max="2" step="0.1" ng-model="settings.descriptionSize">
                    </div>
                </div>
                <div class="col-md-6 col-xs-12">
                    <div class="input-group mb-3">
                        <!-- Range for font size-->
                        <label class="form-label w-100">
                            {{gettext('label.text_min_size')}}
                            <span style="float:right;font-weight: bold;">
                                [[formatRemToPX(settings.descriptionMinSize)]]
                            </span>
                            <tooltip-icon tooltip="{{gettext('label.text_min_size_tooltip')}}"></tooltip-icon>
                        </label>
                        <input ng-change="change('descriptionMinSize')" type="range" ng-model-options="{ debounce: 100 }" class="form-range" min="0" max="2" step="0.1" ng-model="settings.descriptionMinSize">
                        <p>
                        </p>
                    </div>
                </div>
            </div>
            `
    };
})

app.directive('colorpicker', function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            pallete: '=',
            colors: '=',
            palletes: '=',
            change: '&',
        },
        template: `
            <div class="row mb-5">
                <div class="col-sm-12">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <button class="nav-link" type="button" ng-class="{active: state.tab == 'theme'}" ng-click="state.tab = 'theme'">{{gettext('label.colors_theme')}}</button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" type="button" ng-class="{active: state.tab == 'custom'}" ng-click="state.tab = 'custom'">{{gettext('label.colors_custom')}}</button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" type="button" ng-class="{active: state.tab == 'picker'}" ng-click="state.tab = 'picker'">{{gettext('label.colors_picker')}}</button>
                        </li>
                    </ul>
                    <div class="picker-wrapper">
                        <div ng-if="state.tab == 'theme'">
                            <div style="display: flex; flex-wrap: wrap; justify-content: center;">
                                <div ng-repeat="pallete in basePalletes" ng-style="{'background-color': pallete.main, 'color': pallete.text}" class="color-selection" ng-click="changePallete(pallete)">
                                Abc
                                </div>
                            </div>
                            <div ng-show="selectedPallete" style="display: flex; flex-wrap: wrap; justify-content: center;border-top: 1px solid #ddd">
                                <div ng-click="selectedPallete=null" class="color-selection">
                                    <i style="font-size:20px" class="mdi mdi-close"></i>
                                </div>
                                <div ng-repeat="pallete in selectedPallete.palletes" ng-style="{'background-color': pallete.main, 'color': pallete.text}" class="color-selection" ng-click="changePallete(pallete)">
                                    Abc
                                </div>
                            </div>
                        </div>
                        <div ng-if="state.tab == 'picker'">

                            <div>
                                <label for="logoUserInput" class="file-input-button btn btn-outline-primary">
                                    <i class="mdi mdi-cloud-upload" style="font-size: 16px"></i>
                                    [[gettext('button.upload_file_detect_color')]]
                                </label>
                                <input class="logoUserInput" type="file" accept="image/*" id="logoUserInput" style="display: none;">
                            </div>

                            <img id="logoUserImagePreview" class="logoUserImagePreview mt-2">
                        </div>
                        <!-- Main -->
                        <div class="row">
                            <label class="col-12 col-md-3 col-form-label v-align">{{gettext('label.main_color')}}</label>
                            <div class="col-12 col-md-9 v-align">
                                <input id="main-input-color" type="color" ng-model="pallete.main" ng-model-options="{ debounce: 100 }"  ng-change="change()">
                                <a href="javascript:void(0)" ng-click="showColor('main')" class="picker-show-color-btn">
                                    [[gettext('label.click_to_edit_color')]]
                                </a>
                                <a ng-if="state.tab != 'picker' && !listColorsAvailable" href="javascript:void(0)" ng-click="showListColors()" class="picker-show-color-btn ms-2">
                                    [[gettext('label.click_to_select_color')]]
                                </a>
                                <div ng-if="state.tab != 'picker' && listColorsAvailable" class="ms-1 v-align d-flex flex-wrap">
                                    <div ng-repeat="color in colors track by $index"
                                        ng-click="selectColor(color.value, 'main')"
                                        style="background-color: {{color.value}};"
                                        class="picker-item-color">
                                    </div>
                                </div>
                            </div>
                            <div class="picker-colors-wrapper" ng-if="state.tab == 'picker'">
                                <div ng-repeat="color in detectedColors track by $index"
                                    ng-click="selectColor(color, 'main')"
                                    style="background-color: {{color}};"
                                    class="picker-item-color">
                                </div>
                            </div>
                        </div>
                        <!-- Text -->
                        <div class="row">
                            <label class="col-12 col-md-3 col-form-label v-align">{{gettext('label.text_color')}}</label>
                            <div class="col-12 col-md-9 v-align">
                                <input id="text-input-color" type="color" ng-model="pallete.text" ng-model-options="{ debounce: 100 }"  ng-change="change()">
                                <a href="javascript:void(0)" ng-click="showColor('text')" class="picker-show-color-btn">
                                    [[gettext('label.click_to_edit_color')]]
                                </a>
                                <a ng-if="state.tab != 'picker' && !listColorsAvailable" href="javascript:void(0)" ng-click="showListColors()" class="picker-show-color-btn ms-2">
                                    [[gettext('label.click_to_select_color')]]
                                </a>
                                <div ng-if="state.tab != 'picker' && listColorsAvailable" class="ms-1 v-align d-flex flex-wrap">
                                    <div ng-repeat="color in colors track by $index"
                                        ng-click="selectColor(color.value, 'text')"
                                        style="background-color: {{color.value}};"
                                        class="picker-item-color">
                                    </div>
                                </div>
                            </div>
                            <div class="picker-colors-wrapper" ng-if="state.tab == 'picker'">
                                <div ng-repeat="color in detectedColors track by $index"
                                    ng-click="selectColor(color, 'text')"
                                    style="background-color: {{color}};"
                                    class="picker-item-color">
                                </div>
                            </div>
                        </div>
                        <!-- Accent -->
                        <div class="row">
                            <label class="col-12 col-md-3 col-form-label v-align">{{gettext('label.accent_color')}}</label>
                            <div class="col-12 col-md-9 v-align">
                                <input id="highlight-input-color" type="color" ng-model="pallete.highlight" ng-model-options="{ debounce: 100 }"  ng-change="change()">
                                <a href="javascript:void(0)" ng-click="showColor('highlight')" class="picker-show-color-btn">
                                    [[gettext('label.click_to_edit_color')]]
                                </a>
                                <a ng-if="state.tab != 'picker' && !listColorsAvailable" href="javascript:void(0)" ng-click="showListColors()" class="picker-show-color-btn ms-2">
                                    [[gettext('label.click_to_select_color')]]
                                </a>
                                <div ng-if="state.tab != 'picker' && listColorsAvailable" class="ms-1 v-align d-flex flex-wrap">
                                    <div ng-repeat="color in colors track by $index"
                                        ng-click="selectColor(color.value, 'highlight')"
                                        style="background-color: {{color.value}};"
                                        class="picker-item-color">
                                    </div>
                                </div>
                            </div>
                            <div class="picker-colors-wrapper" ng-if="state.tab == 'picker'">
                                <div ng-repeat="color in detectedColors track by $index"
                                    ng-click="selectColor(color, 'highlight')"
                                    style="background-color: {{color}};"
                                    class="picker-item-color">
                                </div>
                            </div>
                        </div>
                        <!-- My colors -->
                        <div class="row">
                            <label class="col-12 col-md-4 col-form-label">
                                {{gettext('label.my_colors')}}
                            </label>
                            <div class="col-12 col md-9 v-align d-flex flex-wrap" ng-if="editingColors">
                                <div ng-repeat="color in tempColors track by $index" class="me-3" style="position: relative">
                                    <i class="mdi mdi-close-circle" style="position: absolute; top: -10px; right: -10px; cursor: pointer;" ng-click="tempColors.splice($index, 1)"></i>
                                    <input type="color" ng-model="color.value">
                                </div>
                                <a href="javascript:void(0)" ng-click="addNewColor()" class="me-3">
                                    <i class="mdi mdi-plus"></i> {{gettext('label.generic_add')}}
                                </a>
                                <a href="javascript:void(0)" ng-click="saveEditColors()" class="me-3">
                                    <i class="mdi mdi-content-save"></i> {{gettext('label.generic_save')}}
                                </a>
                                <a href="javascript:void(0)" ng-click="cancelEditColors()" class="me-3">
                                    <i class="mdi mdi-close"></i> {{gettext('label.generic_cancel')}}
                                </a>
                            </div>
                            <div class="col-12 col md-9 v-align" ng-if="!editingColors">
                                <div ng-repeat="color in colors track by $index"
                                    ng-click="editColors()"
                                    style="background-color: {{color.value}};"
                                    class="picker-item-color">
                                </div>
                                <a href="javascript:void(0)" ng-click="editColors()">
                                    <i class="mdi mdi-pencil"></i>
                                    {{gettext('label.generic_edit')}}
                                </a>
                            </div>
                        </div>
                        <!-- My palletes -->
                        <div class="row">
                            <label class="col-12 col-md-4 col-form-label">
                                {{gettext('label.my_palletes')}}
                            </label>
                            <div class="col-12 col">
                                <div ng-repeat="pallete in palletes">
                                    <colorpickeritem
                                        ng-if="currentEditingIndex == $index || currentEditingIndex == null"
                                        pallete="pallete"
                                        colors="colors"
                                        change="change()"
                                        apply="apply($index)"
                                        remove="remove($index)"
                                        cancel-add="cancelAdd($index)"
                                        on-edit="onStartEditing($index)"
                                        on-edit-end="onEndEditing($index)"
                                        editing="pallete.editing">
                                    </colorpickeritem>
                                </div>
                            </div>
                            <a href="javascript:void(0)" ng-click="addNewPallete()" ng-if="currentEditingIndex == null" class="mt-2">
                                <i class="mdi mdi-plus"></i>
                                {{gettext('label.add_new_pallete')}}
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        `,
        link: function ($scope, $element) {
            $scope.gettext = gettext
            $scope.basePalletes = buildPalletes()
            $scope.editingColors = false
            $scope.listColorsAvailable = false
            $scope.currentEditingIndex = null
            $scope.tempColors = []

            $scope.detectedColors = []

            let intervalCheck = setInterval(function () {
                if (!$element.find('.logoUserInput')[0]) {
                    return
                }
                clearInterval(intervalCheck)
                $scope.init()
            }, 100)


            $scope.showListColors = function () {
                $scope.listColorsAvailable = true
            }

            $scope.editColors = function () {
                $scope.tempColors = JSON.parse(JSON.stringify($scope.colors))
                $scope.editingColors = true
            }

            $scope.cancelEditColors = function () {
                $scope.editingColors = false
            }

            $scope.saveEditColors = function () {
                let uniqueColors = []
                $scope.tempColors.forEach(color => {
                    if (!uniqueColors.find(c => c.value == color.value)) {
                        uniqueColors.push(color)
                    }
                })
                $scope.colors = JSON.parse(JSON.stringify(uniqueColors))
                $scope.editingColors = false
                $scope.change()
            }

            $scope.addNewColor = function () {
                $scope.tempColors.push({
                    value: '#000000'
                })
            }

            $scope.showColor = function (type) {
                $element.find('#' + type + '-input-color').click()
            }

            $scope.init = function () {
                const imageInput = $element.find('.logoUserInput')[0];
                const previewImage = $element.find('.logoUserImagePreview')[0];

                imageInput.addEventListener('change', (event) => {
                    const file = event.target.files[0];
                    const reader = new FileReader();

                    reader.onload = () => {
                        const base64String = reader.result;
                        previewImage.src = base64String;

                        $timeout(function () {
                            $scope.detectColors()
                        })
                    };
                    reader.readAsDataURL(file);
                });

            }
            $scope.state = {
                tab: 'theme',
                view: {
                    customConfig: false,
                    showColors: false,
                }
            }

            $scope.showColors = function () {
                $scope.state.view.customConfig = false
                $scope.state.view.showColors = true
                track('Editor Colors Show')
            }

            $scope.hideColors = function () {
                $scope.state.view.showColors = false
                track('Editor Colors Hide')
            }

            function improveDetectedColors(colors) {
                colors.push('#000000')
                colors.push('#ffffff')
                colors = [...new Set(colors)]
                return colors
            }

            $scope.detectColors = function () {
                const colorThief = new ColorThief();
                const img = document.querySelector('img.logoUserImagePreview');

                if (img.complete) {
                    $timeout(function () {
                        $scope.detectedColors = improveDetectedColors(colorThief.getPalette(img).map(color => RGBToHEX(...color)))
                    })
                } else {
                    image.addEventListener('load', function () {
                        $timeout(function () {
                            $scope.detectedColors = improveDetectedColors(colorThief.getPalette(img).map(color => RGBToHEX(...color)))
                        })
                    });
                }
            }

            $scope.selectColor = function (color, type) {
                $scope.pallete[type] = color
                $scope.change()
            }

            $scope.changePallete = function (pallete) {
                pallete = JSON.parse(JSON.stringify(pallete))
                if (pallete.palletes) {
                    $scope.selectedPallete = pallete
                }
                for (let key of ['main', 'text', 'highlight']) {
                    $scope.pallete[key] = pallete[key]
                }

                $scope.change()
                track('Editor Pallete Click', {
                    color: pallete.name
                })
            }

            $scope.addNewPallete = function () {
                $scope.palletes.push({
                    main: $scope.pallete.main,
                    text: $scope.pallete.text,
                    highlight: $scope.pallete.highlight,
                })

                // Mark last as editing
                $scope.palletes[$scope.palletes.length - 1].editing = true
                $scope.palletes[$scope.palletes.length - 1].isNew = true
                $scope.onStartEditing($scope.palletes.length - 1)
            }

            $scope.apply = function (index) {
                const pallete = $scope.palletes[index]
                $scope.pallete.main = pallete.main
                $scope.pallete.text = pallete.text
                $scope.pallete.highlight = pallete.highlight
                $scope.change()
            }

            $scope.remove = function (index, params) {
                showConfirm(gettext('label.are_you_sure'), null, function (status) {
                    if (status) {
                        $scope.palletes.splice(index, 1)
                        $scope.change()
                    }
                })
            }
            $scope.cancelAdd = function (index) {
                $scope.palletes.splice(index, 1)
                $scope.change()
            }

            $scope.onStartEditing = function (index) {
                $scope.currentEditingIndex = index
            }

            $scope.onEndEditing = function (index) {
                $scope.currentEditingIndex = null

                $scope.updateColorsFromPalletes()
            }

            $scope.updateColorsFromPalletes = function () {
                let currentColors = $scope.colors

                for (let pallete of $scope.palletes) {
                    for (let key of ['main', 'text', 'highlight']) {
                        if (!currentColors.find(color => color.value == pallete[key])) {
                            currentColors.push({
                                value: pallete[key]
                            })
                        }
                    }
                }
                $scope.change()
            }

        }
    }
})

app.directive('ngScroll', function () {
    return {
        restrict: 'A',
        scope: {
            ngScroll: '&',
            ngScrollOffset: '@'
        },
        link: function (scope, element) {
            element.bind('scroll', function () {
                var scrollHeight = element[0].scrollHeight;
                var scrollTop = element[0].scrollTop;
                var clientHeight = element[0].clientHeight;
                var offset = parseInt(scope.ngScrollOffset) || 0;

                if (scrollHeight - scrollTop - offset <= clientHeight) {
                    scope.$apply(scope.ngScroll);
                }
            });
        }
    };
});

app.directive('galilaiCanvas', function () {
    return {
        restrict: 'E',
        scope: {
            editItem: '=',
            edit: '=',
            content: '=',
            extraInfo: '=',
            action: '=',
            visuals: '=',
            histories: '=',
            fonts: '=',
            theme: '=',
            canEdit: '=',
        },
        controller: function ($scope, $element, $attrs, $sce, $rootScope, $timeout, fontsService) {
            $scope.isCalendar = $rootScope.isCalendar;
            $scope.isEditor = $rootScope.isEditor;

            $scope.searchFontVisible = false

            $scope.actions = []

            $scope.hideAction = function ($index, $event) {
                $event.stopPropagation()
                $event.preventDefault()
                $scope.visuals[$index].currentAction = null
            }

            $scope.showAction = function ($index, kind, $event) {
                $event.stopPropagation()
                $event.preventDefault()
                $scope.visuals[$index].currentAction = kind
            }

            $scope.getFontName = function (font) {
                return fontsService.getFontName(font)
            }

            $rootScope.$on('closeAction', function (event, data) {
                if (!data || typeof data.id == 'undefined') {
                    return
                }
                $scope.visuals[parseInt(data.id)].currentAction = null
            })

            $rootScope.$on('showAction', function (event, data) {
                if (!data || typeof data.id == 'undefined' || typeof data.kind == 'undefined') {
                    return
                }
                $scope.visuals[parseInt(data.id)].currentAction = data.kind
            })

            $scope.getCurrentAction = function ($index) {
                return $scope.visuals[$index] && $scope.visuals[$index].currentAction
            }

            $scope.isText = function ($index) {
                let textTypes = ['p-', 'h1-']
                if (!$scope.visuals[$index] || !$scope.visuals[$index].getSelected() || !$scope.visuals[$index].getSelected().elementId) {
                    return
                }
                return textTypes.some(type => $scope.visuals[$index].getSelected().elementId.startsWith(type))
            }

            $scope.isRect = function ($index) {
                if (!$scope.visuals[$index] || !$scope.visuals[$index].getSelected() || !$scope.visuals[$index].getSelected().elementId) {
                    return
                }
                return $scope.visuals[$index].getSelected().elementId.startsWith('rect-')
            }

            $scope.isElement = function ($index) {
                if (!$scope.visuals[$index] || !$scope.visuals[$index].getSelected() || !$scope.visuals[$index].getSelected().elementId) {
                    return
                }
                return !$scope.isText($index) && !$scope.isRect($index) && !$scope.isImage($index)
            }

            $scope.isImage = function ($index) {
                if (!$scope.visuals[$index] || !$scope.visuals[$index].getSelected() || !$scope.visuals[$index].getSelected().elementId) {
                    return
                }
                return $scope.visuals[$index].getSelected().elementId.startsWith('image-')
            }

            $scope.isVideo = function ($index) {
                if (!$scope.visuals[$index] || !$scope.visuals[$index].getSelected() || !$scope.visuals[$index].getSelected().elementId) {
                    return
                }
                return $scope.visuals[$index].getSelected().kind == 'video'
            }

            $scope.hasOverlayImage = function ($index) {
                return $scope.isImage($index)
            }

            $scope.showCustomFont = function ($event) {
                $event.stopPropagation()
                $event.preventDefault()

                $scope.searchFontVisible = true
                $timeout(function () {
                    let parent = $event.target.parentElement
                    let input = parent.querySelector('autocomplete input')
                    if (input) {
                        input.focus()
                    }
                }, 100)
            }
        },
        templateUrl: "canvas.html",
    };
});

app.directive('onEnter', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.bind('keydown', function (event) {
                if (event.keyCode === 13) {  // 13 is the Enter key code
                    scope.$apply(function () {
                        scope.$eval(attrs.onEnter);
                    });
                }
            });
        }
    };
});

app.directive('deferredModelUpdate', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            var isEditing = false;
            var originalValue;

            // When the input gains focus, stop updating the model
            element.on('focus', function () {
                isEditing = true;
                originalValue = ngModelCtrl.$viewValue;
            });

            // Prevent updating the model while the user is typing
            element.on('input', function (event) {
                if (isEditing) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    ngModelCtrl.$setViewValue(originalValue);
                }
            });

            // When the user presses Enter update the model
            element.on('blur keypress', function (event) {
                if (event.type === 'keypress' && event.which === 13) {
                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(element.val());
                        ngModelCtrl.$render();
                        originalValue = element.val()
                    });

                    if (attrs.ngChange) {
                        scope.$eval(attrs.ngChange);
                    }
                } else if (event.type === 'blur') {
                    // On blur, update the model with original value
                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(originalValue);
                        ngModelCtrl.$render();
                    })
                }
            });

            ngModelCtrl.$render = function () {
                element.val(ngModelCtrl.$viewValue);
            };
        }
    };
});

app.directive('fileInput', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('change', function (event) {
                var file = event.target.files[0];
                if (file) {
                    var uploadImageFn = $parse(attrs.fileInput);
                    scope.$apply(function () {
                        uploadImageFn(scope, { $file: file });
                    });

                    // Reset the input value to allow re-uploading the same file
                    event.target.value = null;
                }
            });
        }
    };
}])

app.directive('filesInput', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('change', function (event) {
                var files = event.target.files;
                if (files.length) {
                    var uploadImageFn = $parse(attrs.filesInput);
                    scope.$apply(function () {
                        uploadImageFn(scope, { $files: files });
                    });

                    // Reset the input value to allow re-uploading the same files
                    event.target.value = null;
                }
            });
        }
    };
}]);

app.directive('container', function () {
    return {
        restrict: 'E',
        scope: {
            config: '=',
            index: '=',
        },
        controller: function ($scope, $element, $attrs, $sce) {
        },
        templateUrl: "container.html",
    };
});

app.run(function ($rootScope, $http, experiments, api, $timeout, $interval) {

    console.log('Running app')
    $rootScope.isLoggedIn = isLoggedIn()
    $rootScope.IAPEnabled = function () {
        if ($rootScope.userConfig && $rootScope.userConfig.billing && $rootScope.userConfig.billing.source && $rootScope.userConfig.billing.source != 'iap') {
            return false
        }
        return IS_APP && IS_IOS
    }

    $rootScope.getIAPSubscription = async function (userId) {
        $rootScope.externalCheckout = IS_APP && !$rootScope.IAPEnabled()
        if (!$rootScope.IAPEnabled()) {
            return
        }
        try {
            let response = await sendMessageWithCallback({
                name: 'getActivePlan',
                userId: userId,
            })
            if (response && response.result && response.result.active && response.result.id) {
                if (!$rootScope.userConfig) {
                    $rootScope.userConfig = {}
                }
                if (!$rootScope.userConfig.billing) {
                    $rootScope.userConfig.billing = {}
                }
                $rootScope.userConfig.billing.plan = response.result
                $rootScope.userConfig.billing.customer = true
                delete $rootScope.userConfig.billing.expired
            }
            $timeout(angular.noop)
        } catch (e) {
            console.log('Error getting IAP subscription', e)
        }
    }

    $rootScope.appURL = window.BASE_URL
    function generateCheckoutHash() {
        $rootScope.userTempID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
        $rootScope.checkoutURL = $rootScope.appURL + '/api/checkout/' + $rootScope.userTempID
    }

    generateCheckoutHash()

    function showUpdateMessage(preventClose) {
        let message = preventClose ? gettext('label.app_update_available_required') : gettext('label.app_update_available')
        showSuccess(message)

        setTimeout(function () {
            if (preventClose) {
                let element = document.querySelector('#successModal')
                element.querySelector('button').remove()

                let modal = angular.element(element)
                modal.css('pointer-events', 'none')
            }
        }, 100)
    }

    async function doIAP(data) {
        if (!data || !data.user || !data.user._id) {
            showError(gettext('error.generic'))
            return
        }
        let loading = showLoading()
        try {
            let userId = data.user._id
            let response = await sendMessageWithCallback({
                name: 'makePurchase',
                userId: userId,
            })
            if (response && response.result && response.result.error) {
                if (response.result.error == 'another_user') {
                    showError(gettext('error.iap_other_account'))
                } else if (response.error == 'purchase_cancelled') {
                    // Do nothing
                } else {
                    showError(gettext('error.generic'))
                }
            } else {
                if (response && response.result && response.result.active) {
                    showSuccess(gettext('success.generic'))
                    setTimeout(function () {
                        reloadLocation(true)
                    }, 1000)
                } else {
                    showError(gettext('error.generic'))
                }
            }

            $rootScope.getIAPSubscription(userId)
        } catch (e) {
            showError(gettext('error.generic'))
        } finally {
            loading()
        }
    }

    if (!IS_APP) {
        $rootScope.isBootstraped = true
        $rootScope.startWithLogin = false
    } else {
        $rootScope.startWithLogin = false

        function startApp(withLogin, source) {
            console.log('Starting app', source, withLogin)
            $rootScope.isBootstraped = true
            // Always start without login now
            $rootScope.startWithLogin = false

            $timeout(angular.noop)
        }

        function compareBuildVersions(v1, v2) {
            if (typeof v1 == 'undefined' || typeof v2 == 'undefined' || v1 == null || v2 == null) {
                return '='
            }
            try {
                // Consider if is ios or android
                let os = window.navigator.userAgent.toLowerCase()
                if (os.indexOf('android') > -1) {
                    let build1 = parseInt(v1)
                    let build2 = parseInt(v2)
                    if (build1 > build2) {
                        return '>'
                    } else if (build1 < build2) {
                        return '<'
                    }
                    return '='
                }
                // iOS needs to compare the build number
                let v1Parts = v1.split('.')
                let v2Parts = v2.split('.')

                for (let i = 0; i < v1Parts.length; i++) {
                    if (parseInt(v1Parts[i]) > parseInt(v2Parts[i])) {
                        return '>'
                    }
                    if (parseInt(v1Parts[i]) < parseInt(v2Parts[i])) {
                        return '<'
                    }
                }
            } catch (e) {
                console.log('Error comparing versions', e)
            }
            return '='
        }

        function showUpdateApp(version) {
            let alreadyShown = localStorage.getItem('showed_update.' + version)
            const preventContinueUsing = alreadyShown
            if (preventContinueUsing) {
                showUpdateMessage(true)
                return
            }
            if (!alreadyShown) {
                localStorage.setItem('showed_update.' + version, 'true')
            }
            showUpdateMessage(false)
        }

        function checkVersion(info) {
            if (!info || !info.build) {
                startApp(false, 'no_build')
                return
            }
            api.getGlobalConfig('mobile_app_version').then(res => {
                let currentOS = window.navigator.userAgent.toLowerCase().indexOf('android') > -1 ? 'android' : 'ios'
                if (!res.data.value || typeof res.data.value[currentOS] == 'undefined') {
                    startApp(false, 'no_server_version')
                    return
                }
                let publishedVersion = res.data.value[currentOS].toString()
                let compare = compareBuildVersions(info.build, publishedVersion)
                console.log('Comparing versions', info.build, publishedVersion, compare)
                if (compare == '>') {
                    startApp(true, 'new_version')
                } else {
                    startApp(false, 'same_version')

                    if (compare == '<') {
                        showUpdateApp(publishedVersion)
                    }
                }
            })
                .catch(e => {
                    console.log('Error getting version', e)
                    $timeout(function () {
                        $rootScope.errorCheckApp = true
                    })
                    startApp(false, 'error')
                })
        }
        window.addEventListener('message', function (event) {
            console.log('Received message', event.data)
            if (event.data.name === 'onBootstrap') {
                console.log('Bootstrap event', event.data)
                if (!event.data || !event.data.data || !event.data.data.info) {
                    startApp(false, 'no_info')
                    return
                }
                checkVersion(event.data.data.info)
            }
        });
        if (window.APP_BOOTSTRAPED) {
            console.log('App already bootstrapped')
            checkVersion(window.APP_INFO)
        }
    }

    checkAuth()
    experiments.setupExperiments()
    let interval = setInterval(() => {
        let loading = document.getElementById('before-app-loading')
        if (!loading) {
            return
        }
        loading.remove();
        clearInterval(interval)
    }, 100)
    $rootScope.isApp = IS_APP
    $rootScope.externalCheckout = IS_APP && !$rootScope.IAPEnabled()
    $rootScope.baseEditor = window.location.origin + window.location.pathname
    $rootScope.f = {
        calendar: false,
    }

    $rootScope.setFeatures = function (features) {
        if (!features) {
            return
        }
        for (let key in features) {
            $rootScope.f[key] = features[key]
        }
    }

    $rootScope.hasFeature = function (feature) {
        if (feature == 'allow_auto_font_size') {
            return false
        }
        if (!$rootScope.f) {
            return false
        }
        return $rootScope.f[feature]
    }

    $rootScope.formatRemToPX = function (rem) {
        let base = 16
        try {
            let result = rem * base
            if (!isValidNumber(result)) {
                return '-'
            }
            return result.toFixed(1) + 'px'
        } catch (e) {
            return '-'
        }
        return '-'
    }

    let intervalCheckout = null
    $rootScope.startCheckout = function (data, params) {

        try {
            // Track google conversions
            track('Editor Begin Checkout', params)
        } catch (e) {
            console.log('Error tracking checkout', e)
        }
        try {
            if (typeof microsoftReportBeginCheckout === 'function') {
                microsoftReportBeginCheckout()
            }
        } catch (e) {
            console.log(e)
        }
        console.log('Starting checkout', data, params, $rootScope.IAPEnabled())
        if (intervalCheckout) {
            clearInterval(intervalCheckout)
        }
        if ($rootScope.IAPEnabled()) {
            doIAP(data)
            return
        }
        if (!IS_APP) {
            changeURL(data.url)
            return
        }
        if (!data.jobId) {
            // TODO - this is an error
            return
        }
        generateCheckoutHash()
        intervalCheckout = setInterval(() => {
            api.getJob(data.jobId).then(res => {
                if (res.data && res.data.status != 'pending') {
                    clearInterval(intervalCheckout)
                    if (res.data && res.data.status == 'success' && res.data.data && res.data.data.token) {
                        localStorage.setItem('auth.token', res.data.data.token)
                        reloadLocation()
                        clearInterval(intervalCheckout)
                    } else {
                        clearInterval(intervalCheckout)
                        showError(gettext('error.generic'), null, function () {
                            reloadLocation()
                        })
                    }
                }
            }).catch(e => {
                clearInterval(intervalCheckout)
                showError(gettext('error.generic'), null, function () {
                    reloadLocation()
                })
            })
        }, 2000)
    }

    function monitorDigest() {
        // Initialize variables
        var digestTimestamps = [];
        var threshold = 50; // Set your threshold here (X digests per second)
        var windowSize = 1000; // Window size in milliseconds

        // Function to check the digest rate and print an alert if it exceeds the threshold
        function checkDigestRate() {
            var now = Date.now();
            // Remove timestamps older than the rolling window
            digestTimestamps = digestTimestamps.filter(function (timestamp) {
                return (now - timestamp) <= windowSize;
            });

            // Print a warning if the rate exceeds the threshold
            if (digestTimestamps.length > threshold) {
                console.error('High digest rate detected: ' + digestTimestamps.length + ' digest cycles in the last second');
            }
            if (digestTimestamps.length > threshold * 2) {
                alert('High digest rate detected: ' + digestTimestamps.length + ' digest cycles in the last second');
            }
        }

        // Watch for digest cycles
        $rootScope.$watch(function () {
            digestTimestamps.push(Date.now());
        });

        // Set up an interval to check the digest rate periodically
        $interval(checkDigestRate, windowSize / 2);
    }

    if (_env_ && _env_ == 'DEV') {
        monitorDigest()
    }
})

function checkAuth() {
    try {
        let info = new URLSearchParams(window.location.search).get('info')
        let otp = new URLSearchParams(window.location.search).get('otp')
        let mobile = new URLSearchParams(window.location.search).get('mobile')
        if (!info) {
            return
        }
        // Decode base64
        try {
            info = base64Decode(info)
        } catch (e) {
            console.log('Error decoding info', e)
            return
        }
        // Info is url encoded, parse it
        info = new URLSearchParams(info)
        // Get user info
        let instagram = info.get('instagram')
        let token = info.get('token')
        let email = info.get('email')
        if (instagram) {
            localStorage.setItem('auth.user.instagram', instagram)
        }
        if (email) {
            localStorage.setItem('auth.user.email', email)
        }
        if (token) {
            localStorage.setItem('auth.token', token)
        }
        if (otp) {
            fetch(window.BASE_URL + '/api/auth/otp/verify', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    code: otp,
                    mobile: mobile,
                })
            }).then(res => res.json())
                .then(res => {
                    if (res.status == 'verified') {
                        if (mobile) {
                            showSuccess(gettext('label.otp_verified_mobile'))
                        } else {
                            showSuccess(gettext('label.otp_verified'))
                        }
                    }
                })
                .catch(e => {
                    console.log('Error verifying otp', e)
                })
        }
    } catch (e) {
        console.log('Error checking auth', e)
    }
}
function gettext(message, ...args) {
    let translated = _MESSAGES[language][message]
    if (args && args.length) {
        args.forEach((arg, index) => {
            translated = translated.replace('%s', arg)
        })
    }
    return translated
}

function uuid(
    a
) {
    return a           // if the placeholder was passed, return
        ? (              // a random number from 0 to 15
            a ^            // unless b is 8,
            Math.random()  // in which case
            * 16           // a random number from
            >> a / 4         // 8 to 11
        ).toString(16) // in hexadecimal
        : (              // or otherwise a concatenated string:
            [1e7] +        // 10000000 +
            -1e3 +         // -1000 +
            -4e3 +         // -4000 +
            -8e3 +         // -80000000 +
            -1e11          // -100000000000,
        ).replace(     // replacing
            /[018]/g,    // zeroes, ones, and eights with
            uuid            // random hex digits
        )
}

if (!localStorage.getItem('galilai.uuid')) {
    localStorage.setItem('galilai.uuid', uuid())
}

const _MESSAGES = {
    "pt": {
        "instagram.handle.error": "Não foi possível encontrar o perfil do Instagram",
        "error.generating.content": "Não foi possível gerar o conteúdo",
        "error.saving.post": "Não foi possível salvar o post",
        "success.saving.post": "Post salvo com sucesso!",
        "error.validation.context": "Por favor, preencha todos os campos",
        "error.validation.email": "Por favor, preencha um email válido",
        "error.imageLoading": "Espere um pouquinho, estamos carregando a imagem do post",
        "instagram.handle.at_removed": "Não precisa do @, só o nome do perfil",
        "info.config.show": "Clique na imagem do post para editar cores, fontes e outros detalhes",
        "error.invalid.image": "Erro ao fazer upload da imagem",
        "success.trial_started": "Seja bem-vindo ao período de testes do Editor Mágico 🥳!",
        "error.starting_trial": "Não foi possível iniciar o período de testes",
        "category.all": "Todos",
        "category.images": "Imagens",
        "category.cover": "Capa",
        "category.slide": "Carrossel",
        "category.news": "Notícia",
        "category.social": "Social",
        "category.quote": "Citação",
        "category.question": "Pergunta",
        "category.list": "Lista",
        "category.number": "Lista",
        "category.checklist": "Checklist",
        "category.before-after": "Antes e Depois",
        "category.trivia": "Trivia",
        "error.invalid.image_must_be_png": "A imagem deve ser PNG com fundo transparente",
        "error.project.create": "Não foi possível criar o projeto",
        "error.creating_scratch": "Não foi possível criar o post",
        "source.Save Post": "Salvar um Post",
        "source.Preview Post": "Visualizar um Post",
        "source.Download Post": "Baixar um Post",
        "source.Refresh Keywords": "Atualizar as palavras-chaves",
        "source.Upload Logo": "Atualizar Logo",
        "source.Upload Social Logo": "Atualizar Imagem de Perfil",
        "source.Publish Item": "Publicar um Post",
        "source.Edit Item": "Editar um Post",
        "source.Save Item": "Salvar um Post",
        "source.Captions Item": "Gerar Legendas",
        "source.Generated once but not logged in": "Gerar mais Posts",
        "source.Generated once but not customer": "Gerar mais Posts",
        "source.Generate Audience": "Identificar o Público-Alvo",
        "source.Generate Audience Needs": "Identificar as Necessidades do Público-Alvo",
        "source.Generate Audience Goals": "Identificar os Objetivos do Público-Alvo",
        "source.Generate Captions": "Gerar Legendas",
        "source.Create Scratch": "Criar um Post do Zero",
        "source.Custom Fonts": "Usar Fontes Personalizadas",
        "source.Use my medias": "Usar minhas imagens",
        "source.Edit Themes": "Editar Temas",
        "source.Bulk Edit": "Editar Posts em Massa",
        "source.Save Replan": "Salvar Planejamento dos Posts",
        "source.Remove Schedule": "Remover Agendamento",
        "source.Pin Post": "Favoritar Post",
        "source.Finish Theme Selection": "Finalizar Seleção de Temas",
        "source.Regenerate Post": "Gerar Novo Post",
        "source.Change Calendar Range": "Alterar Período do Calendário",
        "source.Remove Post": "Remover Post",
        "source.Edit Post": "Editar Post",
        "source.Skip Day": "Pular Dia",
        "source.Publish Reels": "Criar e Publicar Reels",
        "source.Add more products": "Adicionar mais produtos",
        "source.Save Post Calendar": "Salvar Post no Calendário",
        "source.Select Audio": "Selecionar Música",
        "source.Select Video": "Selecionar Vídeo",
        "plan.filter.monthly": "Mensal",
        "plan.filter.annual": "Anual",
        "source.Max projects reached": "Adicionar mais contas",
        "source.Publish Post Directly": "Publicar Posts diretamente no Instagram",
        "source.Schedule Posts": "Agendar Posts",
        "features.infinite_ideas": "Ideias ilimitadas de posts",
        "features.custom_style": "Personalização de posts",
        "features.integrated_publishing": "Publicação Automática",
        "features.unlimited_accounts": "Contas ilimitadas",
        "features.1_account": "1 conta social",
        "features.accounts": "empresas",
        "features.reels": "Reels e Animações de posts",
        "features.audio": "Músicas nos posts",
        "features.custom_videos": "Biblioteca de Vídeos",
        "features.unlimited_posts": "Posts ilimitados",
        "label.plans_trial_days": "14 dias de teste grátis",
        "label.plans_cancel_anytime": "Cancele a qualquer momento",
        "error.upgrade_plan": "Erro ao atualizar o plano, tente novamente",
        "error.not_possible_find_instagram_account": "Não encontrou sua conta do Instagram?",
        "label.to_connect_you_need": "Para conectar é necessário:",
        "label.no_instagram_enabled": "Essa página não tem o Instagram associado",
        "error.please_select_page": "Por favor, selecione uma página",
        "error.please_select_target": "Selecione onde você quer publicar",
        "error.please_select_format": "Selecionar o formato do post",
        "error.scheduling_post": "Não foi possível agendar o post, tente novamente",
        "error.authenticating_facebook": "Não foi possível autenticar com o Facebook, tente novamente",
        "success.scheduling_post": "Post agendado para publicação com sucesso!",
        "success.scheduling_post_limit": "Post agendado com sucesso! Apesar de não termos limites de agendamentos, agendar muitos posts no mesmo dia no Instagram/Facebook pode causar restrições no seu Perfil. Recomendamos agendar até no máximo 3 posts por dia.",
        "scratch.post1.title": "Título do seu post sobre o <b>assunto</b> que você quiser",
        "scratch.post1.description": "Escreva na próxima linha para virar a descrição",
        "scratch.post2.title": "Deixe espaço em uma nova linha para começar uma imagem nova",
        "scratch.post3.title": "Marque em <b>negrito partes relevantes</b> para destacar",
        "scratch.post4.title": "<b>1.</b> Marque em negrito números no começo para montar uma lista",
        "scratch.post5.title": "<b>2.</b> Clique em qualquer imagem para editar imagens, layout, fontes e cores",
        "error_publish.too_many_items": "O Instagram permite no máximo 10 posts por carousel. Remova alguns conteúdos para continuar.",
        "error_publish.no_content": "Você precisa adicionar conteúdo ao post para continuar.",
        "error_publish.caption_too_long": "A legenda do post não pode ter mais de 2000 caracteres.",
        "error_publish.too_many_hashtags": "Você pode adicionar no máximo 30 hashtags por post.",
        "error_publish.no_caption": "Você precisa adicionar uma legenda no post",
        "error_publish.already_scheduled": "Esse post já foi publicado nessa página",
        "instagram.handle.too_long": "O nome do perfil do Instagram é muito longo. Tem certeza que está correto?",
        "success.canceling_publish": "Post cancelado com sucesso!",
        "error.canceling_publish": "Não foi possível cancelar o post, tente novamente",
        "label.how_to_connect_instagram": "Clique aqui para aprender como conectar sua conta do Instagram ao Galilai",
        "plan.upgraded": "Plano atualizado com sucesso!",
        "tags.all": "mostrar todos",
        "tags.base": "sem fundo",
        "tags.blob": "bolha",
        "tags.lines": "linhas",
        "tags.waves": "ondas",
        "tags.swipe": "swipe",
        "tags.circles": "círculos",
        "tags.points": "pontos",
        "tags.corner": "cantos",
        "elements.h1": "Título",
        "elements.p": "Descrição",
        "elements.image": "Imagem",
        "elements.overlay": "Elemento",
        "elements.span": "Texto",
        "elements.rect": "Retângulo",
        "elements.circle": "Círculo",
        "elements.trapezoid": "Trapézio",
        "elements.svg": "Gráfico",
        "icons.suggested.arrow": "seta",
        "icons.suggested.heart": "coração",
        "icons.suggested.bubble": "bolha",
        "icons.suggested.shopping": "shopping",
        "icons.suggested.phone": "ligação",
        "icons.suggested.local": "local",
        "icons.suggested.star": "estrela",
        "error.publish_reels_not_supported": "Reels não são suportados ainda, em breve vamos lançar!",
        "error.you_need_to_reconnect_for_facebook_permissions": "Você precisa reconectar sua conta do Facebook para obter as permissões para publicar",
        "label.already_caption_filled": "Já existe uma legenda criada, você quer sobrescrevê-la?",
        "label.type_search": "Digite para buscar",
        "label.colors_theme": "Temas",
        "label.colors_custom": "Personalizado",
        "label.colors_picker": "Identificar pelo meu logo",
        "label.main_color": "Cor principal",
        "label.text_color": "Cor do texto",
        "label.accent_color": "Cor de destaque",
        "label.project": "Projeto",
        "button.upload_file_detect_color": "Envie uma imagem para identificar as cores",
        "label.click_to_edit_color": "Editar cor",
        "label.click_to_select_color": "Selecionar cor",
        "error.please_add_caption": "É necessário adicionar uma legenda no post",
        "label.month_long_1": "Janeiro",
        "label.month_long_2": "Fevereiro",
        "label.month_long_3": "Março",
        "label.month_long_4": "Abril",
        "label.month_long_5": "Maio",
        "label.month_long_6": "Junho",
        "label.month_long_7": "Julho",
        "label.month_long_8": "Agosto",
        "label.month_long_9": "Setembro",
        "label.month_long_10": "Outubro",
        "label.month_long_11": "Novembro",
        "label.month_long_12": "Dezembro",
        "label.month_short_1": "Jan",
        "label.month_short_2": "Fev",
        "label.month_short_3": "Mar",
        "label.month_short_4": "Abr",
        "label.month_short_5": "Mai",
        "label.month_short_6": "Jun",
        "label.month_short_7": "Jul",
        "label.month_short_8": "Ago",
        "label.month_short_9": "Set",
        "label.month_short_10": "Out",
        "label.month_short_11": "Nov",
        "label.month_short_12": "Dez",
        "error.empty_post_text_caption": "Seu post está vazio, adicione um texto para poder gerar uma legenda",
        "label.publish_status_pending": "Pendente Edição",
        "label.publish_status_initial": "Agendado",
        "label.publish_status_published": "Publicado",
        "label.publish_status_error": "Erro ao publicar",
        "error.calendar_full": "O calendário está cheio, vá para o próximo mês para agendar mais posts ou mude suas configuracões de planejamento de posts.",
        "label.calendar_other_themes": "outros temas",
        "label.calendar_other_theme": "outro tema",
        "label.calendar_replan_success": "Posts atualizados com sucesso",
        "error.calendar_replan_error": "Erro ao atualizar posts",
        "error.calendar_no_posts": "Nenhum post para editar, clique em Gerar para criar posts.",
        "error.calendar_no_topics": "Selecione ao menos um assunto para gerar posts",
        "error.generate_empty_profile": "Seu perfil está vazio, descreva um pouco sobre o seu negócio",
        "error.not_logged_in": "Você não está logado, faça login para continuar",
        "error.loading.post": "Erro ao carregar post, por favor tente novamente",
        "error.calendar_drop_past": "Você não pode arrastar posts para datas passadas",
        "error.calendar_topic_exists": "Esse assunto já foi adicionado",
        "label.today": "Hoje",
        "label.help_modal": "Central de Ajuda",
        "error_publish.media_error": "Aconteceu um erro ao enviar suas imagens. Por favor, tente novamente.",
        "error_publish.invalid_images": "Aconteceu um erro ao enviar suas imagens. Por favor, tente novamente.",
        "error_publish.invalid_page": "A página selecionada não é válida. Por acaso você modificou a conexão com o Facebook? Por exemplo: se você fez login com uma nova conta do Facebook, as páginas conectadas anteriormente não estarão mais disponíveis.",
        "error_publish.carousel_error": "Aconteceu um erro ao publicar o carrossel. Por favor, tente novamente.",
        "error_publish.invalid_caption": "A legenda é muito longa ou tem mais de 40 hashtags. Por favor, edite a legenda e tente novamente.",
        "error_publish.invalid_instagram_account": "Conta do Instagram inválida ou não é Empresarial. Por acaso você modificou a conexão com o Facebook? Por exemplo: se você fez login com uma nova conta do Facebook, as páginas conectadas anteriormente não estarão mais disponíveis.",
        "error_publish.instagram_business_error": "A conta do Instagram não é uma conta Empresarial. Por favor, converta sua conta para uma conta Empresarial e tente novamente. Dê uma olhada no checklist de conectar as páginas para mais informações.",
        "error_publish.user_restricted": "Sua conta do Instagram ou Facebook pode estar restrita. Acesse <a target='_blank' href='https://www.facebook.com/business-support-home/?landing_page=overview'>esse link</a> para verificar as restrições e como desbloquear sua conta. Se aparecer alguma conta em vermelho, clique para resolver o problema. Em geral é necessário enviar algum documento para validação.",
        "error_publish.rate_limit": "Apesar de não termos um limite de postagens, o Instagram/Facebook possui um limite. Continuar postando muitos posts por dia pode resultar em um bloqueio da sua conta. Sugerimos você parar de postar por hoje e tentar novamente amanhã e com um volume menor de posts, até que a restrição seja removida.",
        "error_publish.publish_error": "Aconteceu um erro ao publicar. Por favor, tente novamente.",
        "error_publish.publish_error_story": "Aconteceu um erro ao publicar a story. Por favor, tente novamente.",
        "error_publish.publish_error_carousel": "Aconteceu um erro ao publicar o carrossel. Por favor, tente novamente.",
        "error_publish.reauth_required": "Você precisa conectar sua conta do Facebook novamente. Por favor, clique em 'Conectar Minhas Páginas' e siga as instruções.",
        "error.generic": "Ops, algo deu errado. Por favor, tente novamente.",
        "error.calendar_topic_length": "O assunto deve ter entre 3 e 150 caracteres",
        "label.post_type_carousel": "Carrossel",
        "label.post_type_single": "Post Único",
        "label.import_tabs_image": "Imagens",
        "label.import_tabs_text": "Textos",
        "label.import_tabs_background": "Formas",
        "label.import_tabs_colors": "Cores",
        "label.import_tabs_fonts": "Fontes",
        "label.import_option_title": "Título",
        "label.import_option_description": "Descrição",
        "label.import_option_fixed_text": "Texto Fixo",
        "label.import_option_main_image": "Imagem Principal",
        "label.import_option_fixed_image": "Imagem Fixa",
        "label.import_option_email": "Email",
        "label.import_option_address": "Endereço",
        "label.import_option_phone": "Telefone",
        "label.import_option_website": "Website",
        "label.import_option_person_image": "Imagem de Perfil",
        "label.import_option_list_item": "Item de Lista",
        "label.import_option_list_cta": "Botão",
        "label.import_option_main_color": "Cor Principal",
        "label.import_option_text_color": "Cor do Texto",
        "label.import_option_highlight_color": "Cor de Destaque",
        "label.import_option_font_title": "Fonte do Título",
        "label.import_option_font_body": "Fonte do Corpo",
        "label.import_option_font_subtitle": "Fonte do Subtítulo",
        "label.import_hide": "Ocultar",
        "label.import_main_color": "Cor Principal",
        "label.import_number": "Número",
        "label.import_author_handle": "Perfil do Usuário",
        "label.remove_project_confirm": "Tem certeza que deseja remover o projeto? Todos os posts dessa conta serão removidos.",
        "error.remove_project_last": "Você não pode remover seu único projeto",
        "label.import_layout_success": "Layout importado com sucesso",
        "label.import_option_contextual_fixed_image": "Imagem Fixa Contextual",
        "label.success_generic": "Sucesso!",
        "success.generic": "Sucesso!",
        "label.are_you_sure": "Você tem certeza?",
        "label.professional_area": "Trabalho na área de",
        "label.profile_handle": "@meuperfil",
        "label.profile_name": "Meu Nome",
        "area_business.medicine": "Medicina",
        "area_business.psychology": "Psicologia",
        "area_business.law": "Direito",
        "area_business.wellness": "Saúde & Bem-estar",
        "area_business.education": "Educação",
        "area_business.personal_care": "Cuidados Pessoais",
        "area_business.cosmetics": "Cosméticos",
        "area_business.fitness": "Fitness",
        "area_business.finance": "Finanças",
        "area_business.accounting": "Contabilidade",
        "area_business.construction": "Construção",
        "area_business.real_estate": "Imóveis",
        "area_business.architecture": "Arquitetura",
        "area_business.tech": "Tecnologia",
        "area_business.pets": "Pets",
        "area_business.coaching": "Coaching",
        "area_business.clothing": "Moda",
        "area_business.restaurant": "Restaurante",
        "area_business.automotive": "Automotivo",
        "area_business.transport": "Transporte",
        "label.media_select_image": "Selecione uma imagem",
        "label.media_select_audio": "Selecione um áudio",
        "label.media_select_video": "Selecione um vídeo",
        "label.media_select_elements": "Selecione um elemento",
        "label.media_select_fonts": "Selecione uma fonte",
        "label.media_select_product": "Selecione um produto ou serviço",
        "tab.media_icons_database": "Ícones",
        "tab.media_images_database": "Banco de imagens",
        "tab.media_audio_database": "Banco de Músicas",
        "tab.media_video_database": "Banco de Vídeos",
        "tab.media_my_images": "Minhas imagens",
        "tab.media_my_fonts": "Minhas fontes",
        "tab.media_my_audio": "Minhas Músicas",
        "tab.media_my_video": "Meus Vídeos",
        "tab.media_my_products": "Meus Produtos e Serviços",
        "btn.remove_bg": "Remover Fundo",
        "btn.remove": "Remover",
        "btn.select": "Selecionar",
        "label.folder_home": "Todos",
        "tag.audio_all": "Todas",
        "tag.audio_upbeat": "Animada",
        "tag.audio_happy": "Feliz",
        "tag.audio_inspiring": "Inspiradora",
        "tag.audio_chill": "Relaxante",
        "label.need_to_increase_quantity": "você precisa aumentar a quantidade de empresas no seu plano",
        "label.multiple_pages": "Múltiplas páginas",
        "label.one_page": "Uma página",
        "error.rendering_post": "Erro ao baixar o post. Por favor, tente novamente",
        "label.otp_verified_mobile": "Seu login foi realizado com sucesso! Retorne ao aplicativo para continuar.",
        "label.otp_verified": "Seu login foi realizado com sucesso!",
        "success.connected_facebook_app": "Você conectou suas contas sociais com sucesso! Retorne ao aplicativo para continuar.",
        "label.app_update_available": "Uma nova versão do aplicativo está disponível. Atualize para acessar as novas funcionalidades.",
        "label.app_update_available_required": "Uma nova versão do aplicativo está disponível. É necessário atualizar para continuar.",
        "tab.favorites": "Favoritos",
        "error.missing_project_favorite": "Vá na aba favoritos e escolha um projeto primeiro",
        "label.my_text": "Meu Texto",
        "label.remove_generic": "Tem certeza que deseja remover?",
        "label.confirm_reset_layout": "Você tem certeza que deseja remover as formatações? O layout irá voltar para o padrão.",
        "error.invalid.file_type": "Tipo de arquivo inválido",
        "success.copy_clipboard": "Copiado para a área de transferência!",
        "label.remove_all_posts_confirm": "Tem certeza que deseja remover todos os posts? Não será possível recuperá-los.",
        "label.post_should_be_tall": "O tipo de post que você escolheu deve usar um tamanho vertical, caso contrário eles ficarão cortados ao serem postados. Deseja mudar assim mesmo?",
        "label.my_palletes": "Minhas Paletas",
        "label.my_colors": "Minhas Cores",
        "label.generic_add": "Adicionar",
        "label.generic_edit": "Editar",
        "label.generic_save": "Salvar",
        "label.generic_remove": "Remover",
        "label.generic_cancel": "Cancelar",
        "label.add_new_pallete": "Adicionar nova Paleta",
        "label.apply_pallete": "Usar Paleta",
        "label.title_font_header": "Título",
        "label.description_font_header": "Descrição",
        "label.text_min_size": "Tamanho mínimo",
        "label.text_max_size": "Tamanho máximo",
        "label.font_size_info": "Os tamanhos de fonte são ajustados automaticamente para garantir a melhor legibilidade. Para personalizar, ajuste os valores mínimo e máximo. Para definir um tamanho específico, clique no texto e ajuste diretamente.",
        "label.text_min_size_tooltip": "Tamanho mínimo da fonte quando há muito texto e ela precisa ser reduzida para caber no espaço disponível.",
        "label.text_max_size_tooltip": "Tamanho padrão e máximo que a fonte pode ser ajustada.",
        "label.feature_contact_support": "Entre em contato com o suporte para ativar essa funcionalidade. Deseja iniciar uma conversa?",
        "label.iap_info_ios": "As assinaturas serão cobradas no seu cartão de crédito através da sua conta iTunes. As assinaturas serão renovadas automaticamente, a menos que sejam canceladas 24 horas antes do final do período atual. Você pode cancelar a qualquer momento nas configurações da sua conta iTunes.",
        "error.iap_other_account": "Você tem uma assinatura ativa com outro email. Por favor, faça login com o email correto.",
        "error.invalid.product": "Nome e imagens são obrigatórios.",
        "error.invalid.product.name": "Nome é obrigatório.",
        "error.invalid.product.price": "Preço é obrigatório.",
        "error.invalid.product.url": "Imagem é obrigatória.",
        "error.invalid.product.project": "É necessário selecionar um projeto para adicionar um produto.",
        "error.select_product": "Selecione ao menos um produto/serviço.",
        "error.select_media": "Selecione ao menos uma imagem.",
        "error.select_themes": "Selecione ao menos um tema.",
        "error.select_a_post": "Selecione ao menos um post.",
        "error.type_context": "Digite uma instrução para gerar posts.",
        "error.max_media_items": "Só é possível selecionar até 5 items.",
        "error.save_posts": "Erro ao salvar posts.",
        "label.mode_themes": "Escollher assuntos",
        "label.mode_themes_description": "Escolha os assuntos que deseja abordar",
        "label.mode_product": "Produto ou Serviço",
        "label.mode_product_description": "Escolha um produto ou serviço para falar",
        "label.mode_dates": "Datas comemorativas",
        "label.mode_dates_description": "Escolha uma data comemorativa",
        "label.mode_media": "Imagem",
        "label.mode_media_description": "Escolha uma ou mais imagens",
        "label.mode_instruction": "Escrever o que preciso",
        "label.mode_instruction_description": "Descreva o que você precisa",
        "label.mode_link": "Link",
        "label.mode_link_description": "Cole um link para gerar um post",
        "label.mode_empty": "Post em branco",
        "label.mode_empty_description": "Crie um post do zero",
        "label.mode_existing": "Post pronto",
        "label.mode_existing_description": "Só quero fazer um agendamento",
        "layout.smart_any": "Qualquer",
        "layout.smart_title_grid": "Grade",
        "layout.smart_vertical": "Vertical",
        "layout.smart_horizontal": "Horizontal",
        "layout.smart_title_style": "Estilo",
        "layout.smart_geometric": "Geométrico",
        "layout.smart_rounded": "Arredondado",
        "layout.smart_title_shader": "Aparência",
        "layout.smart_flat": "Simples",
        "layout.smart_gradient": "Gradiente",
        "layout.smart_pattern": "Padrão",
        "layout.smart_3d": "3D",
        "layout.smart_title_orientation": "Posição Imagem",
        "layout.smart_begin": "Início",
        "layout.smart_end": "Fim",
        "layout.smart_title_alignment": "Alinhamento",
        "layout.smart_left": "Esquerda",
        "layout.smart_center": "Centro",
        "layout.smart_right": "Direita",
        "layout.smart_title_focus": "Foco",
        "layout.smart_text": "Texto",
        "layout.smart_balanced": "Balanceado",
        "layout.smart_fullscreen": "Tela cheia",
        "layout.smart_title_decorative": "Decorativos",
        "layout.smart_yes": "Sim",
        "layout.smart_no": "Não",
        "layout.smart_title_include_shapes": "Formas",
        "error.generator_no_content": "Não foi possível encontrar conteúdo nesse link",
        "error.generator_no_link": "Por favor, insira um link",
        "gen.product.objective": "Objetivo",
        "gen.product.price": "Preço",
        "gen.product.info": "Informações",
        "gen.product.cta": "Chamada para Ação",
        "gen.product.discount": "Desconto",
        "tab.media_my_videos": "Meus Vídeos",
        "tab.media_videos_database": "Banco de Vídeos",
        "error.invalid.max_size": "O tamanho máximo dos arquivos deve ser %s.",
        "label.too_long_video": "Posts devem ter no máximo %s minutos de duração.",
        "label.affiliate_created": "Crie seu código de afiliado",
        "label.affiliate_message": "Digite apenas o código, ele irá ficar assim para compartilhar:",
        "label.affiliate_code_name": "SEUCODIGO",
        "error.affiliate.code_exists": "Código de afiliado em uso, por favor escolha outro",
        "generic.no": "Não",
        "generic.yes": "Sim",
        "generator.include_related": "Incluir assuntos relacionados?",
        "generator.tone": "Tom de voz",
        "generator.tone_normal": "Normal",
        "generator.tone_formal": "Formal",
        "generator.tone_fun": "Divertido",
        "generator.tone_informal": "Informal",
        "generator.tone_informative": "Informativo",
        "generator.tone_inspiring": "Inspirador",
        "generator.tone_polemic": "Polêmico",
        "generator.tone_curious": "Curiosidade",
        "generator.objective": "Objetivo",
        "generator.objective_authority": "Autoridade",
        "generator.objective_sales": "Vendas",
        "generator.objective_custom": "Personalizado",
        "generator.authority_list": "Lista",
        "generator.authority_opinion": "Opinião",
        "generator.authority_question": "Pergunta",
        "generator.authority_checklist": "Checklist",
        "generator.authority_news": "Notícia",
        "generator.authority_trivia": "Trivia",
        "generator.content_type": "Tipo de Conteúdo",
        "generator.authority_faq": "Dúvidas",
        "generator.authority_tips": "Dicas",
        "generator.authority_tutorial": "Tutoriais",
        "generator.authority_myths": "Mitos e Verdades",
        "generator.authority_errors": "Erros Comuns",
        "generator.authority_trends": "Novidades",
        "generator.sales_hooks": "Gatilhos de Venda",
        "generator.sales_benefits": "Benefícios",
        "generator.sales_features": "Características",
        "generator.sales_offers": "Ofertas",
        "generator.sales_cta": "Chamada para Ação",
        "generator.sales_social_proof": "Provas Sociais",
        "generator.tone_tooltip": "Tom de voz dos seus posts",
        "generator.objective_tooltip": "Posts de autoridade ajudam a mostrar seu conhecimento na área. Já posts de vendas são para promover um produto ou serviço",
        "generator.format_tooltip": "Formato de saída seu post",
        "generator.include_related_tooltip": "Inclua assuntos relacionados para dar mais variedade de conteúdos",
        "generator.include_profile": "Relacionado ao meu negócio",
        "generator.include_profile_tooltip": "Escolha se os posts gerados devem ser relacionados ao seu negócio ou se devem ser mais genéricos",
        "generator.size": "Tamanho do título",
        "generator.size_short": "Curto",
        "generator.size_medium": "Médio",
        "generator.size_long": "Longo",
        "error.media_in_use": "Essa imagem está sendo usada em um post e não pode ser removida",
        "success.cancel_account": "Conta cancelada com sucesso!",
        "error.fill_required_fields": "Preencha todos os campos obrigatórios",
        "generator.media_format": "Tipo de arquivo do post",
        "generator.media_format_image": "Imagem",
        "generator.media_format_video": "Vídeo",
        "generator.hasCaption": "Você tem uma legenda pronta?",
        "generator.post_format": "Formato",
        "generator.post_format_post": "Post",
        "generator.post_format_reels": "Reels",
        "generator.post_format_story": "Story",
        "error.format_post_not_support_media": "O formato de post escolhido não suporta esse tipo de mídia",
        "error.limit_posts_per_format": "O formato de post escolhido não suporta tantos arquivos",
        "label.content_already_generated": "Seu post já tem conteúdo gerado, deseja sobrescrever as páginas do carrossel? A primeira página será mantida.",
        "error.post_duration_exceeded": "A duração do post excedeu o limite máximo de %s segundos."
    },
    "en": {
        "instagram.handle.error": "Could not find Instagram profile",
        "error.generating.content": "Could not generate content",
        "error.saving.post": "Could not save post",
        "success.saving.post": "Post saved successfully",
        "error.validation.context": "Please, fill all the fields",
        "error.validation.email": "Please, fill a valid email",
        "error.imageLoading": "Wait a bit, we are loading the post image",
        "instagram.handle.at_removed": "No need for @, just the profile name",
        "info.config.show": "Click on the post image to edit colors, fonts and other details",
        "error.invalid.image": "Error uploading image",
        "success.trial_started": "Welcome to the Magic Editor trial 🥳",
        "error.starting_trial": "Could not start trial",
        "category.all": "All",
        "category.images": "Images",
        "category.cover": "Cover",
        "category.slide": "Slide",
        "category.news": "News",
        "category.social": "Social",
        "category.quote": "Quote",
        "category.question": "Question",
        "category.list": "List",
        "category.number": "List",
        "category.checklist": "Checklist",
        "category.before-after": "Before and After",
        "category.trivia": "Trivia",
        "error.invalid.image_must_be_png": "Image must be PNG with transparent background",
        "error.project.create": "Could not create project",
        "source.Save Post": "Save Post",
        "source.Preview Post": "Preview Post",
        "source.Download Post": "Download Post",
        "source.Refresh Keywords": "Refresh Keywords",
        "source.Upload Logo": "Upload Logo",
        "source.Upload Social Logo": "Upload Profile Image",
        "source.Publish Item": "Publish Item",
        "source.Edit Item": "Edit Item",
        "source.Save Item": "Save Item",
        "source.Captions Item": "Generate Captions",
        "source.Generated once but not logged in": "Generate More Posts",
        "source.Generated once but not customer": "Generate More Posts",
        "source.Max projects reached": "Add more projects",
        "source.Publish Post Directly": "Publish Post directly to Instagram",
        "source.Schedule Posts": "Schedule Posts to Instagram",
        "source.Generate Audience": "Generate Audience",
        "source.Generate Audience Needs": "Generate Audience Needs",
        "source.Generate Audience Goals": "Generate Audience Goals",
        "source.Generate Captions": "Generate Captions",
        "source.Create Scratch": "Create post from scratch",
        "source.Custom Fonts": "Upload Custom Fonts",
        "source.Use my medias": "Use my images",
        "source.Edit Themes": "Edit Themes",
        "source.Bulk Edit": "Bulk Edit Posts",
        "source.Save Replan": "Save Posts Planning",
        "source.Remove Schedule": "Remove Schedule",
        "source.Pin Post": "Favoritar Post",
        "source.Finish Theme Selection": "Finish Topics Selection",
        "source.Regenerate Post": "Regenerate Post",
        "source.Change Calendar Range": "Change Calendar Range",
        "source.Remove Post": "Remove Post",
        "source.Edit Post": "Edit Post",
        "source.Skip Day": "Skip Day",
        "source.Publish Reels": "Create and Publish Reels",
        "source.Add more products": "Add more products",
        "source.Save Post Calendar": "Save Post",
        "source.Select Audio": "Select Music",
        "source.Select Video": "Select Video",
        "plan.filter.monthly": "Monthly",
        "plan.filter.annual": "Annual",
        "features.infinite_ideas": "Unlimited posts ideas",
        "features.custom_style": "Posts customization",
        "features.integrated_publishing": "Automatic Publishing",
        "features.unlimited_accounts": "Unlimited accounts",
        "features.1_account": "1 social account",
        "features.accounts": "companies",
        "features.reels": "Reels & posts animations",
        "features.audio": "Music in posts",
        "features.custom_videos": "Video Library",
        "features.unlimited_posts": "Unlimited posts",
        "label.plans_trial_days": "14 days free trial",
        "label.plans_cancel_anytime": "Cancel anytime",
        "error.upgrade_plan": "Error upgrading plan, try again",
        "error.not_possible_find_instagram_account": "Did not find your Instagram account?",
        "label.to_connect_you_need": "To connect:",
        "label.no_instagram_enabled": "This page does not have Instagram associated",
        "error.please_select_page": "Please select a page",
        "error.please_select_target": "Select where you want to publish",
        "error.please_select_format": "Select the post format",
        "error.scheduling_post": "Could not schedule post, try again",
        "error.creating_scratch": "Error creating post",
        "error.authenticating_facebook": "Could not authenticate with Facebook, try again",
        "success.scheduling_post": "Post scheduled successfully!",
        "success.scheduling_post_limit": "Post scheduled successfully! Although we do not have scheduling limits, scheduling many posts on the same day on Instagram/Facebook can cause restrictions on your profile. We recommend scheduling up to a maximum of 3 posts per day.",
        "scratch.post1.title": "Title of your post about <b>any subject</b> you want",
        "scratch.post1.description": "Write on the next line to become the description",
        "scratch.post2.title": "Leave space on a new line to start a new image",
        "scratch.post3.title": "Mark in <b>bold relevant parts</b> to highlight",
        "scratch.post4.title": "<b>1.</b> Mark in bold numbers at the beginning to create a list",
        "scratch.post5.title": "<b>2.</b> Click on any image to edit images, layout, fonts and colors",
        "error_publish.too_many_items": "Instagram allows a maximum of 10 posts per carousel. Remove some content to continue.",
        "error_publish.no_content": "You need to add content to the post to continue.",
        "error_publish.caption_too_long": "The post caption cannot be more than 2000 characters.",
        "error_publish.too_many_hashtags": "You can add a maximum of 30 hashtags per post.",
        "error_publish.no_caption": "You need to add a caption to the post",
        "error_publish.already_scheduled": "This post has already been published on this page",
        "instagram.handle.too_long": "Instagram handle is too long. Are you sure it is correct?",
        "success.canceling_publish": "Post canceled successfully!",
        "error.canceling_publish": "Could not cancel post, try again",
        "label.how_to_connect_instagram": "Click here to learn how to connect your Instagram account to Galilai",
        "plan.upgraded": "Plan upgraded successfully!",
        "tags.all": "show all",
        "tags.base": "no background",
        "tags.blob": "blob",
        "tags.lines": "lines",
        "tags.waves": "waves",
        "tags.swipe": "swipe",
        "tags.circles": "circles",
        "tags.points": "points",
        "tags.corner": "corner",
        "elements.h1": "Title",
        "elements.p": "Description",
        "elements.image": "Image",
        "elements.overlay": "Element",
        "elements.span": "Text",
        "elements.rect": "Rectangle",
        "elements.circle": "Circle",
        "elements.trapezoid": "Trapezoid",
        "elements.svg": "Graphic",
        "icons.suggested.arrow": "arrow",
        "icons.suggested.heart": "heart",
        "icons.suggested.bubble": "bubble",
        "icons.suggested.shopping": "shopping",
        "icons.suggested.phone": "phone",
        "icons.suggested.local": "local",
        "icons.suggested.star": "star",
        "error.publish_reels_not_supported": "Reels are not supported yet",
        "error.you_need_to_reconnect_for_facebook_permissions": "You need to reconnect your Facebook account to get the permissions to publish",
        "label.already_caption_filled": "There is a caption already created, do you want to overwrite it?",
        "label.type_search": "Type to search",
        "label.colors_theme": "Themes",
        "label.colors_custom": "Custom",
        "label.colors_picker": "Pick from my logo",
        "label.main_color": "Main color",
        "label.text_color": "Text color",
        "label.accent_color": "Accent Color",
        "label.project": "Project",
        "button.upload_file_detect_color": "Send an image to identify the colors",
        "label.click_to_edit_color": "Edit color",
        "label.click_to_select_color": "Select color",
        "error.please_add_caption": "You need to add a caption to the post",
        "label.month_long_1": "January",
        "label.month_long_2": "February",
        "label.month_long_3": "March",
        "label.month_long_4": "April",
        "label.month_long_5": "May",
        "label.month_long_6": "June",
        "label.month_long_7": "July",
        "label.month_long_8": "August",
        "label.month_long_9": "September",
        "label.month_long_10": "October",
        "label.month_long_11": "November",
        "label.month_long_12": "December",
        "label.month_short_1": "Jan",
        "label.month_short_2": "Feb",
        "label.month_short_3": "Mar",
        "label.month_short_4": "Apr",
        "label.month_short_5": "May",
        "label.month_short_6": "Jun",
        "label.month_short_7": "Jul",
        "label.month_short_8": "Aug",
        "label.month_short_9": "Sep",
        "label.month_short_10": "Oct",
        "label.month_short_11": "Nov",
        "label.month_short_12": "Dec",
        "error.empty_post_text_caption": "Your post is empty, add a text to generate a caption",
        "label.publish_status_pending": "Pending edit",
        "label.publish_status_initial": "Scheduled",
        "label.publish_status_published": "Published",
        "label.publish_status_error": "Error publishing",
        "error.calendar_full": "The calendar is full, go to the next month to schedule more posts or change your post planning settings.",
        "label.calendar_other_themes": "other topics",
        "label.calendar_other_theme": "other topic",
        "label.calendar_replan_success": "Posts updated successfully",
        "error.calendar_replan_error": "Error updating posts",
        "error.calendar_no_posts": "No posts to edit, click Generate to create posts.",
        "error.calendar_no_topics": "Select at least one topic to generate posts",
        "error.generate_empty_profile": "Your profile is empty, describe a bit about what your business",
        "error.not_logged_in": "You are not logged in, log in to continue",
        "error.loading.post": "Error loading post, please try again",
        "error.calendar_drop_past": "You cannot drag posts to past dates",
        "error.calendar_topic_exists": "This topic already exists",
        "label.today": "Today",
        "label.help_modal": "Help Center",
        "error_publish.media_error": "An error occurred while uploading your images. Please try again.",
        "error_publish.invalid_images": "An error occurred while uploading your images. Please try again.",
        "error_publish.invalid_page": "The selected page is not valid. Did you modify the connection with Facebook? For example: if you logged in with a new Facebook account, the previously connected pages will no longer be available.",
        "error_publish.carousel_error": "An error occurred while publishing the carousel. Please try again.",
        "error_publish.invalid_caption": "The caption is too long or has more than 40 hashtags. Please edit the caption and try again.",
        "error_publish.invalid_instagram_account": "Invalid Instagram account or it is not Business type. Did you modify the connection with Facebook? For example: if you logged in with a new Facebook account, the previously connected pages will no longer be available.",
        "error_publish.instagram_business_error": "Instagram Account is not a Business Account. Please convert your account to a Business Account to continue.",
        "error_publish.user_restricted": "Your Instagram or Facebook account may be restricted. Access <a target='_blank' href='https://www.facebook.com/business-support-home/?landing_page=overview'>this link</a> to check the restrictions and how to unlock your account",
        "error_publish.rate_limit": "Although we do not have a limit on posts, Instagram/Facebook have a limit. Continuing to post many posts per day can result in a block of your account. We suggest you stop posting for today and try again tomorrow and with a lower volume of posts, until the restriction is removed.",
        "error_publish.publish_error": "An error occurred while publishing. Please try again.",
        "error_publish.publish_error_story": "An error occurred while publishing the story. Please try again.",
        "error_publish.publish_error_carousel": "An error occurred while publishing the carousel. Please try again.",
        "error_publish.reauth_required": "You need to reconnect your Facebook account. Please click on 'Connect My Pages' and follow the instructions.",
        "error.generic": "Unexpected error. Please try again",
        "error.calendar_topic_length": "The topic must have between 3 and 150 characters",
        "label.post_type_carousel": "Carousel",
        "label.post_type_single": "Single Post",
        "label.import_tabs_image": "Images",
        "label.import_tabs_text": "Texts",
        "label.import_tabs_background": "Shapes",
        "label.import_tabs_colors": "Colors",
        "label.import_tabs_fonts": "Fonts",
        "label.import_option_title": "Title",
        "label.import_option_description": "Description",
        "label.import_option_fixed_text": "Fixed Text",
        "label.import_option_main_image": "Main Image",
        "label.import_option_fixed_image": "Fixed Image",
        "label.import_option_email": "Email",
        "label.import_option_address": "Address",
        "label.import_option_phone": "Phone",
        "label.import_option_website": "Website",
        "label.import_option_person_image": "Person Image",
        "label.import_option_list_item": "List Item",
        "label.import_option_list_cta": "Call to Action",
        "label.import_option_main_color": "Main Color",
        "label.import_option_text_color": "Text Color",
        "label.import_option_highlight_color": "Highlight Color",
        "label.import_option_font_title": "Title Font",
        "label.import_option_font_body": "Body Font",
        "label.import_option_font_subtitle": "Subtitle Font",
        "label.import_hide": "Hide",
        "label.import_main_color": "Main Color",
        "label.import_number": "Number",
        "label.import_author_handle": "Handle",
        "label.remove_project_confirm": "Are you sure you want to remove the project? All posts from this project will be removed.",
        "error.remove_project_last": "You cannot remove your only project",
        "label.import_layout_success": "Layout imported successfully",
        "label.import_option_contextual_fixed_image": "Fixed Image (Contextual)",
        "label.success_generic": "Success!",
        "success.generic": "Success!",
        "label.are_you_sure": "Are you sure?",
        "label.professional_area": "I work in the area of",
        "label.profile_handle": "@myprofile",
        "label.profile_name": "My Name",
        "area_business.medicine": "Medicine",
        "area_business.psychology": "Psychology",
        "area_business.law": "Law",
        "area_business.wellness": "Health & Wellbeing",
        "area_business.education": "Education",
        "area_business.personal_care": "Personal Care",
        "area_business.cosmetics": "Cosmetics",
        "area_business.fitness": "Fitness",
        "area_business.finance": "Finance",
        "area_business.accounting": "Accounting",
        "area_business.construction": "Construction",
        "area_business.real_estate": "Real Estate",
        "area_business.architecture": "Architecture",
        "area_business.tech": "Technology",
        "area_business.pets": "Pets",
        "area_business.coaching": "Coaching",
        "area_business.clothing": "Fashion",
        "area_business.restaurant": "Restaurant",
        "area_business.automotive": "Automotive",
        "area_business.transport": "Transport",
        "label.media_select_image": "Select an image",
        "label.media_select_audio": "Select an audio",
        "label.media_select_video": "Select a video",
        "label.media_select_elements": "Select an element",
        "label.media_select_fonts": "Select a font",
        "label.media_select_product": "Select a product or service",
        "tab.media_icons_database": "Icons",
        "tab.media_images_database": "Image Database",
        "tab.media_audio_database": "Music Database",
        "tab.media_video_database": "Video Database",
        "tab.media_my_fonts": "My Fonts",
        "tab.media_my_images": "My Images",
        "tab.media_my_audio": "My Music",
        "tab.media_my_video": "My Videos",
        "tab.media_my_products": "My Products and Services",
        "btn.remove_bg": "Remove Background",
        "btn.remove": "Remove",
        "btn.select": "Select",
        "label.folder_home": "All",
        "tag.audio_all": "All",
        "tag.audio_upbeat": "Upbeat",
        "tag.audio_happy": "Happy",
        "tag.audio_inspiring": "Inspiring",
        "tag.audio_chill": "Chill",
        "label.need_to_increase_quantity": "you need to increase the number of companies in your plan",
        "label.multiple_pages": "Multiple pages",
        "label.one_page": "One page",
        "error.rendering_post": "Error downloading post. Please try again",
        "label.otp_verified_mobile": "Your login was successful! Return to the app to continue.",
        "label.otp_verified": "Your login was successful!",
        "success.connected_facebook_app": "You have successfully connected your social accounts! Please return to the mobile app to continue.",
        "label.app_update_available": "A new version of the app is available. Update to access new features.",
        "label.app_update_available_required": "A new version of the app is available. Update to continue using the app.",
        "tab.favorites": "Favorites",
        "error.missing_project_favorite": "Go to the favorites tab and choose a project first",
        "label.my_text": "My Text",
        "label.remove_generic": "Are you sure you want to remove?",
        "label.confirm_reset_layout": "Are you sure you want to remove the formatting? The layout will return to its default.",
        "error.invalid.file_type": "Invalid file type",
        "success.copy_clipboard": "Copied to clipboard!",
        "label.remove_all_posts_confirm": "Are you sure you want to remove all posts? You won't be able to recover them.",
        "label.post_should_be_tall": "The post type you chose should use a vertical size, otherwise it will be cropped when posted. Do you want to change anyway?",
        "label.my_palletes": "My Palettes",
        "label.my_colors": "My Colors",
        "label.generic_add": "Add",
        "label.generic_edit": "Edit",
        "label.generic_save": "Save",
        "label.generic_remove": "Remove",
        "label.generic_cancel": "Cancel",
        "label.add_new_pallete": "Add new Palette",
        "label.apply_pallete": "Use Palette",
        "label.title_font_header": "Title",
        "label.description_font_header": "Description",
        "label.text_min_size": "Minimum size",
        "label.text_max_size": "Maximum size",
        "label.font_size_info": "Font sizes are automatically adjusted to ensure the best readability. To customize, adjust the minimum and maximum values. To set a specific size, click on the text and adjust directly.",
        "label.text_min_size_tooltip": "Minimum font size when there is a lot of text and it needs to be reduced to fit the available space.",
        "label.text_max_size_tooltip": "Default and maximum size that the font can be adjusted.",
        "label.feature_contact_support": "Contact support to enable this feature. Do you want to start a chat?",
        "label.iap_info_ios": "Subscriptions will be charged to your credit card through your iTunes account. Subscriptions will automatically renew unless canceled within 24-hours before the end of the current period. You can cancel anytime with your iTunes account settings.",
        "error.iap_other_account": "You have an active subscription with another email. Please log in with the correct email.",
        "error.invalid.product": "Name and images are required.",
        "error.invalid.product.name": "Name is required.",
        "error.invalid.product.price": "Price is required.",
        "error.invalid.product.url": "Image is required.",
        "error.invalid.product.project": "You need to select a project to add a product.",
        "error.select_product": "Select at least one product/service.",
        "error.select_media": "Select at least one image.",
        "error.select_themes": "Select at least one topic.",
        "error.select_a_post": "Select at least one post.",
        "error.type_context": "Type an instruction to generate posts.",
        "error.max_media_items": "You can only select up to 5 items.",
        "error.save_posts": "Error saving posts.",
        "label.mode_themes": "Choose topics",
        "label.mode_themes_description": "Choose the topics you want to address",
        "label.mode_product": "Product or Service",
        "label.mode_product_description": "Choose a product or service to talk about",
        "label.mode_dates": "Commemorative Dates",
        "label.mode_dates_description": "Choose a commemorative date",
        "label.mode_media": "Image",
        "label.mode_media_description": "Choose one or more images",
        "label.mode_instruction": "Instruction",
        "label.mode_instruction_description": "Describe what you need",
        "label.mode_link": "Link",
        "label.mode_link_description": "Paste a link to generate a post",
        "label.mode_empty": "Blank Post",
        "label.mode_empty_description": "Create a post from scratch",
        "label.mode_existing": "Schedule Post",
        "label.mode_existing_description": "Schedule a image/video",
        "layout.smart_any": "Any",
        "layout.smart_title_grid": "Grid",
        "layout.smart_vertical": "Vertical",
        "layout.smart_horizontal": "Horizontal",
        "layout.smart_title_style": "Style",
        "layout.smart_geometric": "Geometric",
        "layout.smart_rounded": "Rounded",
        "layout.smart_title_shader": "Appearance",
        "layout.smart_flat": "Flat",
        "layout.smart_gradient": "Gradient",
        "layout.smart_pattern": "Pattern",
        "layout.smart_3d": "3D",
        "layout.smart_title_orientation": "Image Position",
        "layout.smart_begin": "Begin",
        "layout.smart_end": "End",
        "layout.smart_title_alignment": "Alignment",
        "layout.smart_left": "Left",
        "layout.smart_center": "Center",
        "layout.smart_right": "Right",
        "layout.smart_title_focus": "Focus",
        "layout.smart_text": "Text",
        "layout.smart_balanced": "Balanced",
        "layout.smart_fullscreen": "Fullscreen",
        "layout.smart_title_decorative": "Decoratives",
        "layout.smart_yes": "Yes",
        "layout.smart_no": "No",
        "layout.smart_title_include_shapes": "Shapes",
        "error.generator_no_content": "Could not find content in this link",
        "error.generator_no_link": "Please, insert a link",
        "gen.product.objective": "Objective",
        "gen.product.price": "Price",
        "gen.product.info": "Information",
        "gen.product.cta": "Call to Action",
        "gen.product.discount": "Discount",
        "tab.media_my_videos": "My Videos",
        "tab.media_videos_database": "Video Database",
        "error.invalid.max_size": "The maximum file size must be %s.",
        "label.too_long_video": "Posts must be at most %s minutes long.",
        "label.affiliate_created": "Create your affiliate code",
        "label.affiliate_message": "Enter only the code, it will look like this when sharing:",
        "label.affiliate_code_name": "YOURCODE",
        "error.affiliate.code_exists": "Affiliate code in use, please choose another",
        "generic.no": "No",
        "generic.yes": "Yes",
        "generator.include_related": "Include related topics?",
        "generator.tone": "Tone of voice",
        "generator.tone_normal": "Normal",
        "generator.tone_formal": "Formal",
        "generator.tone_fun": "Fun",
        "generator.tone_informal": "Informal",
        "generator.tone_informative": "Informative",
        "generator.tone_inspiring": "Inspiring",
        "generator.tone_polemic": "Polemic",
        "generator.tone_curious": "Curiosity",
        "generator.objective": "Objective",
        "generator.objective_authority": "Authority",
        "generator.objective_sales": "Sales",
        "generator.objective_custom": "Custom",
        "generator.authority_list": "List",
        "generator.authority_opinion": "Opinion",
        "generator.authority_question": "Question",
        "generator.authority_checklist": "Checklist",
        "generator.authority_news": "News",
        "generator.authority_trivia": "Trivia",
        "generator.content_type": "Content Type",
        "generator.authority_faq": "Questions and Answers",
        "generator.authority_tips": "Tips",
        "generator.authority_tutorial": "Tutorials",
        "generator.authority_myths": "Myths and Truths",
        "generator.authority_errors": "Common Errors",
        "generator.authority_trends": "Trends",
        "generator.sales_hooks": "Sales Hooks",
        "generator.sales_benefits": "Benefits",
        "generator.sales_features": "Features",
        "generator.sales_offers": "Offers",
        "generator.sales_cta": "Call to Action",
        "generator.sales_social_proof": "Social Proof",
        "generator.tone_tooltip": "Tone of voice of your posts",
        "generator.objective_tooltip": "Authority posts help to show your knowledge in the area. Sales posts are used to promote a product or service",
        "generator.format_tooltip": "Output format of your post",
        "generator.include_related_tooltip": "Include related topics to add content variety",
        "generator.size": "Title size",
        "generator.size_short": "Short",
        "generator.size_medium": "Medium",
        "generator.size_long": "Long",
        "generator.include_profile": "Related to my business",
        "generator.include_profile_tooltip": "Choose if the generated posts should be related to your business or more generic",
        "error.media_in_use": "This image is being used in a post and cannot be removed",
        "success.cancel_account": "Account successfully canceled!",
        "error.fill_required_fields": "Please fill in all required fields",
        "generator.media_format": "Post file type",
        "generator.media_format_image": "Image",
        "generator.media_format_video": "Video",
        "generator.hasCaption": "Do you have a caption created?",
        "generator.post_format": "Formato",
        "generator.post_format_post": "Post",
        "generator.post_format_reels": "Reels",
        "generator.post_format_story": "Story",
        "error.format_post_not_support_media": "The selected post format does not support this type of media",
        "error.limit_posts_per_format": "The selected post format does not support so many files",
        "label.content_already_generated": "Your post already has generated content, do you want to overwrite the carousel pages? The first page will be kept.",
        "error.post_duration_exceeded": "The post duration exceeded the maximum limit of %s seconds."
    },
    "es": {
        "instagram.handle.error": "No se puede encontrar el perfil de Instagram",
        "error.generating.content": "No se puede generar contenido",
        "error.saving.post": "No se puede guardar la publicación",
        "success.saving.post": "¡Publicación guardada exitosamente!",
        "error.validation.context": "Por favor rellena todos los campos",
        "error.validation.email": "Por favor complete un correo electrónico válido",
        "error.imageLoading": "Espera un minuto, estamos cargando la imagen de la publicación.",
        "instagram.handle.at_removed": "No necesitas la @, solo el nombre del perfil",
        "info.config.show": "Haga clic en la imagen de la publicación para editar colores, fuentes y otros detalles.",
        "error.invalid.image": "Error subiendo imagen",
        "success.trial_started": "¡Bienvenido al período de prueba de Magic Editor 🥳!",
        "error.starting_trial": "No se puede iniciar el período de prueba",
        "category.all": "Todo",
        "category.images": "Imágenes",
        "category.cover": "Capa",
        "category.slide": "Carrusel",
        "category.news": "Noticias",
        "category.social": "Social",
        "category.quote": "Cita",
        "category.question": "Pregunta",
        "category.list": "Lista",
        "category.number": "Lista",
        "category.checklist": "Lista de verificación",
        "category.before-after": "Antes y Después",
        "category.trivia": "Trivialidades",
        "error.invalid.image_must_be_png": "La imagen debe ser PNG con fondo transparente.",
        "error.project.create": "No se puede crear el proyecto",
        "error.creating_scratch": "No se puede crear la publicación",
        "source.Save Post": "Guardar una publicación",
        "source.Preview Post": "Ver una publicación",
        "source.Download Post": "Descargar una publicación",
        "source.Refresh Keywords": "Actualizar palabras clave",
        "source.Upload Logo": "Actualizar logotipo",
        "source.Upload Social Logo": "Actualizar imagen de perfil",
        "source.Publish Item": "Publicar una publicación",
        "source.Edit Item": "Editar una publicación",
        "source.Save Item": "Guardar una publicación",
        "source.Captions Item": "Generar subtítulos",
        "source.Generated once but not logged in": "Generar más publicaciones",
        "source.Generated once but not customer": "Generar más publicaciones",
        "source.Generate Audience": "Identificar el público objetivo",
        "source.Generate Audience Needs": "Identificar las necesidades del público objetivo",
        "source.Generate Audience Goals": "Identificar los objetivos del público objetivo",
        "source.Generate Captions": "Generar subtítulos",
        "source.Create Scratch": "Crear una publicación desde cero",
        "source.Custom Fonts": "Utilice fuentes personalizadas",
        "source.Use my medias": "Usa mis imágenes",
        "source.Edit Themes": "Editar Temas",
        "source.Bulk Edit": "Editar Posts me Massa",
        "source.Save Replan": "Guardar planificación posterior",
        "source.Remove Schedule": "Eliminar programa",
        "source.Pin Post": "Publicación favorita",
        "source.Finish Theme Selection": "Finalizar la selección del tema",
        "source.Regenerate Post": "Generar nueva publicación",
        "source.Change Calendar Range": "Cambiar período del calendario",
        "source.Remove Post": "Poste eliminador",
        "source.Edit Post": "Editar Post",
        "source.Skip Day": "Saltar día",
        "source.Publish Reels": "Crear y publicar carretes",
        "source.Add more products": "Añadir más productos",
        "source.Save Post Calendar": "Guardar publicación en el calendario",
        "source.Select Audio": "Seleccionar música",
        "source.Select Video": "Seleccionar vídeo",
        "plan.filter.monthly": "Mensual",
        "plan.filter.annual": "Anual",
        "source.Max projects reached": "Agregar más cuentas",
        "source.Publish Post Directly": "Publicar publicaciones directamente en Instagram",
        "source.Schedule Posts": "Programar publicaciones",
        "features.infinite_ideas": "Ideas de publicaciones ilimitadas",
        "features.custom_style": "Personalización de publicaciones",
        "features.integrated_publishing": "Publicación automática",
        "features.unlimited_accounts": "Cuentas ilimitadas",
        "features.1_account": "1 cuenta social",
        "features.accounts": "compañías",
        "features.reels": "Carretes y animaciones de publicaciones.",
        "features.audio": "Canciones en publicaciones",
        "features.custom_videos": "Videoteca",
        "features.unlimited_posts": "Posts ilimitados",
        "label.plans_trial_days": "Prueba gratuita de 14 días",
        "label.plans_cancel_anytime": "Cancelar en cualquier momento",
        "error.upgrade_plan": "Error al actualizar el plan, inténtalo de nuevo",
        "error.not_possible_find_instagram_account": "¿No encuentras tu cuenta de Instagram?",
        "label.to_connect_you_need": "Para conectarte necesitas:",
        "label.no_instagram_enabled": "Esta página no tiene Instagram asociado",
        "error.please_select_page": "Por favor seleccione una página",
        "error.please_select_target": "Selecciona dónde quieres publicar",
        "error.please_select_format": "Seleccionar formato de publicación",
        "error.scheduling_post": "No se puede programar la publicación. Inténtalo de nuevo.",
        "error.authenticating_facebook": "No se puede autenticar con Facebook, inténtelo de nuevo",
        "success.scheduling_post": "¡Publicación programada para publicación exitosa!",
        "success.scheduling_post_limit": "¡Publicación programada exitosamente! Aunque no tenemos límites de programación, programar demasiadas publicaciones el mismo día en Instagram/Facebook puede causar restricciones en tu perfil. Recomendamos programar un máximo de 3 publicaciones por día.",
        "scratch.post1.title": "Título de tu publicación sobre <b>el tema</b> que quieras.",
        "scratch.post1.description": "Escriba en la siguiente línea para convertirse en la descripción.",
        "scratch.post2.title": "Deje espacio en una nueva línea para comenzar una nueva imagen.",
        "scratch.post3.title": "Marque <b>las partes relevantes en negrita</b> para resaltar",
        "scratch.post4.title": "<b>1.</b> Marque los números en negrita al principio para crear una lista.",
        "scratch.post5.title": "<b>2.</b> Haga clic en cualquier imagen para editar imágenes, diseño, fuentes y colores.",
        "error_publish.too_many_items": "Instagram permite un máximo de 10 publicaciones por carrusel. Elimina parte del contenido para continuar.",
        "error_publish.no_content": "Debes agregar contenido a la publicación para continuar.",
        "error_publish.caption_too_long": "El título de la publicación no puede tener más de 2000 caracteres.",
        "error_publish.too_many_hashtags": "Puedes agregar un máximo de 30 hashtags por publicación.",
        "error_publish.no_caption": "Necesitas agregar un título a la publicación.",
        "error_publish.already_scheduled": "Esta publicación ya ha sido publicada en esta página.",
        "instagram.handle.too_long": "El nombre del perfil de Instagram es demasiado largo. ¿Estas seguro que esto es correcto?",
        "success.canceling_publish": "¡Publicación cancelada exitosamente!",
        "error.canceling_publish": "No se puede cancelar la publicación, inténtalo de nuevo.",
        "label.how_to_connect_instagram": "Haga clic aquí para aprender cómo conectar su cuenta de Instagram a Galilai",
        "plan.upgraded": "¡Plan actualizado exitosamente!",
        "tags.all": "mostrar todo",
        "tags.base": "sin fondo",
        "tags.blob": "burbuja",
        "tags.lines": "líneas",
        "tags.waves": "ondas",
        "tags.swipe": "golpe fuerte",
        "tags.circles": "círculos",
        "tags.points": "puntos",
        "tags.corner": "esquinas",
        "elements.h1": "Título",
        "elements.p": "Descripción",
        "elements.image": "Imagen",
        "elements.overlay": "Elemento",
        "elements.span": "Texto",
        "elements.rect": "Rectángulo",
        "elements.circle": "Círculo",
        "elements.trapezoid": "Trapecio",
        "elements.svg": "Gráfico",
        "icons.suggested.arrow": "seta",
        "icons.suggested.heart": "corazón",
        "icons.suggested.bubble": "burbuja",
        "icons.suggested.shopping": "compras",
        "icons.suggested.phone": "conexión",
        "icons.suggested.local": "local",
        "icons.suggested.star": "estrella",
        "error.publish_reels_not_supported": "Los carretes aún no son compatibles, ¡los lanzaremos pronto!",
        "error.you_need_to_reconnect_for_facebook_permissions": "Debes volver a conectar tu cuenta de Facebook para obtener permisos para publicar.",
        "label.already_caption_filled": "Ya hay un título creado, ¿quieres sobrescribirlo?",
        "label.type_search": "Escribe para buscar",
        "label.colors_theme": "Temas",
        "label.colors_custom": "Costumbre",
        "label.colors_picker": "Identificarme por mi logo",
        "label.main_color": "Director",
        "label.text_color": "Color de texto",
        "label.accent_color": "Acentuar el color",
        "label.project": "Proyecto",
        "button.upload_file_detect_color": "Envía una imagen para identificar los colores.",
        "label.click_to_edit_color": "Editar cor",
        "label.click_to_select_color": "Seleccionar color",
        "error.please_add_caption": "Necesitas agregar un título a la publicación.",
        "label.month_long_1": "Enero",
        "label.month_long_2": "Febrero",
        "label.month_long_3": "Marzo",
        "label.month_long_4": "Abril",
        "label.month_long_5": "Puede",
        "label.month_long_6": "Junio",
        "label.month_long_7": "Julio",
        "label.month_long_8": "Agosto",
        "label.month_long_9": "Septiembre",
        "label.month_long_10": "Octubre",
        "label.month_long_11": "Noviembre",
        "label.month_long_12": "Diciembre",
        "label.month_short_1": "Ene",
        "label.month_short_2": "Fev",
        "label.month_short_3": "Mar",
        "label.month_short_4": "Abril",
        "label.month_short_5": "Puede",
        "label.month_short_6": "Jun",
        "label.month_short_7": "Jul",
        "label.month_short_8": "Atrás",
        "label.month_short_9": "Colocar",
        "label.month_short_10": "Afuera",
        "label.month_short_11": "Nov",
        "label.month_short_12": "Diez",
        "error.empty_post_text_caption": "Tu publicación está vacía, agrega texto para generar un título",
        "label.publish_status_pending": "Edición pendiente",
        "label.publish_status_initial": "Programado",
        "label.publish_status_published": "Publicado",
        "label.publish_status_error": "Error al publicar",
        "error.calendar_full": "El calendario está lleno, ve al mes siguiente para programar más publicaciones o cambiar la configuración de planificación de publicaciones.",
        "label.calendar_other_themes": "otros temas",
        "label.calendar_other_theme": "otro tema",
        "label.calendar_replan_success": "Publicaciones actualizadas exitosamente",
        "error.calendar_replan_error": "Error al actualizar publicaciones",
        "error.calendar_no_posts": "No hay publicaciones para editar, haga clic en Generar para crear publicaciones.",
        "error.calendar_no_topics": "Seleccione al menos un tema para generar publicaciones",
        "error.generate_empty_profile": "Tu perfil está vacío, describe un poco sobre tu negocio",
        "error.not_logged_in": "No has iniciado sesión, inicia sesión para continuar",
        "error.loading.post": "Error al cargar la publicación, inténtalo de nuevo.",
        "error.calendar_drop_past": "No puedes arrastrar publicaciones a fechas pasadas",
        "error.calendar_topic_exists": "Este tema ya ha sido agregado.",
        "label.today": "Hoy",
        "label.help_modal": "Central de Ayuda",
        "error_publish.media_error": "Se produjo un error al cargar sus imágenes. Inténtalo de nuevo.",
        "error_publish.invalid_images": "Se produjo un error al cargar sus imágenes. Inténtalo de nuevo.",
        "error_publish.invalid_page": "La página seleccionada no es válida. ¿Cambiaste tu conexión de Facebook? Por ejemplo: si inició sesión con una nueva cuenta de Facebook, las páginas conectadas anteriormente ya no estarán disponibles.",
        "error_publish.carousel_error": "Se produjo un error al publicar el carrusel. Inténtalo de nuevo.",
        "error_publish.invalid_caption": "El título es demasiado largo o tiene más de 40 hashtags. Edite el título e inténtelo de nuevo.",
        "error_publish.invalid_instagram_account": "La cuenta de Instagram no es válida o no es comercial. ¿Cambiaste tu conexión de Facebook? Por ejemplo: si inició sesión con una nueva cuenta de Facebook, las páginas conectadas anteriormente ya no estarán disponibles.",
        "error_publish.instagram_business_error": "La cuenta de Instagram no es una cuenta comercial. Convierta su cuenta a una cuenta comercial e inténtelo nuevamente. Eche un vistazo a la lista de verificación de páginas conectadas para obtener más información.",
        "error_publish.user_restricted": "Su cuenta de Instagram o Facebook puede estar restringida. Visite <a target='_blank' href='https://www.facebook.com/business-support-home/?landing_page=overview'>este enlace</a> para verificar las restricciones y cómo desbloquear su cuenta. Si alguna cuenta aparece en rojo, haga clic para resolver el problema. Por lo general es necesario enviar algún documento para su validación.",
        "error_publish.rate_limit": "Aunque no tenemos un límite de publicaciones, Instagram/Facebook tiene un límite. Continuar publicando demasiadas publicaciones por día puede provocar el bloqueo de su cuenta. Le sugerimos que deje de publicar por hoy y vuelva a intentarlo mañana con un volumen menor de publicaciones, hasta que se elimine la restricción.",
        "error_publish.publish_error": "Se produjo un error al publicar. Inténtalo de nuevo.",
        "error_publish.publish_error_story": "Se produjo un error al publicar la historia. Inténtalo de nuevo.",
        "error_publish.publish_error_carousel": "Se produjo un error al publicar el carrusel. Inténtalo de nuevo.",
        "error_publish.reauth_required": "Debes volver a conectar tu cuenta de Facebook. Haga clic en 'Conectar mis páginas' y siga las instrucciones.",
        "error.generic": "Huy! Algo salió mal. Inténtalo de nuevo.",
        "error.calendar_topic_length": "El asunto debe tener entre 3 y 150 caracteres.",
        "label.post_type_carousel": "Carrusel",
        "label.post_type_single": "Post Único",
        "label.import_tabs_image": "Imágenes",
        "label.import_tabs_text": "Textos",
        "label.import_tabs_background": "Formas",
        "label.import_tabs_colors": "Núcleos",
        "label.import_tabs_fonts": "Fuentes",
        "label.import_option_title": "Título",
        "label.import_option_description": "Descripción",
        "label.import_option_fixed_text": "Texto fijo",
        "label.import_option_main_image": "Imagen principal",
        "label.import_option_fixed_image": "Imagen fija",
        "label.import_option_email": "Correo electrónico",
        "label.import_option_address": "DIRECCIÓN",
        "label.import_option_phone": "Teléfono",
        "label.import_option_website": "Sitio web",
        "label.import_option_person_image": "Imagen de perfil",
        "label.import_option_list_item": "Elemento de lista",
        "label.import_option_list_cta": "Botón",
        "label.import_option_main_color": "Director",
        "label.import_option_text_color": "Color de texto",
        "label.import_option_highlight_color": "Color de resaltado",
        "label.import_option_font_title": "Fuente del título",
        "label.import_option_font_body": "Fuente del cuerpo",
        "label.import_option_font_subtitle": "Fuente de subtítulos",
        "label.import_hide": "Ocultar",
        "label.import_main_color": "Director",
        "label.import_number": "Número",
        "label.import_author_handle": "Perfil del usuario",
        "label.remove_project_confirm": "¿Estás seguro de que deseas eliminar el proyecto? Se eliminarán todas las publicaciones de esta cuenta.",
        "error.remove_project_last": "No puedes eliminar tu único proyecto.",
        "label.import_layout_success": "Diseño importado correctamente",
        "label.import_option_contextual_fixed_image": "Imagen fija contextual",
        "label.success_generic": "¡Éxito!",
        "success.generic": "¡Éxito!",
        "label.are_you_sure": "¿Estás seguro?",
        "label.professional_area": "Trabajo en el campo de",
        "label.profile_handle": "@meuperfil",
        "label.profile_name": "Mi nombre",
        "area_business.medicine": "Medicamento",
        "area_business.psychology": "Psicología",
        "area_business.law": "Bien",
        "area_business.wellness": "Salud y Bienestar",
        "area_business.education": "Educación",
        "area_business.personal_care": "Cuidados personales",
        "area_business.cosmetics": "Productos cosméticos",
        "area_business.fitness": "Aptitud física",
        "area_business.finance": "Finanzas",
        "area_business.accounting": "Contabilidad",
        "area_business.construction": "Construcción",
        "area_business.real_estate": "Propiedades",
        "area_business.architecture": "Arquitectura",
        "area_business.tech": "Tecnología",
        "area_business.pets": "Mascotas",
        "area_business.coaching": "Entrenamiento",
        "area_business.clothing": "Moda",
        "area_business.restaurant": "Restaurante",
        "area_business.automotive": "Automotor",
        "area_business.transport": "Transporte",
        "label.media_select_image": "Seleccione una imagen",
        "label.media_select_audio": "Selecciona un audio",
        "label.media_select_video": "Selecciona un vídeo",
        "label.media_select_elements": "Seleccione un elemento",
        "label.media_select_fonts": "Seleccione una fuente",
        "label.media_select_product": "Seleccione un producto o servicio",
        "tab.media_icons_database": "Iconos",
        "tab.media_images_database": "Banco de imagenes",
        "tab.media_audio_database": "Banco de la música",
        "tab.media_video_database": "Banco de vídeos",
        "tab.media_my_images": "Mis imagenes",
        "tab.media_my_fonts": "Mis fuentes",
        "tab.media_my_audio": "Mis canciones",
        "tab.media_my_video": "Mis videos",
        "tab.media_my_products": "Mis productos y servicios",
        "btn.remove_bg": "Quitar fondo",
        "btn.remove": "Agente de mudanzas",
        "btn.select": "Seleccionar",
        "label.folder_home": "Todo",
        "tag.audio_all": "Todo",
        "tag.audio_upbeat": "Dinámico",
        "tag.audio_happy": "Feliz",
        "tag.audio_inspiring": "Inspirador",
        "tag.audio_chill": "Relajante",
        "label.need_to_increase_quantity": "necesitas aumentar el número de empresas en tu plan",
        "label.multiple_pages": "Multiples paginas",
        "label.one_page": "Una página",
        "error.rendering_post": "Error al descargar la publicación. Inténtalo de nuevo",
        "label.otp_verified_mobile": "¡Su inicio de sesión fue exitoso! Regrese a la aplicación para continuar.",
        "label.otp_verified": "¡Su inicio de sesión fue exitoso!",
        "success.connected_facebook_app": "¡Has conectado exitosamente tus cuentas sociales! Regrese a la aplicación para continuar.",
        "label.app_update_available": "Una nueva versión de la aplicación está disponible. Actualice para acceder a nuevas funciones.",
        "label.app_update_available_required": "Una nueva versión de la aplicación está disponible. Debes actualizar para continuar.",
        "tab.favorites": "Favoritos",
        "error.missing_project_favorite": "Vaya a la pestaña de favoritos y elija un proyecto primero",
        "label.my_text": "Mi texto",
        "label.remove_generic": "¿Estás seguro de que quieres eliminar?",
        "label.confirm_reset_layout": "¿Está seguro de que desea eliminar el formato? El diseño volverá al valor predeterminado.",
        "error.invalid.file_type": "Tipo de archivo no válido",
        "success.copy_clipboard": "¡Copiado al portapapeles!",
        "label.remove_all_posts_confirm": "¿Estás seguro de que deseas eliminar todas las publicaciones? No será posible recuperarlos.",
        "label.post_should_be_tall": "El tipo de publicación que elijas debe usar un tamaño vertical; de lo contrario, se cortarán cuando se publiquen. ¿Quieres cambiar de todos modos?",
        "label.my_palletes": "Mis paletas",
        "label.my_colors": "Mis colores",
        "label.generic_add": "Para agregar",
        "label.generic_edit": "Para editar",
        "label.generic_save": "Ahorrar",
        "label.generic_remove": "Agente de mudanzas",
        "label.generic_cancel": "Cancelar",
        "label.add_new_pallete": "Agregar nueva paleta",
        "label.apply_pallete": "Usar Paleta",
        "label.title_font_header": "Título",
        "label.description_font_header": "Descripción",
        "label.text_min_size": "Tamaño mínimo",
        "label.text_max_size": "Tamaño máximo",
        "label.font_size_info": "Los tamaños de fuente se ajustan automáticamente para garantizar la mejor legibilidad. Para personalizar, ajuste los valores mínimo y máximo. Para establecer un tamaño específico, haga clic en el texto y ajústelo directamente.",
        "label.text_min_size_tooltip": "Tamaño mínimo de fuente cuando hay mucho texto y es necesario reducirlo para ajustarlo al espacio disponible.",
        "label.text_max_size_tooltip": "Tamaño de fuente predeterminado y máximo que se puede ajustar.",
        "label.feature_contact_support": "Comuníquese con el soporte para habilitar esta funcionalidad. ¿Quieres iniciar una conversación?",
        "label.iap_info_ios": "Las suscripciones se cargarán a su tarjeta de crédito a través de su cuenta de iTunes. Las suscripciones se renovarán automáticamente a menos que se cancelen 24 horas antes del final del período actual. Puedes cancelar en cualquier momento en la configuración de tu cuenta de iTunes.",
        "error.iap_other_account": "Tienes una suscripción activa con otro correo electrónico. Por favor inicie sesión con el correo electrónico correcto.",
        "error.invalid.product": "El nombre y las imágenes son obligatorios.",
        "error.invalid.product.name": "El nombre es obligatorio.",
        "error.invalid.product.price": "Se requiere precio.",
        "error.invalid.product.url": "La imagen es obligatoria.",
        "error.invalid.product.project": "Debe seleccionar un proyecto para agregar un producto.",
        "error.select_product": "Seleccione al menos un producto/servicio.",
        "error.select_media": "Seleccione al menos una imagen.",
        "error.select_themes": "Seleccione al menos un tema.",
        "error.select_a_post": "Seleccione al menos una publicación.",
        "error.type_context": "Ingrese una instrucción para generar publicaciones.",
        "error.max_media_items": "Sólo es posible seleccionar hasta 5 artículos.",
        "error.save_posts": "Error al guardar publicaciones.",
        "label.mode_themes": "Elige materias",
        "label.mode_themes_description": "Elige los temas que deseas cubrir",
        "label.mode_product": "Producto o Servicio",
        "label.mode_product_description": "Elija un producto o servicio para hablar",
        "label.mode_dates": "Fechas conmemorativas",
        "label.mode_dates_description": "Elige una fecha conmemorativa",
        "label.mode_media": "Imagen",
        "label.mode_media_description": "Elige una o más imágenes",
        "label.mode_instruction": "Escribe lo que necesito",
        "label.mode_instruction_description": "Describe lo que necesitas",
        "label.mode_link": "Enlace",
        "label.mode_link_description": "Pega un enlace para generar una publicación.",
        "label.mode_empty": "Publicación en blanco",
        "label.mode_empty_description": "Crea una publicación desde cero",
        "label.mode_existing": "Publicar pronto",
        "label.mode_existing_description": "Solo quiero hacer una cita",
        "layout.smart_any": "Cualquier",
        "layout.smart_title_grid": "Calificación",
        "layout.smart_vertical": "Vertical",
        "layout.smart_horizontal": "Horizontal",
        "layout.smart_title_style": "Estilo",
        "layout.smart_geometric": "Geométrico",
        "layout.smart_rounded": "Redondeado",
        "layout.smart_title_shader": "Apariencia",
        "layout.smart_flat": "Simple",
        "layout.smart_gradient": "Gradiente",
        "layout.smart_pattern": "Estándar",
        "layout.smart_3d": "3D",
        "layout.smart_title_orientation": "Posición de la imagen",
        "layout.smart_begin": "Comenzar",
        "layout.smart_end": "Fin",
        "layout.smart_title_alignment": "Alineación",
        "layout.smart_left": "Izquierda",
        "layout.smart_center": "Centro",
        "layout.smart_right": "Bien",
        "layout.smart_title_focus": "Enfocar",
        "layout.smart_text": "Texto",
        "layout.smart_balanced": "Balanceado",
        "layout.smart_fullscreen": "Pantalla completa",
        "layout.smart_title_decorative": "Decorativo",
        "layout.smart_yes": "Intentar",
        "layout.smart_no": "No",
        "layout.smart_title_include_shapes": "Formas",
        "error.generator_no_content": "No se pudo encontrar contenido en este enlace",
        "error.generator_no_link": "Por favor inserte un enlace",
        "gen.product.objective": "Objetivo",
        "gen.product.price": "Precio",
        "gen.product.info": "Información",
        "gen.product.cta": "Llamado a la acción",
        "gen.product.discount": "Descuento",
        "tab.media_my_videos": "Mis videos",
        "tab.media_videos_database": "Banco de vídeos",
        "error.invalid.max_size": "El tamaño máximo del archivo debe ser %s.",
        "label.too_long_video": "Las publicaciones no deben durar más de %s minutos.",
        "label.affiliate_created": "Crea tu código de afiliado",
        "label.affiliate_message": "Solo ingresa el código, se verá así para compartir:",
        "label.affiliate_code_name": "TU CÓDIGO",
        "error.affiliate.code_exists": "Código de afiliado en uso, elija otro",
        "generic.no": "No",
        "generic.yes": "Intentar",
        "generator.include_related": "¿Incluir temas relacionados?",
        "generator.tone": "Tom de voz",
        "generator.tone_normal": "Normal",
        "generator.tone_formal": "Formal",
        "generator.tone_fun": "Divertido",
        "generator.tone_informal": "Informal",
        "generator.tone_informative": "Informativo",
        "generator.tone_inspiring": "Inspirador",
        "generator.tone_polemic": "Controversial",
        "generator.tone_curious": "Curiosidad",
        "generator.objective": "Objetivo",
        "generator.objective_authority": "Autoridad",
        "generator.objective_sales": "Ventas",
        "generator.objective_custom": "Costumbre",
        "generator.authority_list": "Lista",
        "generator.authority_opinion": "Opinión",
        "generator.authority_question": "Pregunta",
        "generator.authority_checklist": "Lista de verificación",
        "generator.authority_news": "Noticias",
        "generator.authority_trivia": "Trivialidades",
        "generator.content_type": "Tipo de contenido",
        "generator.authority_faq": "Dudas",
        "generator.authority_tips": "Consejos",
        "generator.authority_tutorial": "Tutoriales",
        "generator.authority_myths": "Mitos y verdades",
        "generator.authority_errors": "Errores comunes",
        "generator.authority_trends": "Noticias",
        "generator.sales_hooks": "Desencadenantes de ventas",
        "generator.sales_benefits": "Beneficios",
        "generator.sales_features": "Características",
        "generator.sales_offers": "Ofertas",
        "generator.sales_cta": "Llamado a la acción",
        "generator.sales_social_proof": "Pruebas sociales",
        "generator.tone_tooltip": "Tono de voz de tus publicaciones",
        "generator.objective_tooltip": "Las publicaciones de autoridad ayudan a mostrar su experiencia en el campo. Las publicaciones de ventas se utilizan para promocionar un producto o servicio.",
        "generator.format_tooltip": "Formato de salida de tu publicación",
        "generator.include_related_tooltip": "Incluir temas relacionados para proporcionar más variedad de contenido.",
        "generator.include_profile": "Relacionado con mi negocio",
        "generator.include_profile_tooltip": "Elige si las publicaciones generadas deben estar relacionadas con tu negocio o si deben ser más genéricas.",
        "generator.size": "Tamaño del título",
        "generator.size_short": "Corto",
        "generator.size_medium": "Promedio",
        "generator.size_long": "Lejos",
        "error.media_in_use": "Esta imagen se está utilizando en una publicación y no se puede eliminar.",
        "success.cancel_account": "¡Cuenta cancelada exitosamente!",
        "error.fill_required_fields": "Complete todos los campos obligatorios",
        "generator.media_format": "Tipo de archivo de publicación",
        "generator.media_format_image": "Imagen",
        "generator.media_format_video": "Video",
        "generator.hasCaption": "¿Tienes un título listo?",
        "generator.post_format": "Formato",
        "generator.post_format_post": "Correo",
        "generator.post_format_reels": "Bobinas",
        "generator.post_format_story": "Story",
        "error.format_post_not_support_media": "El formato de publicación elegido no admite este tipo de medios.",
        "error.limit_posts_per_format": "El formato de publicación elegido no admite tantos archivos",
        "label.content_already_generated": "Tu publicación ya tiene contenido generado. ¿Quieres sobrescribir las páginas del carrusel? Se conservará la primera página.",
        "error.post_duration_exceeded": "La duración de la publicación excedió el límite máximo de %s segundos."
    },
    "fr": {
        "instagram.handle.error": "Impossible de trouver le profil Instagram",
        "error.generating.content": "Impossible de générer du contenu",
        "error.saving.post": "Impossible d'enregistrer le message",
        "success.saving.post": "Message enregistré avec succès !",
        "error.validation.context": "Merci de remplir tous les champs",
        "error.validation.email": "Veuillez remplir un email valide",
        "error.imageLoading": "Attendez une minute, nous chargeons l'image du message",
        "instagram.handle.at_removed": "Vous n'avez pas besoin du @, juste du nom du profil",
        "info.config.show": "Cliquez sur l'image du message pour modifier les couleurs, les polices et d'autres détails",
        "error.invalid.image": "Erreur lors de l'envoi de l'image",
        "success.trial_started": "Bienvenue dans la période d'essai de Magic Editor 🥳 !",
        "error.starting_trial": "Impossible de démarrer la période d'essai",
        "category.all": "Tous",
        "category.images": "Images",
        "category.cover": "Couche",
        "category.slide": "Carrousel",
        "category.news": "Nouvelles",
        "category.social": "Sociale",
        "category.quote": "Citation",
        "category.question": "Question",
        "category.list": "Liste",
        "category.number": "Liste",
        "category.checklist": "Liste de contrôle",
        "category.before-after": "Avant et Après",
        "category.trivia": "Anecdotes",
        "error.invalid.image_must_be_png": "L'image doit être au format PNG avec un fond transparent",
        "error.project.create": "Impossible de créer un projet",
        "error.creating_scratch": "Impossible de créer le message",
        "source.Save Post": "Enregistrer une publication",
        "source.Preview Post": "Afficher une publication",
        "source.Download Post": "Télécharger un article",
        "source.Refresh Keywords": "Mettre à jour les mots clés",
        "source.Upload Logo": "Mettre à jour le logo",
        "source.Upload Social Logo": "Mettre à jour la photo de profil",
        "source.Publish Item": "Publier un article",
        "source.Edit Item": "Modifier un message",
        "source.Save Item": "Enregistrer une publication",
        "source.Captions Item": "Générer des sous-titres",
        "source.Generated once but not logged in": "Générer plus de publications",
        "source.Generated once but not customer": "Générer plus de publications",
        "source.Generate Audience": "Identifiez le public cible",
        "source.Generate Audience Needs": "Identifier les besoins du public cible",
        "source.Generate Audience Goals": "Identifier les objectifs du public cible",
        "source.Generate Captions": "Générer des sous-titres",
        "source.Create Scratch": "Créer une publication à partir de zéro",
        "source.Custom Fonts": "Utiliser des polices personnalisées",
        "source.Use my medias": "Utiliser mes images",
        "source.Edit Themes": "Modifier les thèmes",
        "source.Bulk Edit": "Modifier les messages dans Massa",
        "source.Save Replan": "Enregistrer la planification des publications",
        "source.Remove Schedule": "Supprimer le programme",
        "source.Pin Post": "Message favori",
        "source.Finish Theme Selection": "Finaliser la sélection du thème",
        "source.Regenerate Post": "Générer un nouveau message",
        "source.Change Calendar Range": "Modifier la période du calendrier",
        "source.Remove Post": "Message de suppression",
        "source.Edit Post": "Modifier le message",
        "source.Skip Day": "Passer un jour",
        "source.Publish Reels": "Créer et publier des bobines",
        "source.Add more products": "Ajouter plus de produits",
        "source.Save Post Calendar": "Enregistrer la publication dans le calendrier",
        "source.Select Audio": "Sélectionnez la musique",
        "source.Select Video": "Sélectionner une vidéo",
        "plan.filter.monthly": "Mensuel",
        "plan.filter.annual": "Annuel",
        "source.Max projects reached": "Ajouter plus de comptes",
        "source.Publish Post Directly": "Publier des publications directement sur Instagram",
        "source.Schedule Posts": "Programmer des publications",
        "features.infinite_ideas": "Idées de publication illimitées",
        "features.custom_style": "Personnalisation de la publication",
        "features.integrated_publishing": "Publication automatique",
        "features.unlimited_accounts": "Comptes illimités",
        "features.1_account": "1 compte social",
        "features.accounts": "entreprises",
        "features.reels": "Bobines et animations de publication",
        "features.audio": "Chansons dans les messages",
        "features.custom_videos": "Vidéothèque",
        "features.unlimited_posts": "Publications illimitées",
        "label.plans_trial_days": "14 jours d'essai gratuit",
        "label.plans_cancel_anytime": "Annuler à tout moment",
        "error.upgrade_plan": "Erreur lors de la mise à jour du plan, réessayez",
        "error.not_possible_find_instagram_account": "Vous ne trouvez pas votre compte Instagram ?",
        "label.to_connect_you_need": "Pour vous connecter, vous avez besoin de :",
        "label.no_instagram_enabled": "Cette page n'est pas associée à Instagram",
        "error.please_select_page": "Veuillez sélectionner une page",
        "error.please_select_target": "Sélectionnez où vous souhaitez publier",
        "error.please_select_format": "Sélectionnez le format de publication",
        "error.scheduling_post": "Impossible de planifier la publication, veuillez réessayer",
        "error.authenticating_facebook": "Impossible de vous authentifier auprès de Facebook, veuillez réessayer",
        "success.scheduling_post": "Article dont la publication est prévue avec succès !",
        "success.scheduling_post_limit": "Publication programmée avec succès ! Bien que nous n'ayons pas de limites de planification, la planification d'un trop grand nombre de publications le même jour sur Instagram/Facebook peut entraîner des restrictions sur votre profil. Nous vous recommandons de planifier un maximum de 3 publications par jour.",
        "scratch.post1.title": "Titre de votre article sur <b>le sujet</b> de votre choix",
        "scratch.post1.description": "Écrivez sur la ligne suivante pour devenir la description",
        "scratch.post2.title": "Laissez de l'espace sur une nouvelle ligne pour démarrer une nouvelle image",
        "scratch.post3.title": "Marquez <b>les parties pertinentes en gras</b> pour les mettre en évidence",
        "scratch.post4.title": "<b>1.</b> Marquez les nombres en gras au début pour créer une liste",
        "scratch.post5.title": "<b>2.</b> Cliquez sur n'importe quelle image pour modifier les images, la mise en page, les polices et les couleurs",
        "error_publish.too_many_items": "Instagram autorise un maximum de 10 publications par carrousel. Supprimez du contenu pour continuer.",
        "error_publish.no_content": "Vous devez ajouter du contenu à la publication pour continuer.",
        "error_publish.caption_too_long": "La légende du message ne peut pas dépasser 2 000 caractères.",
        "error_publish.too_many_hashtags": "Vous pouvez ajouter un maximum de 30 hashtags par publication.",
        "error_publish.no_caption": "Vous devez ajouter une légende au message",
        "error_publish.already_scheduled": "Cet article a déjà été publié sur cette page",
        "instagram.handle.too_long": "Le nom du profil Instagram est trop long. Etes-vous sûr que c'est correct ?",
        "success.canceling_publish": "Message annulé avec succès !",
        "error.canceling_publish": "Impossible d'annuler la publication, veuillez réessayer",
        "label.how_to_connect_instagram": "Cliquez ici pour savoir comment connecter votre compte Instagram à Galilai",
        "plan.upgraded": "Plan mis à jour avec succès !",
        "tags.all": "Afficher tout",
        "tags.base": "sans fond",
        "tags.blob": "bulle",
        "tags.lines": "lignes",
        "tags.waves": "vagues",
        "tags.swipe": "glisser",
        "tags.circles": "cercles",
        "tags.points": "points",
        "tags.corner": "coins",
        "elements.h1": "Titre",
        "elements.p": "Description",
        "elements.image": "Image",
        "elements.overlay": "Élément",
        "elements.span": "Texte",
        "elements.rect": "Rectangle",
        "elements.circle": "Cercle",
        "elements.trapezoid": "Trapèze",
        "elements.svg": "Graphique",
        "icons.suggested.arrow": "seta",
        "icons.suggested.heart": "cœur",
        "icons.suggested.bubble": "bulle",
        "icons.suggested.shopping": "achats",
        "icons.suggested.phone": "connexion",
        "icons.suggested.local": "locale",
        "icons.suggested.star": "étoile",
        "error.publish_reels_not_supported": "Les reels ne sont pas encore pris en charge, nous les lancerons bientôt !",
        "error.you_need_to_reconnect_for_facebook_permissions": "Vous devez reconnecter votre compte Facebook pour obtenir l'autorisation de publier",
        "label.already_caption_filled": "Une légende a déjà été créée, souhaitez-vous l'écraser ?",
        "label.type_search": "Tapez pour rechercher",
        "label.colors_theme": "Thèmes",
        "label.colors_custom": "Coutume",
        "label.colors_picker": "Identifier par mon logo",
        "label.main_color": "Directeur principal",
        "label.text_color": "Couleur du texte",
        "label.accent_color": "Couleur d'accentuation",
        "label.project": "Projet",
        "button.upload_file_detect_color": "Envoyer une image pour identifier les couleurs",
        "label.click_to_edit_color": "Modifier le code",
        "label.click_to_select_color": "Sélectionnez la couleur",
        "error.please_add_caption": "Vous devez ajouter une légende au message",
        "label.month_long_1": "Janvier",
        "label.month_long_2": "Février",
        "label.month_long_3": "Mars",
        "label.month_long_4": "Avril",
        "label.month_long_5": "Peut",
        "label.month_long_6": "Juin",
        "label.month_long_7": "Juillet",
        "label.month_long_8": "Août",
        "label.month_long_9": "Septembre",
        "label.month_long_10": "Octobre",
        "label.month_long_11": "Novembre",
        "label.month_long_12": "Décembre",
        "label.month_short_1": "Jan",
        "label.month_short_2": "Février",
        "label.month_short_3": "Mar",
        "label.month_short_4": "Avril",
        "label.month_short_5": "Peut",
        "label.month_short_6": "Juin",
        "label.month_short_7": "Juillet",
        "label.month_short_8": "Il y a",
        "label.month_short_9": "Ensemble",
        "label.month_short_10": "Dehors",
        "label.month_short_11": "Nov",
        "label.month_short_12": "Dix",
        "error.empty_post_text_caption": "Votre message est vide, ajoutez du texte pour générer une légende",
        "label.publish_status_pending": "Édition en attente",
        "label.publish_status_initial": "Programmé",
        "label.publish_status_published": "Publié",
        "label.publish_status_error": "Erreur de publication",
        "error.calendar_full": "Le calendrier est plein, passez au mois suivant pour programmer plus de publications ou modifier vos paramètres de planification de publication.",
        "label.calendar_other_themes": "d'autres sujets",
        "label.calendar_other_theme": "un autre sujet",
        "label.calendar_replan_success": "Messages mis à jour avec succès",
        "error.calendar_replan_error": "Erreur lors de la mise à jour des messages",
        "error.calendar_no_posts": "Aucune publication à modifier, cliquez sur Générer pour créer des publications.",
        "error.calendar_no_topics": "Sélectionnez au moins un sujet pour générer des publications",
        "error.generate_empty_profile": "Votre profil est vide, décrivez un peu votre entreprise",
        "error.not_logged_in": "Vous n'êtes pas connecté, veuillez vous connecter pour continuer",
        "error.loading.post": "Erreur lors du chargement de la publication, veuillez réessayer",
        "error.calendar_drop_past": "Vous ne pouvez pas faire glisser les publications vers des dates passées",
        "error.calendar_topic_exists": "Ce sujet a déjà été ajouté",
        "label.today": "Aujourd'hui",
        "label.help_modal": "Centre d'aide",
        "error_publish.media_error": "Une erreur s'est produite lors du téléchargement de vos images. Veuillez réessayer.",
        "error_publish.invalid_images": "Une erreur s'est produite lors du téléchargement de vos images. Veuillez réessayer.",
        "error_publish.invalid_page": "La page sélectionnée n'est pas valide. Avez-vous modifié votre connexion Facebook ? Par exemple : si vous vous êtes connecté avec un nouveau compte Facebook, les pages précédemment connectées ne seront plus disponibles.",
        "error_publish.carousel_error": "Une erreur s'est produite lors de la publication du carrousel. Veuillez réessayer.",
        "error_publish.invalid_caption": "La légende est trop longue ou contient plus de 40 hashtags. Veuillez modifier la légende et réessayer.",
        "error_publish.invalid_instagram_account": "Le compte Instagram n'est pas valide ou n'est pas Business. Avez-vous modifié votre connexion Facebook ? Par exemple : si vous vous êtes connecté avec un nouveau compte Facebook, les pages précédemment connectées ne seront plus disponibles.",
        "error_publish.instagram_business_error": "Le compte Instagram n'est pas un compte Business. Veuillez convertir votre compte en compte professionnel et réessayer. Jetez un œil à la liste de contrôle des pages de connexion pour plus d’informations.",
        "error_publish.user_restricted": "Votre compte Instagram ou Facebook peut être restreint. Visitez <a target='_blank' href='https://www.facebook.com/business-support-home/?landing_page=overview'>ce lien</a> pour vérifier les restrictions et comment déverrouiller votre compte. Si des comptes apparaissent en rouge, cliquez pour résoudre le problème. En général, il est nécessaire d'envoyer un document pour validation.",
        "error_publish.rate_limit": "Bien que nous n'ayons pas de limite sur les publications, Instagram/Facebook a une limite. Continuer à publier trop de messages par jour peut entraîner le blocage de votre compte. Nous vous suggérons d'arrêter de publier aujourd'hui et de réessayer demain avec un plus petit volume de publications, jusqu'à ce que la restriction soit supprimée.",
        "error_publish.publish_error": "Une erreur s'est produite lors de la publication. Veuillez réessayer.",
        "error_publish.publish_error_story": "Une erreur s'est produite lors de la publication de l'histoire. Veuillez réessayer.",
        "error_publish.publish_error_carousel": "Une erreur s'est produite lors de la publication du carrousel. Veuillez réessayer.",
        "error_publish.reauth_required": "Vous devez à nouveau connecter votre compte Facebook. Veuillez cliquer sur « Connecter mes pages » et suivez les instructions.",
        "error.generic": "Oups, quelque chose s'est mal passé. Veuillez réessayer.",
        "error.calendar_topic_length": "Le sujet doit comporter entre 3 et 150 caractères",
        "label.post_type_carousel": "Carrousel",
        "label.post_type_single": "Message unique",
        "label.import_tabs_image": "Images",
        "label.import_tabs_text": "Des textes",
        "label.import_tabs_background": "Formes",
        "label.import_tabs_colors": "Noyaux",
        "label.import_tabs_fonts": "Sources",
        "label.import_option_title": "Titre",
        "label.import_option_description": "Description",
        "label.import_option_fixed_text": "Texte fixe",
        "label.import_option_main_image": "Image principale",
        "label.import_option_fixed_image": "Image fixe",
        "label.import_option_email": "E-mail",
        "label.import_option_address": "Adresse",
        "label.import_option_phone": "Téléphone",
        "label.import_option_website": "Site web",
        "label.import_option_person_image": "Image de profil",
        "label.import_option_list_item": "Élément de liste",
        "label.import_option_list_cta": "Bouton",
        "label.import_option_main_color": "Directeur principal",
        "label.import_option_text_color": "Couleur du texte",
        "label.import_option_highlight_color": "Couleur de surbrillance",
        "label.import_option_font_title": "Titre Source",
        "label.import_option_font_body": "Source du corps",
        "label.import_option_font_subtitle": "Police des sous-titres",
        "label.import_hide": "Cacher",
        "label.import_main_color": "Directeur principal",
        "label.import_number": "Nombre",
        "label.import_author_handle": "Profil de l'utilisateur",
        "label.remove_project_confirm": "Êtes-vous sûr de vouloir supprimer le projet ? Toutes les publications de ce compte seront supprimées.",
        "error.remove_project_last": "Vous ne pouvez pas supprimer votre seul projet",
        "label.import_layout_success": "Mise en page importée avec succès",
        "label.import_option_contextual_fixed_image": "Image fixe contextuelle",
        "label.success_generic": "Succès!",
        "success.generic": "Succès!",
        "label.are_you_sure": "Es-tu sûr?",
        "label.professional_area": "Je travaille dans le domaine de",
        "label.profile_handle": "@meuperfil",
        "label.profile_name": "Mon nom",
        "area_business.medicine": "Médecine",
        "area_business.psychology": "Psychologie",
        "area_business.law": "Droite",
        "area_business.wellness": "Santé et bien-être",
        "area_business.education": "Éducation",
        "area_business.personal_care": "Soins personnels",
        "area_business.cosmetics": "Produits de beauté",
        "area_business.fitness": "Aptitude",
        "area_business.finance": "Finance",
        "area_business.accounting": "Comptabilité",
        "area_business.construction": "Construction",
        "area_business.real_estate": "Propriétés",
        "area_business.architecture": "Architecture",
        "area_business.tech": "Technologie",
        "area_business.pets": "Animaux domestiques",
        "area_business.coaching": "Encadrement",
        "area_business.clothing": "Mode",
        "area_business.restaurant": "Restaurant",
        "area_business.automotive": "Automobile",
        "area_business.transport": "Transport",
        "label.media_select_image": "Sélectionnez une image",
        "label.media_select_audio": "Sélectionnez un audio",
        "label.media_select_video": "Sélectionnez une vidéo",
        "label.media_select_elements": "Sélectionnez un élément",
        "label.media_select_fonts": "Sélectionnez une police",
        "label.media_select_product": "Sélectionnez un produit ou un service",
        "tab.media_icons_database": "Icônes",
        "tab.media_images_database": "Banque d'images",
        "tab.media_audio_database": "La Banque de musique",
        "tab.media_video_database": "Banque de vidéos",
        "tab.media_my_images": "Mes images",
        "tab.media_my_fonts": "Mes sources",
        "tab.media_my_audio": "Mes chansons",
        "tab.media_my_video": "Mes vidéos",
        "tab.media_my_products": "Mes produits et services",
        "btn.remove_bg": "Supprimer l'arrière-plan",
        "btn.remove": "Dissolvant",
        "btn.select": "Sélectionner",
        "label.folder_home": "Tous",
        "tag.audio_all": "Tous",
        "tag.audio_upbeat": "Vivant",
        "tag.audio_happy": "Heureux",
        "tag.audio_inspiring": "Inspirant",
        "tag.audio_chill": "Relaxant",
        "label.need_to_increase_quantity": "vous devez augmenter le nombre d'entreprises dans votre plan",
        "label.multiple_pages": "Pages multiples",
        "label.one_page": "Une page",
        "error.rendering_post": "Erreur lors du téléchargement de la publication. Veuillez réessayer",
        "label.otp_verified_mobile": "Votre connexion a réussi ! Revenez à l'application pour continuer.",
        "label.otp_verified": "Votre connexion a réussi !",
        "success.connected_facebook_app": "Vous avez connecté avec succès vos comptes sociaux ! Revenez à l'application pour continuer.",
        "label.app_update_available": "Une nouvelle version de l'application est disponible. Mettez à jour pour accéder aux nouvelles fonctionnalités.",
        "label.app_update_available_required": "Une nouvelle version de l'application est disponible. Vous devez mettre à jour pour continuer.",
        "tab.favorites": "Favoris",
        "error.missing_project_favorite": "Allez dans l'onglet Favoris et choisissez d'abord un projet",
        "label.my_text": "Mon texte",
        "label.remove_generic": "Êtes-vous sûr de vouloir supprimer ?",
        "label.confirm_reset_layout": "Êtes-vous sûr de vouloir supprimer le formatage ? La mise en page reviendra à sa valeur par défaut.",
        "error.invalid.file_type": "Type de fichier invalide",
        "success.copy_clipboard": "Copié dans le presse-papier !",
        "label.remove_all_posts_confirm": "Êtes-vous sûr de vouloir supprimer tous les messages ? Il ne sera pas possible de les récupérer.",
        "label.post_should_be_tall": "Le type de publication que vous choisissez doit utiliser une taille verticale, sinon ils seront coupés lors de la publication. Voulez-vous quand même changer ?",
        "label.my_palletes": "Mes palettes",
        "label.my_colors": "Mes couleurs",
        "label.generic_add": "Ajouter",
        "label.generic_edit": "Éditer",
        "label.generic_save": "Sauver",
        "label.generic_remove": "Dissolvant",
        "label.generic_cancel": "Annuler",
        "label.add_new_pallete": "Ajouter une nouvelle palette",
        "label.apply_pallete": "Utiliser la palette",
        "label.title_font_header": "Titre",
        "label.description_font_header": "Description",
        "label.text_min_size": "Taille minimale",
        "label.text_max_size": "Taille maximale",
        "label.font_size_info": "Les tailles de police sont automatiquement ajustées pour garantir la meilleure lisibilité. Pour personnaliser, ajustez les valeurs minimales et maximales. Pour définir une taille spécifique, cliquez sur le texte et ajustez directement.",
        "label.text_min_size_tooltip": "Taille de police minimale lorsqu'il y a beaucoup de texte et qu'elle doit être réduite pour s'adapter à l'espace disponible.",
        "label.text_max_size_tooltip": "Taille de police par défaut et maximale pouvant être ajustée.",
        "label.feature_contact_support": "Veuillez contacter le support pour activer cette fonctionnalité. Voulez-vous démarrer une conversation?",
        "label.iap_info_ios": "Les abonnements seront facturés sur votre carte de crédit via votre compte iTunes. Les abonnements seront automatiquement renouvelés sauf annulation 24 heures avant la fin de la période en cours. Vous pouvez annuler à tout moment dans les paramètres de votre compte iTunes.",
        "error.iap_other_account": "Vous avez un abonnement actif avec un autre email. Veuillez vous connecter avec le bon email.",
        "error.invalid.product": "Le nom et les images sont obligatoires.",
        "error.invalid.product.name": "Le nom est obligatoire.",
        "error.invalid.product.price": "Le prix est obligatoire.",
        "error.invalid.product.url": "L'image est obligatoire.",
        "error.invalid.product.project": "Vous devez sélectionner un projet pour ajouter un produit.",
        "error.select_product": "Sélectionnez au moins un produit/service.",
        "error.select_media": "Sélectionnez au moins une image.",
        "error.select_themes": "Sélectionnez au moins un thème.",
        "error.select_a_post": "Sélectionnez au moins une publication.",
        "error.type_context": "Entrez une instruction pour générer des publications.",
        "error.max_media_items": "Il n'est possible de sélectionner que jusqu'à 5 éléments.",
        "error.save_posts": "Erreur lors de l'enregistrement des messages.",
        "label.mode_themes": "Choisissez des sujets",
        "label.mode_themes_description": "Choisissez les sujets que vous souhaitez aborder",
        "label.mode_product": "Produit ou service",
        "label.mode_product_description": "Choisissez un produit ou un service dont vous souhaitez parler",
        "label.mode_dates": "Dates commémoratives",
        "label.mode_dates_description": "Choisissez une date commémorative",
        "label.mode_media": "Image",
        "label.mode_media_description": "Choisissez une ou plusieurs images",
        "label.mode_instruction": "Écrivez ce dont j'ai besoin",
        "label.mode_instruction_description": "Décrivez ce dont vous avez besoin",
        "label.mode_link": "Lien",
        "label.mode_link_description": "Collez un lien pour générer une publication",
        "label.mode_empty": "Message vide",
        "label.mode_empty_description": "Créer une publication à partir de zéro",
        "label.mode_existing": "Postez pronto",
        "label.mode_existing_description": "Je veux juste prendre rendez-vous",
        "layout.smart_any": "N'importe lequel",
        "layout.smart_title_grid": "Grade",
        "layout.smart_vertical": "Verticale",
        "layout.smart_horizontal": "Horizontal",
        "layout.smart_title_style": "Style",
        "layout.smart_geometric": "Géométrique",
        "layout.smart_rounded": "Arrondi",
        "layout.smart_title_shader": "Apparence",
        "layout.smart_flat": "Simple",
        "layout.smart_gradient": "Pente",
        "layout.smart_pattern": "Standard",
        "layout.smart_3d": "3D",
        "layout.smart_title_orientation": "Position de l'image",
        "layout.smart_begin": "Commencer",
        "layout.smart_end": "Fin",
        "layout.smart_title_alignment": "Alignement",
        "layout.smart_left": "Gauche",
        "layout.smart_center": "Centre",
        "layout.smart_right": "Droite",
        "layout.smart_title_focus": "Se concentrer",
        "layout.smart_text": "Texte",
        "layout.smart_balanced": "Équilibré",
        "layout.smart_fullscreen": "Plein écran",
        "layout.smart_title_decorative": "Décoratif",
        "layout.smart_yes": "Essayer",
        "layout.smart_no": "Non",
        "layout.smart_title_include_shapes": "Formes",
        "error.generator_no_content": "Impossible de trouver le contenu de ce lien",
        "error.generator_no_link": "Veuillez insérer un lien",
        "gen.product.objective": "But",
        "gen.product.price": "Prix",
        "gen.product.info": "Information",
        "gen.product.cta": "Appel à l'action",
        "gen.product.discount": "Rabais",
        "tab.media_my_videos": "Mes vidéos",
        "tab.media_videos_database": "Banque de vidéos",
        "error.invalid.max_size": "La taille maximale du fichier doit être %s.",
        "label.too_long_video": "Les messages ne doivent pas durer plus de %s minutes.",
        "label.affiliate_created": "Créez votre code d'affiliation",
        "label.affiliate_message": "Entrez simplement le code, il ressemblera à ceci à partager :",
        "label.affiliate_code_name": "VOTRECODE",
        "error.affiliate.code_exists": "Code d'affiliation utilisé, veuillez en choisir un autre",
        "generic.no": "Non",
        "generic.yes": "Essayer",
        "generator.include_related": "Inclure des sujets connexes ?",
        "generator.tone": "Voix de Tom",
        "generator.tone_normal": "Normale",
        "generator.tone_formal": "Officiel",
        "generator.tone_fun": "Amusant",
        "generator.tone_informal": "Informel",
        "generator.tone_informative": "Informatif",
        "generator.tone_inspiring": "Inspirant",
        "generator.tone_polemic": "Controversé",
        "generator.tone_curious": "Curiosité",
        "generator.objective": "But",
        "generator.objective_authority": "Autorité",
        "generator.objective_sales": "Ventes",
        "generator.objective_custom": "Coutume",
        "generator.authority_list": "Liste",
        "generator.authority_opinion": "Avis",
        "generator.authority_question": "Question",
        "generator.authority_checklist": "Liste de contrôle",
        "generator.authority_news": "Nouvelles",
        "generator.authority_trivia": "Anecdotes",
        "generator.content_type": "Type de contenu",
        "generator.authority_faq": "Doutes",
        "generator.authority_tips": "Conseils",
        "generator.authority_tutorial": "Tutoriels",
        "generator.authority_myths": "Mythes et vérités",
        "generator.authority_errors": "Erreurs courantes",
        "generator.authority_trends": "Nouvelles",
        "generator.sales_hooks": "Déclencheurs de vente",
        "generator.sales_benefits": "Avantages",
        "generator.sales_features": "Caractéristiques",
        "generator.sales_offers": "Offres",
        "generator.sales_cta": "Appel à l'action",
        "generator.sales_social_proof": "Preuves sociales",
        "generator.tone_tooltip": "Ton de voix de vos messages",
        "generator.objective_tooltip": "Les publications d’autorité aident à mettre en valeur votre expertise dans le domaine. Les publications de vente sont utilisées pour promouvoir un produit ou un service.",
        "generator.format_tooltip": "Format de sortie de votre message",
        "generator.include_related_tooltip": "Inclure des sujets connexes pour offrir une plus grande variété de contenu",
        "generator.include_profile": "En rapport avec mon entreprise",
        "generator.include_profile_tooltip": "Choisissez si les publications générées doivent être liées à votre entreprise ou si elles doivent être plus génériques",
        "generator.size": "Taille du titre",
        "generator.size_short": "Court",
        "generator.size_medium": "Moyenne",
        "generator.size_long": "Loin",
        "error.media_in_use": "Cette image est utilisée dans un article et ne peut pas être supprimée.",
        "success.cancel_account": "Compte annulé avec succès !",
        "error.fill_required_fields": "Remplissez tous les champs obligatoires",
        "generator.media_format": "Type de fichier de publication",
        "generator.media_format_image": "Image",
        "generator.media_format_video": "Vidéo",
        "generator.hasCaption": "Avez-vous une légende prête ?",
        "generator.post_format": "Format",
        "generator.post_format_post": "Poste",
        "generator.post_format_reels": "Bobines",
        "generator.post_format_story": "Story",
        "error.format_post_not_support_media": "Le format de publication choisi ne prend pas en charge ce type de média",
        "error.limit_posts_per_format": "Le format de publication choisi ne prend pas en charge autant de fichiers",
        "label.content_already_generated": "Votre publication a déjà généré du contenu. Voulez-vous écraser les pages du carrousel ? La première page sera conservée.",
        "error.post_duration_exceeded": "La durée de la publication a dépassé la limite maximale de %s secondes."
    },
    "de": {
        "instagram.handle.error": "Instagram-Profil konnte nicht gefunden werden",
        "error.generating.content": "Der Inhalt konnte nicht generiert werden",
        "error.saving.post": "Beitrag konnte nicht gespeichert werden",
        "success.saving.post": "Beitrag erfolgreich gespeichert",
        "error.validation.context": "Bitte füllen Sie alle Felder aus",
        "error.validation.email": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        "error.imageLoading": "Warten Sie etwas, wir laden das Beitragsbild",
        "instagram.handle.at_removed": "Kein @ erforderlich, nur der Profilname",
        "info.config.show": "Klicken Sie auf das Beitragsbild, um Farben, Schriftarten und andere Details zu bearbeiten",
        "error.invalid.image": "Fehler beim hochladen des Bildes",
        "success.trial_started": "Willkommen zur Magic Editor-Testversion 🥳",
        "error.starting_trial": "Der Test konnte nicht gestartet werden",
        "category.all": "Alle",
        "category.images": "Bilder",
        "category.cover": "Abdeckung",
        "category.slide": "Gleiten",
        "category.news": "Nachricht",
        "category.social": "Sozial",
        "category.quote": "Zitat",
        "category.question": "Frage",
        "category.list": "Liste",
        "category.number": "Liste",
        "category.checklist": "Checklist",
        "category.before-after": "Vorher und Nachher",
        "category.trivia": "Wissenswertes",
        "error.invalid.image_must_be_png": "Das Bild muss im PNG-Format mit transparentem Hintergrund vorliegen",
        "error.project.create": "Projekt konnte nicht erstellt werden",
        "source.Save Post": "Beitrag speichern",
        "source.Preview Post": "Beitragsvorschau",
        "source.Download Post": "Beitrag herunterladen",
        "source.Refresh Keywords": "Schlüsselwörter aktualisieren",
        "source.Upload Logo": "Logo hochladen",
        "source.Upload Social Logo": "Profilbild hochladen",
        "source.Publish Item": "Artikel veröffentlichen",
        "source.Edit Item": "Element bearbeiten",
        "source.Save Item": "Artikel speichern",
        "source.Captions Item": "Untertitel generieren",
        "source.Generated once but not logged in": "Generieren Sie mehr Beiträge",
        "source.Generated once but not customer": "Generieren Sie mehr Beiträge",
        "source.Max projects reached": "Fügen Sie weitere Projekte hinzu",
        "source.Publish Post Directly": "Veröffentlichen Sie Beiträge direkt auf Instagram",
        "source.Schedule Posts": "Planen Sie Beiträge auf Instagram",
        "source.Generate Audience": "Publikum generieren",
        "source.Generate Audience Needs": "Generieren Sie Zielgruppenbedürfnisse",
        "source.Generate Audience Goals": "Generieren Sie Zielgruppenziele",
        "source.Generate Captions": "Untertitel generieren",
        "source.Create Scratch": "Erstellen Sie einen Beitrag von Grund auf",
        "source.Custom Fonts": "Benutzerdefinierte Schriftarten hochladen",
        "source.Use my medias": "Benutze meine Bilder",
        "source.Edit Themes": "Themen bearbeiten",
        "source.Bulk Edit": "Massenbearbeitung von Beiträgen",
        "source.Save Replan": "Planung von Beiträgen speichern",
        "source.Remove Schedule": "Zeitplan entfernen",
        "source.Pin Post": "Lieblingsbeitrag",
        "source.Finish Theme Selection": "Beenden Sie die Themenauswahl",
        "source.Regenerate Post": "Beitrag neu generieren",
        "source.Change Calendar Range": "Kalenderbereich ändern",
        "source.Remove Post": "Beitrag entfernen",
        "source.Edit Post": "Beitrag bearbeiten",
        "source.Skip Day": "Tag überspringen",
        "source.Publish Reels": "Erstellen und veröffentlichen Sie Rollen",
        "source.Add more products": "Weitere Produkte hinzufügen",
        "source.Save Post Calendar": "Beitrag speichern",
        "source.Select Audio": "Musik auswählen",
        "source.Select Video": "Video auswählen",
        "plan.filter.monthly": "Monatlich",
        "plan.filter.annual": "Jährlich",
        "features.infinite_ideas": "Unbegrenzte Ideen für Beiträge",
        "features.custom_style": "Anpassung der Beiträge",
        "features.integrated_publishing": "Automatische Veröffentlichung",
        "features.unlimited_accounts": "Unbegrenzte Konten",
        "features.1_account": "1 soziales Konto",
        "features.accounts": "Firmen",
        "features.reels": "Rollen und posten Sie Animationen",
        "features.audio": "Musik in Beiträgen",
        "features.custom_videos": "Videothek",
        "features.unlimited_posts": "Unbegrenzte Beiträge",
        "label.plans_trial_days": "14 Tage kostenlos testen",
        "label.plans_cancel_anytime": "Jederzeit kündbar",
        "error.upgrade_plan": "Beim Upgrade des Plans ist ein Fehler aufgetreten. Versuchen Sie es erneut",
        "error.not_possible_find_instagram_account": "Haben Sie Ihr Instagram-Konto nicht gefunden?",
        "label.to_connect_you_need": "Verbinden:",
        "label.no_instagram_enabled": "Mit dieser Seite ist kein Instagram verknüpft",
        "error.please_select_page": "Bitte wählen Sie eine Seite aus",
        "error.please_select_target": "Wählen Sie aus, wo Sie veröffentlichen möchten",
        "error.please_select_format": "Wählen Sie das Beitragsformat",
        "error.scheduling_post": "Der Beitrag konnte nicht geplant werden. Versuchen Sie es erneut",
        "error.creating_scratch": "Fehler beim Erstellen des Beitrags",
        "error.authenticating_facebook": "Die Authentifizierung bei Facebook konnte nicht durchgeführt werden. Versuchen Sie es erneut",
        "success.scheduling_post": "Beitrag erfolgreich geplant!",
        "success.scheduling_post_limit": "Beitrag erfolgreich geplant! Obwohl wir keine Planungslimits haben, kann die Planung mehrerer Beiträge am selben Tag auf Instagram/Facebook zu Einschränkungen Ihres Profils führen. Wir empfehlen, maximal drei Beiträge pro Tag zu planen.",
        "scratch.post1.title": "Titel Ihres Beitrags zu <b>einem beliebigen Thema</b>",
        "scratch.post1.description": "Schreiben Sie in die nächste Zeile, um die Beschreibung zu erhalten",
        "scratch.post2.title": "Lassen Sie in einer neuen Zeile Platz, um ein neues Bild zu beginnen",
        "scratch.post3.title": "Markieren Sie <b>relevante Teile, die Sie hervorheben möchten, fett</b>",
        "scratch.post4.title": "<b>1.</b> Markieren Sie am Anfang fett gedruckte Zahlen, um eine Liste zu erstellen",
        "scratch.post5.title": "<b>2.</b> Klicken Sie auf ein beliebiges Bild, um Bilder, Layout, Schriftarten und Farben zu bearbeiten",
        "error_publish.too_many_items": "Instagram erlaubt maximal 10 Beiträge pro Karussell. Entfernen Sie einige Inhalte, um fortzufahren.",
        "error_publish.no_content": "Sie müssen dem Beitrag Inhalte hinzufügen, um fortzufahren.",
        "error_publish.caption_too_long": "Die Überschrift des Beitrags darf nicht mehr als 2000 Zeichen lang sein.",
        "error_publish.too_many_hashtags": "Sie können maximal 30 Hashtags pro Post hinzufügen.",
        "error_publish.no_caption": "Sie müssen dem Beitrag eine Bildunterschrift hinzufügen",
        "error_publish.already_scheduled": "Dieser Beitrag wurde bereits auf dieser Seite veröffentlicht",
        "instagram.handle.too_long": "Instagram-Handle ist zu lang. Sind Sie sicher, dass es richtig ist?",
        "success.canceling_publish": "Beitrag erfolgreich abgebrochen!",
        "error.canceling_publish": "Der Beitrag konnte nicht abgebrochen werden. Versuchen Sie es erneut",
        "label.how_to_connect_instagram": "Klicken Sie hier, um zu erfahren, wie Sie Ihr Instagram-Konto mit Galilai verbinden",
        "plan.upgraded": "Plan erfolgreich aktualisiert!",
        "tags.all": "zeige alles",
        "tags.base": "kein Hintergrund",
        "tags.blob": "Klecks",
        "tags.lines": "Linien",
        "tags.waves": "Wellen",
        "tags.swipe": "wischen",
        "tags.circles": "Kreise",
        "tags.points": "Punkte",
        "tags.corner": "Ecke",
        "elements.h1": "Titel",
        "elements.p": "Beschreibung",
        "elements.image": "Bild",
        "elements.overlay": "Element",
        "elements.span": "Text",
        "elements.rect": "Rechteck",
        "elements.circle": "Kreis",
        "elements.trapezoid": "Trapez",
        "elements.svg": "Grafik",
        "icons.suggested.arrow": "Pfeil",
        "icons.suggested.heart": "Herz",
        "icons.suggested.bubble": "Blase",
        "icons.suggested.shopping": "Einkaufen",
        "icons.suggested.phone": "Telefon",
        "icons.suggested.local": "lokal",
        "icons.suggested.star": "Stern",
        "error.publish_reels_not_supported": "Rollen werden noch nicht unterstützt",
        "error.you_need_to_reconnect_for_facebook_permissions": "Sie müssen Ihr Facebook-Konto erneut verbinden, um die Berechtigungen zum Veröffentlichen zu erhalten",
        "label.already_caption_filled": "Es wurde bereits eine Beschriftung erstellt. Möchten Sie diese überschreiben?",
        "label.type_search": "Tippe um zu suchen",
        "label.colors_theme": "Themen",
        "label.colors_custom": "Brauch",
        "label.colors_picker": "Wählen Sie aus meinem Logo",
        "label.main_color": "Hauptfarbe",
        "label.text_color": "Textfarbe",
        "label.accent_color": "Akzentfarbe",
        "label.project": "Projekt",
        "button.upload_file_detect_color": "Senden Sie ein Bild, um die Farben zu identifizieren",
        "label.click_to_edit_color": "Farbe bearbeiten",
        "label.click_to_select_color": "Wähle Farbe",
        "error.please_add_caption": "Sie müssen dem Beitrag eine Bildunterschrift hinzufügen",
        "label.month_long_1": "Januar",
        "label.month_long_2": "Februar",
        "label.month_long_3": "Marsch",
        "label.month_long_4": "April",
        "label.month_long_5": "Mai",
        "label.month_long_6": "Juni",
        "label.month_long_7": "Juli",
        "label.month_long_8": "August",
        "label.month_long_9": "September",
        "label.month_long_10": "Oktober",
        "label.month_long_11": "November",
        "label.month_long_12": "Dezember",
        "label.month_short_1": "Jan",
        "label.month_short_2": "Febr",
        "label.month_short_3": "Beschädigen",
        "label.month_short_4": "Apr",
        "label.month_short_5": "Mai",
        "label.month_short_6": "Jun",
        "label.month_short_7": "Juli",
        "label.month_short_8": "Aug",
        "label.month_short_9": "Sept",
        "label.month_short_10": "Okt",
        "label.month_short_11": "Nov",
        "label.month_short_12": "Dez",
        "error.empty_post_text_caption": "Ihr Beitrag ist leer. Fügen Sie einen Text hinzu, um eine Überschrift zu erstellen",
        "label.publish_status_pending": "Ausstehende Bearbeitung",
        "label.publish_status_initial": "Geplant",
        "label.publish_status_published": "Veröffentlicht",
        "label.publish_status_error": "Fehler beim Veröffentlichen",
        "error.calendar_full": "Der Kalender ist voll. Gehen Sie zum nächsten Monat, um weitere Beiträge zu planen oder Ihre Einstellungen für die Beitragsplanung zu ändern.",
        "label.calendar_other_themes": "andere Themen",
        "label.calendar_other_theme": "anderes Thema",
        "label.calendar_replan_success": "Beiträge erfolgreich aktualisiert",
        "error.calendar_replan_error": "Fehler beim Aktualisieren der Beiträge",
        "error.calendar_no_posts": "Keine Beiträge zum Bearbeiten vorhanden. Klicken Sie auf „Generieren“, um Beiträge zu erstellen.",
        "error.calendar_no_topics": "Wählen Sie mindestens ein Thema aus, um Beiträge zu generieren",
        "error.generate_empty_profile": "Ihr Profil ist leer. Beschreiben Sie kurz, was Ihr Unternehmen ist",
        "error.not_logged_in": "Sie sind nicht angemeldet. Melden Sie sich an, um fortzufahren",
        "error.loading.post": "Beim Laden des Beitrags ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
        "error.calendar_drop_past": "Sie können Beiträge nicht auf vergangene Daten ziehen",
        "error.calendar_topic_exists": "Dieses Thema existiert bereits",
        "label.today": "Heute",
        "label.help_modal": "Hilfezentrum",
        "error_publish.media_error": "Beim Hochladen Ihrer Bilder ist ein Fehler aufgetreten. Bitte versuche es erneut.",
        "error_publish.invalid_images": "Beim Hochladen Ihrer Bilder ist ein Fehler aufgetreten. Bitte versuche es erneut.",
        "error_publish.invalid_page": "Die ausgewählte Seite ist ungültig. Haben Sie die Verbindung mit Facebook geändert? Beispiel: Wenn Sie sich mit einem neuen Facebook-Konto anmelden, sind die zuvor verbundenen Seiten nicht mehr verfügbar.",
        "error_publish.carousel_error": "Beim Veröffentlichen des Karussells ist ein Fehler aufgetreten. Bitte versuche es erneut.",
        "error_publish.invalid_caption": "Die Bildunterschrift ist zu lang oder enthält mehr als 40 Hashtags. Bitte bearbeiten Sie die Überschrift und versuchen Sie es erneut.",
        "error_publish.invalid_instagram_account": "Ungültiges Instagram-Konto oder kein Unternehmenstyp. Haben Sie die Verbindung mit Facebook geändert? Beispiel: Wenn Sie sich mit einem neuen Facebook-Konto angemeldet haben, sind die zuvor verbundenen Seiten nicht mehr verfügbar.",
        "error_publish.instagram_business_error": "Das Instagram-Konto ist kein Geschäftskonto. Bitte wandeln Sie Ihr Konto in ein Geschäftskonto um, um fortzufahren.",
        "error_publish.user_restricted": "Ihr Instagram- oder Facebook-Konto ist möglicherweise eingeschränkt. Rufen Sie <a target='_blank' href='https://www.facebook.com/business-support-home/?landing_page=overview'>diesen Link</a> auf, um die Einschränkungen zu prüfen und zu erfahren, wie Sie Ihr Konto entsperren können.",
        "error_publish.rate_limit": "Obwohl wir keine Begrenzung für Beiträge haben, gibt es bei Instagram/Facebook eine Begrenzung. Wenn Sie weiterhin viele Beiträge pro Tag veröffentlichen, kann dies zu einer Sperrung Ihres Kontos führen. Wir empfehlen Ihnen, heute mit dem Posten aufzuhören und es morgen mit einer geringeren Anzahl von Beiträgen erneut zu versuchen, bis die Beschränkung aufgehoben wird.",
        "error_publish.publish_error": "Beim Veröffentlichen ist ein Fehler aufgetreten. Bitte versuche es erneut.",
        "error_publish.publish_error_story": "Beim Veröffentlichen der Geschichte ist ein Fehler aufgetreten. Bitte versuche es erneut.",
        "error_publish.publish_error_carousel": "Beim Veröffentlichen des Karussells ist ein Fehler aufgetreten. Bitte versuche es erneut.",
        "error_publish.reauth_required": "Sie müssen Ihr Facebook-Konto erneut verbinden. Klicken Sie bitte auf „Meine Seiten verbinden“ und folgen Sie den Anweisungen.",
        "error.generic": "Unerwarteter Fehler. Bitte versuche es erneut",
        "error.calendar_topic_length": "Das Thema muss zwischen 3 und 150 Zeichen lang sein",
        "label.post_type_carousel": "Karussell",
        "label.post_type_single": "Einzelner Beitrag",
        "label.import_tabs_image": "Bilder",
        "label.import_tabs_text": "Texte",
        "label.import_tabs_background": "Formen",
        "label.import_tabs_colors": "Farben",
        "label.import_tabs_fonts": "Schriftarten",
        "label.import_option_title": "Titel",
        "label.import_option_description": "Beschreibung",
        "label.import_option_fixed_text": "Fester Text",
        "label.import_option_main_image": "Hauptbild",
        "label.import_option_fixed_image": "Festes Bild",
        "label.import_option_email": "Email",
        "label.import_option_address": "Adresse",
        "label.import_option_phone": "Telefon",
        "label.import_option_website": "Webseite",
        "label.import_option_person_image": "Personenbild",
        "label.import_option_list_item": "Listenpunkt",
        "label.import_option_list_cta": "Aufruf zum Handeln",
        "label.import_option_main_color": "Hauptfarbe",
        "label.import_option_text_color": "Textfarbe",
        "label.import_option_highlight_color": "Hervorhebungsfarbe",
        "label.import_option_font_title": "Überschrift",
        "label.import_option_font_body": "Schriftart des Hauptteils",
        "label.import_option_font_subtitle": "Untertitelschriftart",
        "label.import_hide": "Verstecken",
        "label.import_main_color": "Hauptfarbe",
        "label.import_number": "Nummer",
        "label.import_author_handle": "Handhaben",
        "label.remove_project_confirm": "Möchten Sie das Projekt wirklich löschen? Alle Beiträge aus diesem Projekt werden gelöscht.",
        "error.remove_project_last": "Sie können Ihr einziges Projekt nicht entfernen",
        "label.import_layout_success": "Layout erfolgreich importiert",
        "label.import_option_contextual_fixed_image": "Festes Bild (Kontextbezogen)",
        "label.success_generic": "Erfolg!",
        "success.generic": "Erfolg!",
        "label.are_you_sure": "Bist du sicher?",
        "label.professional_area": "Ich arbeite im Bereich",
        "label.profile_handle": "@mein Profil",
        "label.profile_name": "Mein Name",
        "area_business.medicine": "Medizin",
        "area_business.psychology": "Psychologie",
        "area_business.law": "Gesetz",
        "area_business.wellness": "Gesundheit & Wohlbefinden",
        "area_business.education": "Ausbildung",
        "area_business.personal_care": "Körperpflege",
        "area_business.cosmetics": "Kosmetika",
        "area_business.fitness": "Fitness",
        "area_business.finance": "Finanzen",
        "area_business.accounting": "Buchhaltung",
        "area_business.construction": "Konstruktion",
        "area_business.real_estate": "Immobilie",
        "area_business.architecture": "Die Architektur",
        "area_business.tech": "Technologie",
        "area_business.pets": "Haustiere",
        "area_business.coaching": "Coaching",
        "area_business.clothing": "Mode",
        "area_business.restaurant": "Restaurant",
        "area_business.automotive": "Automobilindustrie",
        "area_business.transport": "Transport",
        "label.media_select_image": "Wählen Sie ein Bild aus",
        "label.media_select_audio": "Wählen Sie ein Audio",
        "label.media_select_video": "Wählen Sie ein Video aus",
        "label.media_select_elements": "Wählen Sie ein Element aus",
        "label.media_select_fonts": "Auswählen einer Schriftart",
        "label.media_select_product": "Wählen Sie ein Produkt oder eine Dienstleistung aus",
        "tab.media_icons_database": "Symbole",
        "tab.media_images_database": "Bilddatenbank",
        "tab.media_audio_database": "Musikdatenbank",
        "tab.media_video_database": "Videodatenbank",
        "tab.media_my_fonts": "Meine Schriftarten",
        "tab.media_my_images": "Meine Bilder",
        "tab.media_my_audio": "Meine Musik",
        "tab.media_my_video": "Meine Videos",
        "tab.media_my_products": "Meine Produkte und Dienstleistungen",
        "btn.remove_bg": "Hintergrund entfernen",
        "btn.remove": "Entfernen",
        "btn.select": "Wählen",
        "label.folder_home": "Alle",
        "tag.audio_all": "Alle",
        "tag.audio_upbeat": "Optimistisch",
        "tag.audio_happy": "Glücklich",
        "tag.audio_inspiring": "Inspirierend",
        "tag.audio_chill": "Kühlen",
        "label.need_to_increase_quantity": "Sie müssen die Anzahl der Unternehmen in Ihrem Plan erhöhen",
        "label.multiple_pages": "Mehrere Seiten",
        "label.one_page": "Eine Seite",
        "error.rendering_post": "Fehler beim Herunterladen des Beitrags. Bitte versuchen Sie es erneut",
        "label.otp_verified_mobile": "Ihre Anmeldung war erfolgreich! Kehren Sie zur App zurück, um fortzufahren.",
        "label.otp_verified": "Ihre Anmeldung war erfolgreich!",
        "success.connected_facebook_app": "Sie haben Ihre Social-Media-Konten erfolgreich verbunden! Kehren Sie bitte zur mobilen App zurück, um fortzufahren.",
        "label.app_update_available": "Eine neue Version der App ist verfügbar. Aktualisieren Sie, um auf neue Funktionen zuzugreifen.",
        "label.app_update_available_required": "Eine neue Version der App ist verfügbar. Aktualisieren Sie, um die App weiterhin verwenden zu können.",
        "tab.favorites": "Favoriten",
        "error.missing_project_favorite": "Gehen Sie zur Registerkarte Favoriten und wählen Sie zunächst ein Projekt aus",
        "label.my_text": "Mein Text",
        "label.remove_generic": "Möchten Sie es wirklich entfernen?",
        "label.confirm_reset_layout": "Möchten Sie die Formatierung wirklich entfernen? Das Layout wird auf die Standardeinstellung zurückgesetzt.",
        "error.invalid.file_type": "Ungültiger Dateityp",
        "success.copy_clipboard": "In die Zwischenablage kopiert!",
        "label.remove_all_posts_confirm": "Möchten Sie wirklich alle Beiträge löschen? Sie können sie nicht wiederherstellen.",
        "label.post_should_be_tall": "Der von Ihnen gewählte Beitragstyp sollte eine vertikale Größe verwenden, da er sonst beim Posten abgeschnitten wird. Möchten Sie ihn trotzdem ändern?",
        "label.my_palletes": "Meine Paletten",
        "label.my_colors": "Meine Farben",
        "label.generic_add": "Hinzufügen",
        "label.generic_edit": "Bearbeiten",
        "label.generic_save": "Speichern",
        "label.generic_remove": "Entfernen",
        "label.generic_cancel": "Stornieren",
        "label.add_new_pallete": "Neue Palette hinzufügen",
        "label.apply_pallete": "Palette verwenden",
        "label.title_font_header": "Titel",
        "label.description_font_header": "Beschreibung",
        "label.text_min_size": "Mindestgröße",
        "label.text_max_size": "Maximalgröße",
        "label.font_size_info": "Die Schriftgrößen werden automatisch angepasst, um eine optimale Lesbarkeit zu gewährleisten. Passen Sie zum Anpassen die Mindest- und Höchstwerte an. Um eine bestimmte Größe festzulegen, klicken Sie auf den Text und passen Sie ihn direkt an.",
        "label.text_min_size_tooltip": "Minimale Schriftgröße, wenn viel Text vorhanden ist und dieser verkleinert werden muss, um in den verfügbaren Platz zu passen.",
        "label.text_max_size_tooltip": "Standard- und Maximalgröße der Schriftart, die angepasst werden kann.",
        "label.feature_contact_support": "Kontaktieren Sie den Support, um diese Funktion zu aktivieren. Möchten Sie einen Chat starten?",
        "label.iap_info_ios": "Abonnements werden über Ihr iTunes-Konto von Ihrer Kreditkarte abgebucht. Abonnements verlängern sich automatisch, sofern sie nicht innerhalb von 24 Stunden vor Ablauf der aktuellen Laufzeit gekündigt werden. Sie können jederzeit in den Einstellungen Ihres iTunes-Kontos kündigen.",
        "error.iap_other_account": "Sie haben ein aktives Abonnement mit einer anderen E-Mail-Adresse. Bitte melden Sie sich mit der richtigen E-Mail-Adresse an.",
        "error.invalid.product": "Name und Bilder sind erforderlich.",
        "error.invalid.product.name": "Name ist erforderlich.",
        "error.invalid.product.price": "Preis ist erforderlich.",
        "error.invalid.product.url": "Bild ist erforderlich.",
        "error.invalid.product.project": "Sie müssen ein Projekt auswählen, um ein Produkt hinzuzufügen.",
        "error.select_product": "Wählen Sie mindestens ein Produkt/eine Dienstleistung aus.",
        "error.select_media": "Wählen Sie mindestens ein Bild aus.",
        "error.select_themes": "Wählen Sie mindestens ein Thema aus.",
        "error.select_a_post": "Wählen Sie mindestens einen Beitrag aus.",
        "error.type_context": "Geben Sie eine Anweisung zum Generieren von Posts ein.",
        "error.max_media_items": "Sie können maximal 5 Artikel auswählen.",
        "error.save_posts": "Fehler beim Speichern der Beiträge.",
        "label.mode_themes": "Themen auswählen",
        "label.mode_themes_description": "Wählen Sie die Themen aus, die Sie ansprechen möchten",
        "label.mode_product": "Produkt oder Dienstleistung",
        "label.mode_product_description": "Wählen Sie ein Produkt oder eine Dienstleistung aus, über die Sie sprechen möchten",
        "label.mode_dates": "Gedenkdaten",
        "label.mode_dates_description": "Wählen Sie ein Gedenkdatum",
        "label.mode_media": "Bild",
        "label.mode_media_description": "Wählen Sie ein oder mehrere Bilder aus",
        "label.mode_instruction": "Anweisung",
        "label.mode_instruction_description": "Beschreiben Sie, was Sie brauchen",
        "label.mode_link": "Link",
        "label.mode_link_description": "Fügen Sie einen Link ein, um einen Beitrag zu generieren",
        "label.mode_empty": "Leerer Beitrag",
        "label.mode_empty_description": "Einen Beitrag von Grund auf erstellen",
        "label.mode_existing": "Beitrag planen",
        "label.mode_existing_description": "Planen Sie ein Bild/Video",
        "layout.smart_any": "Beliebig",
        "layout.smart_title_grid": "Netz",
        "layout.smart_vertical": "Vertikal",
        "layout.smart_horizontal": "Horizontal",
        "layout.smart_title_style": "Stil",
        "layout.smart_geometric": "Geometrisch",
        "layout.smart_rounded": "Gerundet",
        "layout.smart_title_shader": "Aussehen",
        "layout.smart_flat": "Wohnung",
        "layout.smart_gradient": "Gradient",
        "layout.smart_pattern": "Muster",
        "layout.smart_3d": "3D",
        "layout.smart_title_orientation": "Bildposition",
        "layout.smart_begin": "Beginnen",
        "layout.smart_end": "Ende",
        "layout.smart_title_alignment": "Ausrichtung",
        "layout.smart_left": "Links",
        "layout.smart_center": "Center",
        "layout.smart_right": "Rechts",
        "layout.smart_title_focus": "Fokus",
        "layout.smart_text": "Text",
        "layout.smart_balanced": "Ausgewogen",
        "layout.smart_fullscreen": "Vollbild",
        "layout.smart_title_decorative": "Dekorativ",
        "layout.smart_yes": "Ja",
        "layout.smart_no": "NEIN",
        "layout.smart_title_include_shapes": "Formen",
        "error.generator_no_content": "In diesem Link konnte kein Inhalt gefunden werden.",
        "error.generator_no_link": "Bitte fügen Sie einen Link ein",
        "gen.product.objective": "Zielsetzung",
        "gen.product.price": "Preis",
        "gen.product.info": "Information",
        "gen.product.cta": "Aufruf zum Handeln",
        "gen.product.discount": "Rabatt",
        "tab.media_my_videos": "Meine Videos",
        "tab.media_videos_database": "Videodatenbank",
        "error.invalid.max_size": "Die maximale Dateigröße muss %s betragen.",
        "label.too_long_video": "Beiträge dürfen höchstens %s Minuten lang sein.",
        "label.affiliate_created": "Erstellen Sie Ihren Partnercode",
        "label.affiliate_message": "Gib nur den Code ein, dieser sieht beim Teilen dann so aus:",
        "label.affiliate_code_name": "IHRCODE",
        "error.affiliate.code_exists": "Partnercode wird verwendet. Bitte wählen Sie einen anderen.",
        "generic.no": "NEIN",
        "generic.yes": "Ja",
        "generator.include_related": "Verwandte Themen einbeziehen?",
        "generator.tone": "Tonfall",
        "generator.tone_normal": "Normal",
        "generator.tone_formal": "Formell",
        "generator.tone_fun": "Spaß",
        "generator.tone_informal": "Informell",
        "generator.tone_informative": "Informativ",
        "generator.tone_inspiring": "Inspirierend",
        "generator.tone_polemic": "Polemik",
        "generator.tone_curious": "Neugier",
        "generator.objective": "Zielsetzung",
        "generator.objective_authority": "Behörde",
        "generator.objective_sales": "Verkäufe",
        "generator.objective_custom": "Brauch",
        "generator.authority_list": "Liste",
        "generator.authority_opinion": "Meinung",
        "generator.authority_question": "Frage",
        "generator.authority_checklist": "Checklist",
        "generator.authority_news": "Nachricht",
        "generator.authority_trivia": "Wissenswertes",
        "generator.content_type": "Inhaltstyp",
        "generator.authority_faq": "Fragen und Antworten",
        "generator.authority_tips": "Tipps",
        "generator.authority_tutorial": "Anleitungen",
        "generator.authority_myths": "Mythen und Wahrheiten",
        "generator.authority_errors": "Häufige Fehler",
        "generator.authority_trends": "Trends",
        "generator.sales_hooks": "Verkaufshaken",
        "generator.sales_benefits": "Vorteile",
        "generator.sales_features": "Merkmale",
        "generator.sales_offers": "Angebote",
        "generator.sales_cta": "Aufruf zum Handeln",
        "generator.sales_social_proof": "Sozialer Beweis",
        "generator.tone_tooltip": "Tonfall Ihrer Beiträge",
        "generator.objective_tooltip": "Autoritätsbeiträge helfen, Ihr Wissen in diesem Bereich zu zeigen. Verkaufsbeiträge werden verwendet, um ein Produkt oder eine Dienstleistung zu bewerben",
        "generator.format_tooltip": "Ausgabeformat Ihres Beitrags",
        "generator.include_related_tooltip": "Fügen Sie verwandte Themen hinzu, um die Inhalte abwechslungsreicher zu gestalten",
        "generator.size": "Titelgröße",
        "generator.size_short": "Kurz",
        "generator.size_medium": "Mittel",
        "generator.size_long": "Lang",
        "generator.include_profile": "Im Zusammenhang mit meinem Geschäft",
        "generator.include_profile_tooltip": "Wählen Sie, ob die generierten Beiträge sich auf Ihr Unternehmen beziehen oder allgemeiner sein sollen",
        "error.media_in_use": "Dieses Bild wird in einem Beitrag verwendet und kann nicht entfernt werden",
        "success.cancel_account": "Konto erfolgreich gekündigt!",
        "error.fill_required_fields": "Bitte füllen Sie alle Pflichtfelder aus",
        "generator.media_format": "Post-Dateityp",
        "generator.media_format_image": "Bild",
        "generator.media_format_video": "Video",
        "generator.hasCaption": "Haben Sie eine Beschriftung erstellt?",
        "generator.post_format": "Format",
        "generator.post_format_post": "Post",
        "generator.post_format_reels": "Rollen",
        "generator.post_format_story": "Story",
        "error.format_post_not_support_media": "Das ausgewählte Postformat unterstützt diesen Medientyp nicht",
        "error.limit_posts_per_format": "Das ausgewählte Postformat unterstützt nicht so viele Dateien",
        "label.content_already_generated": "Ihr Beitrag enthält bereits generierten Inhalt. Möchten Sie die Karussellseiten überschreiben? Die erste Seite bleibt erhalten.",
        "error.post_duration_exceeded": "Die Dauer des Posts hat das maximale Limit von %s Sekunden überschritten."
    },
    "it": {
        "instagram.handle.error": "Impossibile trovare il profilo Instagram",
        "error.generating.content": "Impossibile generare contenuto",
        "error.saving.post": "Impossibile salvare il post",
        "success.saving.post": "Post salvato con successo!",
        "error.validation.context": "Si prega di compilare tutti i campi",
        "error.validation.email": "Inserisci un'e-mail valida",
        "error.imageLoading": "Aspetta un attimo, stiamo caricando l'immagine del post",
        "instagram.handle.at_removed": "Non hai bisogno della @, solo del nome del profilo",
        "info.config.show": "Fai clic sull'immagine del post per modificare colori, caratteri e altri dettagli",
        "error.invalid.image": "Errore durante il caricamento dell'immagine",
        "success.trial_started": "Benvenuto nel periodo di prova di Magic Editor 🥳!",
        "error.starting_trial": "Impossibile avviare il periodo di prova",
        "category.all": "Tutto",
        "category.images": "Immagini",
        "category.cover": "Strato",
        "category.slide": "Giostra",
        "category.news": "Notizia",
        "category.social": "Sociale",
        "category.quote": "Citazione",
        "category.question": "Domanda",
        "category.list": "Lista",
        "category.number": "Lista",
        "category.checklist": "Lista di controllo",
        "category.before-after": "Prima e dopo",
        "category.trivia": "Curiosità",
        "error.invalid.image_must_be_png": "L'immagine deve essere PNG con uno sfondo trasparente",
        "error.project.create": "Impossibile creare il progetto",
        "error.creating_scratch": "Impossibile creare il post",
        "source.Save Post": "Salva un messaggio",
        "source.Preview Post": "Visualizza un messaggio",
        "source.Download Post": "Scarica un messaggio",
        "source.Refresh Keywords": "Aggiorna le parole chiave",
        "source.Upload Logo": "Aggiorna logo",
        "source.Upload Social Logo": "Aggiorna l'immagine del profilo",
        "source.Publish Item": "Pubblica un messaggio",
        "source.Edit Item": "Modifica un messaggio",
        "source.Save Item": "Salva un messaggio",
        "source.Captions Item": "Genera sottotitoli",
        "source.Generated once but not logged in": "Genera più post",
        "source.Generated once but not customer": "Genera più post",
        "source.Generate Audience": "Identificare il pubblico target",
        "source.Generate Audience Needs": "Identificare le esigenze del pubblico target",
        "source.Generate Audience Goals": "Identificare gli obiettivi del pubblico target",
        "source.Generate Captions": "Genera sottotitoli",
        "source.Create Scratch": "Crea un post da zero",
        "source.Custom Fonts": "Utilizza caratteri personalizzati",
        "source.Use my medias": "Usa le mie immagini",
        "source.Edit Themes": "Modifica temi",
        "source.Bulk Edit": "Modifica post a Massa",
        "source.Save Replan": "Salva pianificazione post",
        "source.Remove Schedule": "Rimuovi pianificazione",
        "source.Pin Post": "Post preferito",
        "source.Finish Theme Selection": "Finalizzare la selezione del tema",
        "source.Regenerate Post": "Genera nuovo messaggio",
        "source.Change Calendar Range": "Modifica periodo di calendario",
        "source.Remove Post": "Posta di rimozione",
        "source.Edit Post": "Modifica post",
        "source.Skip Day": "Salta il giorno",
        "source.Publish Reels": "Crea e pubblica reel",
        "source.Add more products": "Aggiungi altri prodotti",
        "source.Save Post Calendar": "Salva il post nel calendario",
        "source.Select Audio": "Seleziona Musica",
        "source.Select Video": "Seleziona Video",
        "plan.filter.monthly": "Mensile",
        "plan.filter.annual": "Annuale",
        "source.Max projects reached": "Aggiungi altri account",
        "source.Publish Post Directly": "Pubblica post direttamente su Instagram",
        "source.Schedule Posts": "Pianifica post",
        "features.infinite_ideas": "Idee di post illimitate",
        "features.custom_style": "Posta personalizzazione",
        "features.integrated_publishing": "Pubblicazione automatica",
        "features.unlimited_accounts": "Conti illimitati",
        "features.1_account": "1 conto sociale",
        "features.accounts": "aziende",
        "features.reels": "Reels e animazioni dei post",
        "features.audio": "Canzoni nei post",
        "features.custom_videos": "Videoteca",
        "features.unlimited_posts": "Post illimitati",
        "label.plans_trial_days": "Prova gratuita di 14 giorni",
        "label.plans_cancel_anytime": "Annulla in qualsiasi momento",
        "error.upgrade_plan": "Errore durante l'aggiornamento del piano, riprova",
        "error.not_possible_find_instagram_account": "Non riesci a trovare il tuo account Instagram?",
        "label.to_connect_you_need": "Per connetterti è necessario:",
        "label.no_instagram_enabled": "Questa pagina non ha Instagram associato",
        "error.please_select_page": "Seleziona una pagina",
        "error.please_select_target": "Seleziona dove vuoi pubblicare",
        "error.please_select_format": "Seleziona il formato del post",
        "error.scheduling_post": "Impossibile pianificare il post, riprova",
        "error.authenticating_facebook": "Impossibile autenticarsi con Facebook, riprova",
        "success.scheduling_post": "Post pianificato per la pubblicazione con successo!",
        "success.scheduling_post_limit": "Post programmato con successo! Sebbene non ci siano limiti di programmazione, programmare troppi post nello stesso giorno su Instagram/Facebook potrebbe comportare delle restrizioni sul tuo profilo. Consigliamo di programmare un massimo di 3 post al giorno.",
        "scratch.post1.title": "Titolo del tuo post su qualunque <b>argomento</b> tu voglia",
        "scratch.post1.description": "Scrivi nella riga successiva per diventare la descrizione",
        "scratch.post2.title": "Lascia spazio su una nuova riga per iniziare una nuova immagine",
        "scratch.post3.title": "Contrassegna <b>le parti rilevanti in grassetto</b> per evidenziarle",
        "scratch.post4.title": "<b>1.</b> Contrassegna i numeri in grassetto all'inizio per creare un elenco",
        "scratch.post5.title": "<b>2.</b> Fare clic su qualsiasi immagine per modificare immagini, layout, caratteri e colori",
        "error_publish.too_many_items": "Instagram consente un massimo di 10 post per carosello. Rimuovi alcuni contenuti per continuare.",
        "error_publish.no_content": "È necessario aggiungere contenuto al post per continuare.",
        "error_publish.caption_too_long": "La didascalia del post non può contenere più di 2000 caratteri.",
        "error_publish.too_many_hashtags": "Puoi aggiungere un massimo di 30 hashtag per post.",
        "error_publish.no_caption": "Devi aggiungere una didascalia al post",
        "error_publish.already_scheduled": "Questo post è già stato pubblicato su questa pagina",
        "instagram.handle.too_long": "Il nome del profilo Instagram è troppo lungo. Sei sicuro che sia corretto?",
        "success.canceling_publish": "Post cancellato con successo!",
        "error.canceling_publish": "Impossibile annullare il post, riprova",
        "label.how_to_connect_instagram": "Clicca qui per sapere come collegare il tuo account Instagram a Galilai",
        "plan.upgraded": "Piano aggiornato con successo!",
        "tags.all": "mostra tutto",
        "tags.base": "senza fondo",
        "tags.blob": "bolla",
        "tags.lines": "linee",
        "tags.waves": "onde",
        "tags.swipe": "scorrere",
        "tags.circles": "cerchi",
        "tags.points": "punti",
        "tags.corner": "angoli",
        "elements.h1": "Titolo",
        "elements.p": "Descrizione",
        "elements.image": "Immagine",
        "elements.overlay": "Elemento",
        "elements.span": "Testo",
        "elements.rect": "Rettangolo",
        "elements.circle": "Cerchio",
        "elements.trapezoid": "Trapezio",
        "elements.svg": "Grafico",
        "icons.suggested.arrow": "seta",
        "icons.suggested.heart": "cuore",
        "icons.suggested.bubble": "bolla",
        "icons.suggested.shopping": "shopping",
        "icons.suggested.phone": "connessione",
        "icons.suggested.local": "Locale",
        "icons.suggested.star": "stella",
        "error.publish_reels_not_supported": "I rulli non sono ancora supportati, lanceremo presto!",
        "error.you_need_to_reconnect_for_facebook_permissions": "È necessario ricollegare il tuo account Facebook per ottenere le autorizzazioni per pubblicare",
        "label.already_caption_filled": "È già stata creata una didascalia, vuoi sovrascriverla?",
        "label.type_search": "Digita per cercare",
        "label.colors_theme": "Temi",
        "label.colors_custom": "Costume",
        "label.colors_picker": "Identificati tramite il mio logo",
        "label.main_color": "Cor principale",
        "label.text_color": "Colore del testo",
        "label.accent_color": "Colore accento",
        "label.project": "Progetto",
        "button.upload_file_detect_color": "Invia un'immagine per identificare i colori",
        "label.click_to_edit_color": "Modifica cor",
        "label.click_to_select_color": "Seleziona il colore",
        "error.please_add_caption": "Devi aggiungere una didascalia al post",
        "label.month_long_1": "Gennaio",
        "label.month_long_2": "Febbraio",
        "label.month_long_3": "Marzo",
        "label.month_long_4": "Aprile",
        "label.month_long_5": "Maggio",
        "label.month_long_6": "Giugno",
        "label.month_long_7": "Luglio",
        "label.month_long_8": "Agosto",
        "label.month_long_9": "Settembre",
        "label.month_long_10": "Ottobre",
        "label.month_long_11": "Novembre",
        "label.month_long_12": "Dicembre",
        "label.month_short_1": "Gen",
        "label.month_short_2": "Feb",
        "label.month_short_3": "Mar",
        "label.month_short_4": "Abr",
        "label.month_short_5": "Maggio",
        "label.month_short_6": "Giugno",
        "label.month_short_7": "Lug",
        "label.month_short_8": "Fa",
        "label.month_short_9": "Impostato",
        "label.month_short_10": "Fuori",
        "label.month_short_11": "Novembre",
        "label.month_short_12": "Dieci",
        "error.empty_post_text_caption": "Il tuo post è vuoto, aggiungi testo per generare una didascalia",
        "label.publish_status_pending": "Edizione in sospeso",
        "label.publish_status_initial": "Programmato",
        "label.publish_status_published": "Pubblicato",
        "label.publish_status_error": "Errore nella pubblicazione",
        "error.calendar_full": "Il calendario è pieno, vai al mese prossimo per programmare più post o modificare le impostazioni di pianificazione dei post.",
        "label.calendar_other_themes": "altri argomenti",
        "label.calendar_other_theme": "un altro argomento",
        "label.calendar_replan_success": "Post aggiornati con successo",
        "error.calendar_replan_error": "Errore durante l'aggiornamento dei post",
        "error.calendar_no_posts": "Nessun post da modificare, fai clic su Genera per creare post.",
        "error.calendar_no_topics": "Seleziona almeno un argomento per generare post",
        "error.generate_empty_profile": "Il tuo profilo è vuoto, descrivi brevemente la tua attività",
        "error.not_logged_in": "Non hai effettuato l'accesso, effettua l'accesso per continuare",
        "error.loading.post": "Errore durante il caricamento del post, riprova",
        "error.calendar_drop_past": "Non puoi trascinare i post in date passate",
        "error.calendar_topic_exists": "Questo argomento è già stato aggiunto",
        "label.today": "Oggi",
        "label.help_modal": "Centro assistenza",
        "error_publish.media_error": "Si è verificato un errore durante il caricamento delle immagini. Per favore riprova.",
        "error_publish.invalid_images": "Si è verificato un errore durante il caricamento delle immagini. Per favore riprova.",
        "error_publish.invalid_page": "La pagina selezionata non è valida. Ti è capitato di cambiare la tua connessione a Facebook? Ad esempio: se hai effettuato l'accesso con un nuovo account Facebook, le pagine precedentemente collegate non saranno più disponibili.",
        "error_publish.carousel_error": "Si è verificato un errore durante la pubblicazione del carosello. Per favore riprova.",
        "error_publish.invalid_caption": "La didascalia è troppo lunga o contiene più di 40 hashtag. Modifica la didascalia e riprova.",
        "error_publish.invalid_instagram_account": "L'account Instagram non è valido o non è Business. Ti è capitato di cambiare la tua connessione a Facebook? Ad esempio: se hai effettuato l'accesso con un nuovo account Facebook, le pagine precedentemente collegate non saranno più disponibili.",
        "error_publish.instagram_business_error": "L'account Instagram non è un account Business. Converti il tuo account in un account Business e riprova. Dai un'occhiata all'elenco di controllo delle pagine di collegamento per ulteriori informazioni.",
        "error_publish.user_restricted": "Il tuo account Instagram o Facebook potrebbe essere limitato. Visita <a target='_blank' href='https://www.facebook.com/business-support-home/?landing_page=overview'>questo link</a> per verificare le restrizioni e come sbloccare il tuo account. Se qualche account appare in rosso, fai clic per risolvere il problema. In generale è necessario inviare qualche documento per la validazione.",
        "error_publish.rate_limit": "Anche se non abbiamo un limite ai post, Instagram/Facebook ha un limite. Continuare a pubblicare troppi post al giorno potrebbe comportare il blocco del tuo account. Ti suggeriamo di interrompere la pubblicazione per oggi e di riprovare domani con un volume minore di post, finché la restrizione non verrà rimossa.",
        "error_publish.publish_error": "Si è verificato un errore durante la pubblicazione. Per favore riprova.",
        "error_publish.publish_error_story": "Si è verificato un errore durante la pubblicazione della storia. Per favore riprova.",
        "error_publish.publish_error_carousel": "Si è verificato un errore durante la pubblicazione del carosello. Per favore riprova.",
        "error_publish.reauth_required": "Devi connettere nuovamente il tuo account Facebook. Fai clic su \"Collega le mie pagine\" e segui le istruzioni.",
        "error.generic": "Oops! Qualcosa è andato storto. Per favore riprova.",
        "error.calendar_topic_length": "L'oggetto deve contenere da 3 a 150 caratteri",
        "label.post_type_carousel": "Giostra",
        "label.post_type_single": "Posta unica",
        "label.import_tabs_image": "Immagini",
        "label.import_tabs_text": "Testi",
        "label.import_tabs_background": "Forme",
        "label.import_tabs_colors": "Nuclei",
        "label.import_tabs_fonts": "Fonti",
        "label.import_option_title": "Titolo",
        "label.import_option_description": "Descrizione",
        "label.import_option_fixed_text": "Testo fisso",
        "label.import_option_main_image": "Immagine principale",
        "label.import_option_fixed_image": "Fermo immagine",
        "label.import_option_email": "E-mail",
        "label.import_option_address": "Indirizzo",
        "label.import_option_phone": "Telefono",
        "label.import_option_website": "Sito web",
        "label.import_option_person_image": "Immagine del profilo",
        "label.import_option_list_item": "Voce di elenco",
        "label.import_option_list_cta": "Pulsante",
        "label.import_option_main_color": "Cor Principal",
        "label.import_option_text_color": "Colore del testo",
        "label.import_option_highlight_color": "Evidenzia colore",
        "label.import_option_font_title": "Fonte del titolo",
        "label.import_option_font_body": "Fonte corporea",
        "label.import_option_font_subtitle": "Carattere dei sottotitoli",
        "label.import_hide": "Travestimento",
        "label.import_main_color": "Cor Principal",
        "label.import_number": "Numero",
        "label.import_author_handle": "Profilo utente",
        "label.remove_project_confirm": "Sei sicuro di voler rimuovere il progetto? Tutti i post di questo account verranno rimossi.",
        "error.remove_project_last": "Non puoi rimuovere il tuo unico progetto",
        "label.import_layout_success": "Layout importato correttamente",
        "label.import_option_contextual_fixed_image": "Immagine fissa contestuale",
        "label.success_generic": "Successo!",
        "success.generic": "Successo!",
        "label.are_you_sure": "Sei sicuro?",
        "label.professional_area": "Lavoro nel campo della",
        "label.profile_handle": "@meuperfil",
        "label.profile_name": "Il mio nome",
        "area_business.medicine": "Medicinale",
        "area_business.psychology": "Psicologia",
        "area_business.law": "Giusto",
        "area_business.wellness": "Salute e benessere",
        "area_business.education": "Formazione scolastica",
        "area_business.personal_care": "Cure personali",
        "area_business.cosmetics": "Cosmetici",
        "area_business.fitness": "Fitness",
        "area_business.finance": "Finanza",
        "area_business.accounting": "Contabilità",
        "area_business.construction": "Costruzione",
        "area_business.real_estate": "Proprietà",
        "area_business.architecture": "Architettura",
        "area_business.tech": "Tecnologia",
        "area_business.pets": "Animali domestici",
        "area_business.coaching": "Istruire",
        "area_business.clothing": "Moda",
        "area_business.restaurant": "Ristorante",
        "area_business.automotive": "Settore automobilistico",
        "area_business.transport": "Trasporto",
        "label.media_select_image": "Seleziona un'immagine",
        "label.media_select_audio": "Seleziona un audio",
        "label.media_select_video": "Seleziona un video",
        "label.media_select_elements": "Seleziona un elemento",
        "label.media_select_fonts": "Seleziona un carattere",
        "label.media_select_product": "Seleziona un prodotto o un servizio",
        "tab.media_icons_database": "Icone",
        "tab.media_images_database": "Banca di immagini",
        "tab.media_audio_database": "Banca della musica",
        "tab.media_video_database": "Banca video",
        "tab.media_my_images": "Le mie immagini",
        "tab.media_my_fonts": "Le mie fonti",
        "tab.media_my_audio": "Le mie canzoni",
        "tab.media_my_video": "I miei video",
        "tab.media_my_products": "I miei prodotti e servizi",
        "btn.remove_bg": "Rimuovi sfondo",
        "btn.remove": "Dispositivo di rimozione",
        "btn.select": "Selezionare",
        "label.folder_home": "Tutto",
        "tag.audio_all": "Tutto",
        "tag.audio_upbeat": "Vivace",
        "tag.audio_happy": "Contento",
        "tag.audio_inspiring": "Ispirante",
        "tag.audio_chill": "Rilassante",
        "label.need_to_increase_quantity": "è necessario aumentare il numero di aziende nel tuo piano",
        "label.multiple_pages": "Pagine multiple",
        "label.one_page": "Una pagina",
        "error.rendering_post": "Errore durante il download del post. Per favore riprova",
        "label.otp_verified_mobile": "Il tuo accesso è avvenuto con successo! Torna all'app per continuare.",
        "label.otp_verified": "Il tuo accesso è avvenuto con successo!",
        "success.connected_facebook_app": "Hai collegato con successo i tuoi account social! Torna all'app per continuare.",
        "label.app_update_available": "È disponibile una nuova versione dell'applicazione. Aggiorna per accedere a nuove funzionalità.",
        "label.app_update_available_required": "È disponibile una nuova versione dell'applicazione. È necessario aggiornare per continuare.",
        "tab.favorites": "Preferiti",
        "error.missing_project_favorite": "Vai alla scheda Preferiti e scegli prima un progetto",
        "label.my_text": "Il mio testo",
        "label.remove_generic": "Sei sicuro di voler rimuovere?",
        "label.confirm_reset_layout": "Sei sicuro di voler rimuovere la formattazione? Il layout tornerà ai valori predefiniti.",
        "error.invalid.file_type": "Tipo di file non valido",
        "success.copy_clipboard": "Copiato negli appunti!",
        "label.remove_all_posts_confirm": "Sei sicuro di voler rimuovere tutti i post? Non sarà possibile recuperarli.",
        "label.post_should_be_tall": "Il tipo di post scelto deve utilizzare una dimensione verticale, altrimenti verranno tagliati una volta pubblicati. Vuoi cambiare comunque?",
        "label.my_palletes": "Le mie tavolozze",
        "label.my_colors": "I miei colori",
        "label.generic_add": "Aggiungere",
        "label.generic_edit": "Modificare",
        "label.generic_save": "Salvare",
        "label.generic_remove": "Dispositivo di rimozione",
        "label.generic_cancel": "Annulla",
        "label.add_new_pallete": "Aggiungi nuova tavolozza",
        "label.apply_pallete": "Usa tavolozza",
        "label.title_font_header": "Titolo",
        "label.description_font_header": "Descrizione",
        "label.text_min_size": "Dimensione minima",
        "label.text_max_size": "Dimensione massima",
        "label.font_size_info": "Le dimensioni dei caratteri vengono adattate automaticamente per garantire la migliore leggibilità. Per personalizzare, regolare i valori minimo e massimo. Per impostare una dimensione specifica, fare clic sul testo e regolare direttamente.",
        "label.text_min_size_tooltip": "Dimensione minima del carattere quando è presente molto testo e deve essere ridotto per adattarsi allo spazio disponibile.",
        "label.text_max_size_tooltip": "Dimensione predefinita e massima del carattere che può essere regolata.",
        "label.feature_contact_support": "Contatta l'assistenza per abilitare questa funzionalità. Vuoi iniziare una conversazione?",
        "label.iap_info_ios": "Gli abbonamenti verranno addebitati sulla tua carta di credito tramite il tuo account iTunes. Gli abbonamenti si rinnoveranno automaticamente a meno che non vengano annullati 24 ore prima della fine del periodo corrente. Puoi annullare in qualsiasi momento nelle impostazioni del tuo account iTunes.",
        "error.iap_other_account": "Hai un abbonamento attivo con un'altra email. Effettua il login con l'e-mail corretta.",
        "error.invalid.product": "Nome e immagini sono obbligatori.",
        "error.invalid.product.name": "Il nome è obbligatorio.",
        "error.invalid.product.price": "Il prezzo è obbligatorio.",
        "error.invalid.product.url": "L'immagine è obbligatoria.",
        "error.invalid.product.project": "Per aggiungere un prodotto è necessario selezionare un progetto.",
        "error.select_product": "Seleziona almeno un prodotto/servizio.",
        "error.select_media": "Seleziona almeno un'immagine.",
        "error.select_themes": "Seleziona almeno un tema.",
        "error.select_a_post": "Seleziona almeno un post.",
        "error.type_context": "Inserisci un'istruzione per generare post.",
        "error.max_media_items": "È possibile selezionare solo fino a 5 elementi.",
        "error.save_posts": "Errore durante il salvataggio dei post.",
        "label.mode_themes": "Scegli i soggetti",
        "label.mode_themes_description": "Scegli gli argomenti che vuoi trattare",
        "label.mode_product": "Prodotto o servizio",
        "label.mode_product_description": "Scegli un prodotto o servizio di cui parlare",
        "label.mode_dates": "Date commemorative",
        "label.mode_dates_description": "Scegli una data commemorativa",
        "label.mode_media": "Immagine",
        "label.mode_media_description": "Scegli una o più immagini",
        "label.mode_instruction": "Scrivi quello di cui ho bisogno",
        "label.mode_instruction_description": "Descrivi ciò di cui hai bisogno",
        "label.mode_link": "Collegamento",
        "label.mode_link_description": "Incolla un collegamento per generare un post",
        "label.mode_empty": "Posta vuota",
        "label.mode_empty_description": "Crea un post da zero",
        "label.mode_existing": "Posta pronta",
        "label.mode_existing_description": "Voglio solo fissare un appuntamento",
        "layout.smart_any": "Qualunque",
        "layout.smart_title_grid": "Grado",
        "layout.smart_vertical": "Verticale",
        "layout.smart_horizontal": "Orizzontale",
        "layout.smart_title_style": "Stile",
        "layout.smart_geometric": "Geometrico",
        "layout.smart_rounded": "Arrotondato",
        "layout.smart_title_shader": "Aspetto",
        "layout.smart_flat": "Semplice",
        "layout.smart_gradient": "Pendenza",
        "layout.smart_pattern": "Standard",
        "layout.smart_3d": "3D",
        "layout.smart_title_orientation": "Posizione Immagine",
        "layout.smart_begin": "Inizio",
        "layout.smart_end": "FINE",
        "layout.smart_title_alignment": "Allineamento",
        "layout.smart_left": "Sinistra",
        "layout.smart_center": "Centro",
        "layout.smart_right": "Giusto",
        "layout.smart_title_focus": "Messa a fuoco",
        "layout.smart_text": "Testo",
        "layout.smart_balanced": "Equilibrato",
        "layout.smart_fullscreen": "A schermo intero",
        "layout.smart_title_decorative": "Decorativo",
        "layout.smart_yes": "Tentativo",
        "layout.smart_no": "NO",
        "layout.smart_title_include_shapes": "Forme",
        "error.generator_no_content": "Impossibile trovare il contenuto a questo link",
        "error.generator_no_link": "Inserisci un collegamento",
        "gen.product.objective": "Scopo",
        "gen.product.price": "Prezzo",
        "gen.product.info": "Informazioni",
        "gen.product.cta": "Chiamata all'azione",
        "gen.product.discount": "Sconto",
        "tab.media_my_videos": "I miei video",
        "tab.media_videos_database": "Banca video",
        "error.invalid.max_size": "La dimensione massima del file deve essere %s.",
        "label.too_long_video": "I post non devono durare più di %s minuti.",
        "label.affiliate_created": "Crea il tuo codice di affiliazione",
        "label.affiliate_message": "Basta inserire il codice, apparirà così per la condivisione:",
        "label.affiliate_code_name": "IL TUO CODICE",
        "error.affiliate.code_exists": "Codice affiliato in uso, scegline un altro",
        "generic.no": "NO",
        "generic.yes": "Tentativo",
        "generator.include_related": "Includere argomenti correlati?",
        "generator.tone": "Voce Tom",
        "generator.tone_normal": "Normale",
        "generator.tone_formal": "Formale",
        "generator.tone_fun": "Divertimento",
        "generator.tone_informal": "Informale",
        "generator.tone_informative": "Informativo",
        "generator.tone_inspiring": "Ispirante",
        "generator.tone_polemic": "Controverso",
        "generator.tone_curious": "Curiosità",
        "generator.objective": "Scopo",
        "generator.objective_authority": "Autorità",
        "generator.objective_sales": "Saldi",
        "generator.objective_custom": "Costume",
        "generator.authority_list": "Lista",
        "generator.authority_opinion": "Opinione",
        "generator.authority_question": "Domanda",
        "generator.authority_checklist": "Lista di controllo",
        "generator.authority_news": "Notizia",
        "generator.authority_trivia": "Curiosità",
        "generator.content_type": "Tipo di contenuto",
        "generator.authority_faq": "Dubbi",
        "generator.authority_tips": "Suggerimenti",
        "generator.authority_tutorial": "Esercitazioni",
        "generator.authority_myths": "Miti e verità",
        "generator.authority_errors": "Errori comuni",
        "generator.authority_trends": "Notizia",
        "generator.sales_hooks": "Trigger di vendita",
        "generator.sales_benefits": "Benefici",
        "generator.sales_features": "Caratteristiche",
        "generator.sales_offers": "Offerte",
        "generator.sales_cta": "Chiamata all'azione",
        "generator.sales_social_proof": "Prove sociali",
        "generator.tone_tooltip": "Tono di voce dei tuoi post",
        "generator.objective_tooltip": "I post autorevoli aiutano a mettere in mostra la tua competenza nel settore. I post di vendita vengono utilizzati per promuovere un prodotto o un servizio.",
        "generator.format_tooltip": "Formato di output del tuo post",
        "generator.include_related_tooltip": "Includere argomenti correlati per fornire una maggiore varietà di contenuti",
        "generator.include_profile": "Correlato alla mia attività",
        "generator.include_profile_tooltip": "Scegli se i post generati devono essere correlati alla tua attività o se devono essere più generici",
        "generator.size": "Dimensione del titolo",
        "generator.size_short": "Corto",
        "generator.size_medium": "Media",
        "generator.size_long": "Lontano",
        "error.media_in_use": "Questa immagine è utilizzata in un post e non può essere rimossa.",
        "success.cancel_account": "Account annullato con successo!",
        "error.fill_required_fields": "Compila tutti i campi obbligatori",
        "generator.media_format": "Tipo di file di posta",
        "generator.media_format_image": "Immagine",
        "generator.media_format_video": "Video",
        "generator.hasCaption": "Hai già pronta una didascalia?",
        "generator.post_format": "Formato",
        "generator.post_format_post": "Inviare",
        "generator.post_format_reels": "Bobine",
        "generator.post_format_story": "Story",
        "error.format_post_not_support_media": "Il formato di post scelto non supporta questo tipo di media",
        "error.limit_posts_per_format": "Il formato di post scelto non supporta così tanti file",
        "label.content_already_generated": "Il tuo post ha già generato contenuti. Vuoi sovrascrivere le pagine carosello? La prima pagina verrà mantenuta.",
        "error.post_duration_exceeded": "La durata del post ha superato il limite massimo di %s secondi."
    },
    "nl": {
        "instagram.handle.error": "Kan Instagram-profiel niet vinden",
        "error.generating.content": "Kan geen inhoud genereren",
        "error.saving.post": "Kan bericht niet opslaan",
        "success.saving.post": "Bericht succesvol opgeslagen",
        "error.validation.context": "Vul alstublieft alle velden in",
        "error.validation.email": "Vul een geldig e-mailadres in",
        "error.imageLoading": "Wacht even, we zijn de berichtafbeelding aan het laden",
        "instagram.handle.at_removed": "Geen @ nodig, alleen de profielnaam",
        "info.config.show": "Klik op de berichtafbeelding om kleuren, lettertypen en andere details te bewerken",
        "error.invalid.image": "Fout bij uploaden afbeelding",
        "success.trial_started": "Welkom bij de proefversie van Magic Editor 🥳",
        "error.starting_trial": "Kan de proefperiode niet starten",
        "category.all": "Alle",
        "category.images": "Afbeeldingen",
        "category.cover": "Omslag",
        "category.slide": "Dia",
        "category.news": "Nieuws",
        "category.social": "Sociaal",
        "category.quote": "Citaat",
        "category.question": "Vraag",
        "category.list": "Lijst",
        "category.number": "Lijst",
        "category.checklist": "Controlelijst",
        "category.before-after": "Voor en na",
        "category.trivia": "Weetjes",
        "error.invalid.image_must_be_png": "De afbeelding moet een PNG-bestand zijn met een transparante achtergrond",
        "error.project.create": "Kan project niet maken",
        "source.Save Post": "Bericht opslaan",
        "source.Preview Post": "Voorbeeldbericht",
        "source.Download Post": "Bericht downloaden",
        "source.Refresh Keywords": "Zoekwoorden vernieuwen",
        "source.Upload Logo": "Logo uploaden",
        "source.Upload Social Logo": "Profielafbeelding uploaden",
        "source.Publish Item": "Artikel publiceren",
        "source.Edit Item": "Item bewerken",
        "source.Save Item": "Artikel opslaan",
        "source.Captions Item": "Genereer ondertitels",
        "source.Generated once but not logged in": "Genereer meer berichten",
        "source.Generated once but not customer": "Genereer meer berichten",
        "source.Max projects reached": "Voeg meer projecten toe",
        "source.Publish Post Directly": "Publiceer berichten rechtstreeks op Instagram",
        "source.Schedule Posts": "Plan berichten op Instagram",
        "source.Generate Audience": "Publiek genereren",
        "source.Generate Audience Needs": "Genereer behoeften van het publiek",
        "source.Generate Audience Goals": "Genereer doelgroepdoelen",
        "source.Generate Captions": "Genereer ondertitels",
        "source.Create Scratch": "Maak een bericht vanuit het niets",
        "source.Custom Fonts": "Aangepaste lettertypen uploaden",
        "source.Use my medias": "Gebruik mijn afbeeldingen",
        "source.Edit Themes": "Thema's bewerken",
        "source.Bulk Edit": "Berichten bulksgewijs bewerken",
        "source.Save Replan": "Berichtenplanning opslaan",
        "source.Remove Schedule": "Schema verwijderen",
        "source.Pin Post": "Favoriete post",
        "source.Finish Theme Selection": "Voltooi de selectie van onderwerpen",
        "source.Regenerate Post": "Post opnieuw genereren",
        "source.Change Calendar Range": "Wijzig het kalenderbereik",
        "source.Remove Post": "Bericht verwijderen",
        "source.Edit Post": "Bericht bewerken",
        "source.Skip Day": "Dag overslaan",
        "source.Publish Reels": "Rollen maken en publiceren",
        "source.Add more products": "Voeg meer producten toe",
        "source.Save Post Calendar": "Bericht opslaan",
        "source.Select Audio": "Selecteer Muziek",
        "source.Select Video": "Selecteer Video",
        "plan.filter.monthly": "Maandelijks",
        "plan.filter.annual": "Jaarlijks",
        "features.infinite_ideas": "Onbeperkte berichtenideeën",
        "features.custom_style": "Aanpassing van berichten",
        "features.integrated_publishing": "Automatisch publiceren",
        "features.unlimited_accounts": "Onbeperkte accounts",
        "features.1_account": "1 sociaal account",
        "features.accounts": "bedrijven",
        "features.reels": "Animaties van rollen en berichten",
        "features.audio": "Muziek in berichten",
        "features.custom_videos": "Videobibliotheek",
        "features.unlimited_posts": "Onbeperkt aantal berichten",
        "label.plans_trial_days": "14 dagen gratis proefperiode",
        "label.plans_cancel_anytime": "Annuleer op elk gewenst moment",
        "error.upgrade_plan": "Fout bij het upgraden van het abonnement. Probeer het opnieuw",
        "error.not_possible_find_instagram_account": "Heb je je Instagram-account niet gevonden?",
        "label.to_connect_you_need": "Verbinden:",
        "label.no_instagram_enabled": "Aan deze pagina is geen Instagram gekoppeld",
        "error.please_select_page": "Selecteer een pagina",
        "error.please_select_target": "Selecteer waar u wilt publiceren",
        "error.please_select_format": "Selecteer het berichtformaat",
        "error.scheduling_post": "Kan bericht niet plannen. Probeer het opnieuw",
        "error.creating_scratch": "Fout bij het maken van bericht",
        "error.authenticating_facebook": "Kon niet verifiëren met Facebook, probeer het opnieuw",
        "success.scheduling_post": "Bericht gepland!",
        "success.scheduling_post_limit": "Bericht succesvol gepland! Hoewel we geen planningslimieten hebben, kan het plannen van veel berichten op dezelfde dag op Instagram/Facebook beperkingen op uw profiel veroorzaken. We raden aan om maximaal 3 berichten per dag te plannen.",
        "scratch.post1.title": "Titel van je bericht over <b>elk onderwerp</b> dat je wilt",
        "scratch.post1.description": "Schrijf op de volgende regel om de beschrijving te worden",
        "scratch.post2.title": "Laat ruimte vrij op een nieuwe regel om een nieuwe afbeelding te starten",
        "scratch.post3.title": "Markeer relevante delen <b>vetgedrukt</b> om te markeren",
        "scratch.post4.title": "<b>1.</b> Markeer de cijfers aan het begin vetgedrukt om een lijst te maken",
        "scratch.post5.title": "<b>2.</b> Klik op een afbeelding om afbeeldingen, lay-out, lettertypen en kleuren te bewerken",
        "error_publish.too_many_items": "Instagram staat maximaal 10 berichten per carrousel toe. Verwijder wat inhoud om door te gaan.",
        "error_publish.no_content": "Je moet inhoud aan het bericht toevoegen om door te gaan.",
        "error_publish.caption_too_long": "Het berichtonderschrift mag niet langer zijn dan 2000 tekens.",
        "error_publish.too_many_hashtags": "Je kunt maximaal 30 hashtags per bericht toevoegen.",
        "error_publish.no_caption": "Je moet een onderschrift aan het bericht toevoegen",
        "error_publish.already_scheduled": "Dit bericht is al op deze pagina gepubliceerd",
        "instagram.handle.too_long": "Instagram-handle is te lang. Weet je zeker dat het klopt?",
        "success.canceling_publish": "Bericht geannuleerd!",
        "error.canceling_publish": "Kan het bericht niet annuleren. Probeer het opnieuw",
        "label.how_to_connect_instagram": "Klik hier voor meer informatie over hoe u uw Instagram-account kunt koppelen aan Galilai",
        "plan.upgraded": "Plan geüpgraded met succes!",
        "tags.all": "toon alles",
        "tags.base": "geen achtergrond",
        "tags.blob": "klodder",
        "tags.lines": "lijnen",
        "tags.waves": "golven",
        "tags.swipe": "veeg",
        "tags.circles": "cirkels",
        "tags.points": "punten",
        "tags.corner": "hoek",
        "elements.h1": "Titel",
        "elements.p": "Beschrijving",
        "elements.image": "Afbeelding",
        "elements.overlay": "Element",
        "elements.span": "Tekst",
        "elements.rect": "Rechthoek",
        "elements.circle": "Cirkel",
        "elements.trapezoid": "Trapezium",
        "elements.svg": "Grafisch",
        "icons.suggested.arrow": "pijl",
        "icons.suggested.heart": "hart",
        "icons.suggested.bubble": "bubbel",
        "icons.suggested.shopping": "winkelen",
        "icons.suggested.phone": "telefoon",
        "icons.suggested.local": "lokaal",
        "icons.suggested.star": "ster",
        "error.publish_reels_not_supported": "Rollen worden nog niet ondersteund",
        "error.you_need_to_reconnect_for_facebook_permissions": "U moet uw Facebook-account opnieuw verbinden om toestemming te krijgen om te publiceren",
        "label.already_caption_filled": "Er is al een bijschrift aangemaakt. Wilt u dit overschrijven?",
        "label.type_search": "Type om te zoeken",
        "label.colors_theme": "Thema's",
        "label.colors_custom": "Aangepast",
        "label.colors_picker": "Kies uit mijn logo",
        "label.main_color": "Hoofdkleur",
        "label.text_color": "Tekst kleur",
        "label.accent_color": "Accent kleur",
        "label.project": "Project",
        "button.upload_file_detect_color": "Stuur een afbeelding om de kleuren te identificeren",
        "label.click_to_edit_color": "Kleur bewerken",
        "label.click_to_select_color": "Selecteer kleur",
        "error.please_add_caption": "Je moet een onderschrift aan het bericht toevoegen",
        "label.month_long_1": "Januari",
        "label.month_long_2": "Februari",
        "label.month_long_3": "Maart",
        "label.month_long_4": "April",
        "label.month_long_5": "Kunnen",
        "label.month_long_6": "Juni",
        "label.month_long_7": "Juli",
        "label.month_long_8": "Augustus",
        "label.month_long_9": "September",
        "label.month_long_10": "Oktober",
        "label.month_long_11": "November",
        "label.month_long_12": "December",
        "label.month_short_1": "Jan",
        "label.month_short_2": "Februari",
        "label.month_short_3": "Maart",
        "label.month_short_4": "April",
        "label.month_short_5": "Kunnen",
        "label.month_short_6": "Jun",
        "label.month_short_7": "Juli",
        "label.month_short_8": "Augustus",
        "label.month_short_9": "September",
        "label.month_short_10": "Okt",
        "label.month_short_11": "Nov",
        "label.month_short_12": "Dec",
        "error.empty_post_text_caption": "Je bericht is leeg. Voeg een tekst toe om een onderschrift te genereren",
        "label.publish_status_pending": "Bewerking in behandeling",
        "label.publish_status_initial": "Gepland",
        "label.publish_status_published": "Gepubliceerd",
        "label.publish_status_error": "Fout bij publiceren",
        "error.calendar_full": "De kalender is vol, ga naar de volgende maand om meer berichten in te plannen of uw instellingen voor postplanning te wijzigen.",
        "label.calendar_other_themes": "andere onderwerpen",
        "label.calendar_other_theme": "ander onderwerp",
        "label.calendar_replan_success": "Berichten zijn succesvol bijgewerkt",
        "error.calendar_replan_error": "Fout bij updaten van berichten",
        "error.calendar_no_posts": "Er zijn geen berichten om te bewerken. Klik op Genereren om berichten te maken.",
        "error.calendar_no_topics": "Selecteer ten minste één onderwerp om berichten te genereren",
        "error.generate_empty_profile": "Uw profiel is leeg. Beschrijf iets over uw bedrijf",
        "error.not_logged_in": "U bent niet ingelogd, log in om verder te gaan",
        "error.loading.post": "Fout bij het laden van bericht. Probeer het opnieuw",
        "error.calendar_drop_past": "Je kunt berichten niet naar eerdere datums slepen",
        "error.calendar_topic_exists": "Dit onderwerp bestaat al",
        "label.today": "Vandaag",
        "label.help_modal": "Helpcentrum",
        "error_publish.media_error": "Er is een fout opgetreden tijdens het uploaden van uw afbeeldingen. Probeer het opnieuw.",
        "error_publish.invalid_images": "Er is een fout opgetreden tijdens het uploaden van uw afbeeldingen. Probeer het opnieuw.",
        "error_publish.invalid_page": "De geselecteerde pagina is niet geldig. Heeft u de verbinding met Facebook gewijzigd? Als u bijvoorbeeld bent ingelogd met een nieuw Facebook-account, zijn de eerder gekoppelde pagina's niet langer beschikbaar.",
        "error_publish.carousel_error": "Er is een fout opgetreden bij het publiceren van de carrousel. Probeer het opnieuw.",
        "error_publish.invalid_caption": "Het bijschrift is te lang of bevat meer dan 40 hashtags. Bewerk het bijschrift en probeer het opnieuw.",
        "error_publish.invalid_instagram_account": "Ongeldig Instagram-account of het is geen bedrijfstype. Heeft u de verbinding met Facebook gewijzigd? Als u bijvoorbeeld bent ingelogd met een nieuw Facebook-account, zijn de eerder gekoppelde pagina's niet langer beschikbaar.",
        "error_publish.instagram_business_error": "Instagram-account is geen zakelijk account. Converteer uw account naar een zakelijk account om door te gaan.",
        "error_publish.user_restricted": "Je Instagram- of Facebook-account is mogelijk beperkt. Ga naar <a target='_blank' href='https://www.facebook.com/business-support-home/?landing_page=overview'>deze link</a> om de beperkingen te bekijken en te zien hoe je je account kunt ontgrendelen.",
        "error_publish.rate_limit": "Hoewel we geen limiet hebben voor posts, hebben Instagram/Facebook wel een limiet. Als u doorgaat met het posten van veel posts per dag, kan dit resulteren in een blokkering van uw account. We raden u aan om vandaag te stoppen met posten en het morgen opnieuw te proberen met een lager volume aan posts, totdat de beperking is opgeheven.",
        "error_publish.publish_error": "Er is een fout opgetreden tijdens het publiceren. Probeer het opnieuw.",
        "error_publish.publish_error_story": "Er is een fout opgetreden bij het publiceren van het verhaal. Probeer het opnieuw.",
        "error_publish.publish_error_carousel": "Er is een fout opgetreden bij het publiceren van de carrousel. Probeer het opnieuw.",
        "error_publish.reauth_required": "U moet uw Facebook-account opnieuw verbinden. Klik op 'Mijn pagina's verbinden' en volg de instructies.",
        "error.generic": "Onverwachte fout. Probeer het opnieuw",
        "error.calendar_topic_length": "Het onderwerp moet tussen de 3 en 150 tekens bevatten",
        "label.post_type_carousel": "Carrousel",
        "label.post_type_single": "Enkele post",
        "label.import_tabs_image": "Afbeeldingen",
        "label.import_tabs_text": "Teksten",
        "label.import_tabs_background": "Vormen",
        "label.import_tabs_colors": "Kleuren",
        "label.import_tabs_fonts": "Lettertypen",
        "label.import_option_title": "Titel",
        "label.import_option_description": "Beschrijving",
        "label.import_option_fixed_text": "Vaste tekst",
        "label.import_option_main_image": "Hoofdafbeelding",
        "label.import_option_fixed_image": "Vast beeld",
        "label.import_option_email": "E-mail",
        "label.import_option_address": "Adres",
        "label.import_option_phone": "Telefoon",
        "label.import_option_website": "Website",
        "label.import_option_person_image": "Persoon afbeelding",
        "label.import_option_list_item": "Lijstitem",
        "label.import_option_list_cta": "Oproep tot actie",
        "label.import_option_main_color": "Hoofdkleur",
        "label.import_option_text_color": "Tekst kleur",
        "label.import_option_highlight_color": "Markeer kleur",
        "label.import_option_font_title": "Titel lettertype",
        "label.import_option_font_body": "Lichaamslettertype",
        "label.import_option_font_subtitle": "Ondertitel lettertype",
        "label.import_hide": "Verbergen",
        "label.import_main_color": "Hoofdkleur",
        "label.import_number": "Nummer",
        "label.import_author_handle": "Hendel",
        "label.remove_project_confirm": "Weet u zeker dat u het project wilt verwijderen? Alle berichten van dit project worden verwijderd.",
        "error.remove_project_last": "U kunt uw enige project niet verwijderen",
        "label.import_layout_success": "Lay-out geïmporteerd",
        "label.import_option_contextual_fixed_image": "Vast beeld (contextueel)",
        "label.success_generic": "Succes!",
        "success.generic": "Succes!",
        "label.are_you_sure": "Weet je het zeker?",
        "label.professional_area": "Ik werk in de omgeving van",
        "label.profile_handle": "@mijn profiel",
        "label.profile_name": "Mijn naam",
        "area_business.medicine": "Geneesmiddel",
        "area_business.psychology": "Psychologie",
        "area_business.law": "Wet",
        "area_business.wellness": "Gezondheid en welzijn",
        "area_business.education": "Onderwijs",
        "area_business.personal_care": "Persoonlijke verzorging",
        "area_business.cosmetics": "Cosmetica",
        "area_business.fitness": "Geschiktheid",
        "area_business.finance": "Financiën",
        "area_business.accounting": "Boekhouding",
        "area_business.construction": "Bouw",
        "area_business.real_estate": "Vastgoed",
        "area_business.architecture": "Architectuur",
        "area_business.tech": "Technologie",
        "area_business.pets": "Huisdieren",
        "area_business.coaching": "Coaching",
        "area_business.clothing": "Mode",
        "area_business.restaurant": "Restaurant",
        "area_business.automotive": "Automobiel",
        "area_business.transport": "Vervoer",
        "label.media_select_image": "Selecteer een afbeelding",
        "label.media_select_audio": "Selecteer een audio",
        "label.media_select_video": "Selecteer een video",
        "label.media_select_elements": "Selecteer een element",
        "label.media_select_fonts": "Selecteer een lettertype",
        "label.media_select_product": "Selecteer een product of dienst",
        "tab.media_icons_database": "Iconen",
        "tab.media_images_database": "Beelddatabase",
        "tab.media_audio_database": "Muziekdatabase",
        "tab.media_video_database": "Videodatabase",
        "tab.media_my_fonts": "Mijn lettertypen",
        "tab.media_my_images": "Mijn afbeeldingen",
        "tab.media_my_audio": "Mijn muziek",
        "tab.media_my_video": "Mijn video's",
        "tab.media_my_products": "Mijn producten en diensten",
        "btn.remove_bg": "Verwijder achtergrond",
        "btn.remove": "Verwijderen",
        "btn.select": "Selecteer",
        "label.folder_home": "Alle",
        "tag.audio_all": "Alle",
        "tag.audio_upbeat": "Vrolijk",
        "tag.audio_happy": "Vrolijk",
        "tag.audio_inspiring": "Inspirerend",
        "tag.audio_chill": "Chill",
        "label.need_to_increase_quantity": "u moet het aantal bedrijven in uw plan vergroten",
        "label.multiple_pages": "Meerdere pagina's",
        "label.one_page": "Een pagina",
        "error.rendering_post": "Fout bij downloaden van bericht. Probeer het opnieuw",
        "label.otp_verified_mobile": "Je aanmelding is gelukt! Keer terug naar de app om door te gaan.",
        "label.otp_verified": "Je aanmelding is gelukt!",
        "success.connected_facebook_app": "Je hebt met succes je sociale accounts gekoppeld! Ga terug naar de mobiele app om door te gaan.",
        "label.app_update_available": "Er is een nieuwe versie van de app beschikbaar. Update om toegang te krijgen tot nieuwe functies.",
        "label.app_update_available_required": "Er is een nieuwe versie van de app beschikbaar. Update om de app te blijven gebruiken.",
        "tab.favorites": "Favorieten",
        "error.missing_project_favorite": "Ga naar het tabblad Favorieten en kies eerst een project",
        "label.my_text": "Mijn tekst",
        "label.remove_generic": "Weet u zeker dat u wilt verwijderen?",
        "label.confirm_reset_layout": "Weet u zeker dat u de opmaak wilt verwijderen? De lay-out wordt teruggezet naar de standaardinstelling.",
        "error.invalid.file_type": "Ongeldig bestandstype",
        "success.copy_clipboard": "Gekopieerd naar klembord!",
        "label.remove_all_posts_confirm": "Weet u zeker dat u alle berichten wilt verwijderen? U kunt ze niet meer herstellen.",
        "label.post_should_be_tall": "Het posttype dat u kiest, moet een verticale grootte hebben, anders wordt het bijgesneden wanneer het wordt geplaatst. Wilt u het toch wijzigen?",
        "label.my_palletes": "Mijn paletten",
        "label.my_colors": "Mijn kleuren",
        "label.generic_add": "Toevoegen",
        "label.generic_edit": "Bewerking",
        "label.generic_save": "Redden",
        "label.generic_remove": "Verwijderen",
        "label.generic_cancel": "Annuleren",
        "label.add_new_pallete": "Nieuw palet toevoegen",
        "label.apply_pallete": "Gebruik palet",
        "label.title_font_header": "Titel",
        "label.description_font_header": "Beschrijving",
        "label.text_min_size": "Minimale grootte",
        "label.text_max_size": "Maximale grootte",
        "label.font_size_info": "Lettergroottes worden automatisch aangepast om de beste leesbaarheid te garanderen. Om aan te passen, past u de minimum- en maximumwaarden aan. Om een specifieke grootte in te stellen, klikt u op de tekst en past u deze direct aan.",
        "label.text_min_size_tooltip": "Minimale lettergrootte wanneer er veel tekst is en de tekst verkleind moet worden om in de beschikbare ruimte te passen.",
        "label.text_max_size_tooltip": "Standaard- en maximale grootte waarin het lettertype kan worden aangepast.",
        "label.feature_contact_support": "Neem contact op met support om deze functie in te schakelen. Wil je een chat starten?",
        "label.iap_info_ios": "Abonnementen worden via uw iTunes-account op uw creditcard in rekening gebracht. Abonnementen worden automatisch verlengd, tenzij ze binnen 24 uur voor het einde van de huidige periode worden geannuleerd. U kunt op elk moment annuleren met uw iTunes-accountinstellingen.",
        "error.iap_other_account": "U hebt een actief abonnement met een ander e-mailadres. Meld u aan met het juiste e-mailadres.",
        "error.invalid.product": "Naam en afbeeldingen zijn verplicht.",
        "error.invalid.product.name": "Naam is verplicht.",
        "error.invalid.product.price": "Prijs is verplicht.",
        "error.invalid.product.url": "Afbeelding is vereist.",
        "error.invalid.product.project": "U moet een project selecteren om een product toe te voegen.",
        "error.select_product": "Selecteer minimaal één product/dienst.",
        "error.select_media": "Selecteer minimaal één afbeelding.",
        "error.select_themes": "Selecteer minimaal één onderwerp.",
        "error.select_a_post": "Selecteer minimaal één bericht.",
        "error.type_context": "Typ een instructie om berichten te genereren.",
        "error.max_media_items": "U kunt maximaal 5 items selecteren.",
        "error.save_posts": "Fout bij het opslaan van berichten.",
        "label.mode_themes": "Kies onderwerpen",
        "label.mode_themes_description": "Kies de onderwerpen die u wilt behandelen",
        "label.mode_product": "Product of dienst",
        "label.mode_product_description": "Kies een product of dienst om over te praten",
        "label.mode_dates": "Herdenkingsdata",
        "label.mode_dates_description": "Kies een herdenkingsdatum",
        "label.mode_media": "Afbeelding",
        "label.mode_media_description": "Kies een of meer afbeeldingen",
        "label.mode_instruction": "Instructie",
        "label.mode_instruction_description": "Beschrijf wat u nodig hebt",
        "label.mode_link": "Link",
        "label.mode_link_description": "Plak een link om een bericht te genereren",
        "label.mode_empty": "Lege post",
        "label.mode_empty_description": "Een bericht vanaf nul maken",
        "label.mode_existing": "Planningsbericht",
        "label.mode_existing_description": "Plan een afbeelding/video",
        "layout.smart_any": "Elk",
        "layout.smart_title_grid": "Rooster",
        "layout.smart_vertical": "Verticaal",
        "layout.smart_horizontal": "Horizontaal",
        "layout.smart_title_style": "Stijl",
        "layout.smart_geometric": "Geometrisch",
        "layout.smart_rounded": "Afgerond",
        "layout.smart_title_shader": "Verschijning",
        "layout.smart_flat": "Vlak",
        "layout.smart_gradient": "Verloop",
        "layout.smart_pattern": "Patroon",
        "layout.smart_3d": "3D",
        "layout.smart_title_orientation": "Afbeeldingpositie",
        "layout.smart_begin": "Beginnen",
        "layout.smart_end": "Einde",
        "layout.smart_title_alignment": "Uitlijning",
        "layout.smart_left": "Links",
        "layout.smart_center": "Centrum",
        "layout.smart_right": "Rechts",
        "layout.smart_title_focus": "Focus",
        "layout.smart_text": "Tekst",
        "layout.smart_balanced": "Gebalanceerd",
        "layout.smart_fullscreen": "Volledig scherm",
        "layout.smart_title_decorative": "Decoratief",
        "layout.smart_yes": "Ja",
        "layout.smart_no": "Nee",
        "layout.smart_title_include_shapes": "Vormen",
        "error.generator_no_content": "Kon geen inhoud vinden in deze link",
        "error.generator_no_link": "Voeg een link toe",
        "gen.product.objective": "Objectief",
        "gen.product.price": "Prijs",
        "gen.product.info": "Informatie",
        "gen.product.cta": "Oproep tot actie",
        "gen.product.discount": "Korting",
        "tab.media_my_videos": "Mijn video's",
        "tab.media_videos_database": "Videodatabase",
        "error.invalid.max_size": "De maximale bestandsgrootte mag %s zijn.",
        "label.too_long_video": "Berichten mogen maximaal %s minuten lang zijn.",
        "label.affiliate_created": "Maak uw affiliatecode aan",
        "label.affiliate_message": "Voer alleen de code in, deze ziet er bij het delen zo uit:",
        "label.affiliate_code_name": "UWCODE",
        "error.affiliate.code_exists": "Affiliatecode in gebruik, kies een andere",
        "generic.no": "Nee",
        "generic.yes": "Ja",
        "generator.include_related": "Gerelateerde onderwerpen opnemen?",
        "generator.tone": "Toon van de stem",
        "generator.tone_normal": "Normaal",
        "generator.tone_formal": "Formeel",
        "generator.tone_fun": "Plezier",
        "generator.tone_informal": "Informeel",
        "generator.tone_informative": "Informatief",
        "generator.tone_inspiring": "Inspirerend",
        "generator.tone_polemic": "Polemiek",
        "generator.tone_curious": "Nieuwsgierigheid",
        "generator.objective": "Objectief",
        "generator.objective_authority": "Autoriteit",
        "generator.objective_sales": "Verkoop",
        "generator.objective_custom": "Aangepast",
        "generator.authority_list": "Lijst",
        "generator.authority_opinion": "Mening",
        "generator.authority_question": "Vraag",
        "generator.authority_checklist": "Controlelijst",
        "generator.authority_news": "Nieuws",
        "generator.authority_trivia": "Weetjes",
        "generator.content_type": "Inhoudstype",
        "generator.authority_faq": "Vragen en antwoorden",
        "generator.authority_tips": "Tips",
        "generator.authority_tutorial": "Zelfstudies",
        "generator.authority_myths": "Mythen en waarheden",
        "generator.authority_errors": "Veelvoorkomende fouten",
        "generator.authority_trends": "Trends",
        "generator.sales_hooks": "Verkoophaken",
        "generator.sales_benefits": "Voordelen",
        "generator.sales_features": "Functies",
        "generator.sales_offers": "Aanbiedingen",
        "generator.sales_cta": "Oproep tot actie",
        "generator.sales_social_proof": "Sociaal bewijs",
        "generator.tone_tooltip": "Toon van uw berichten",
        "generator.objective_tooltip": "Autoriteitsberichten helpen om uw kennis op het gebied te tonen. Verkoopberichten worden gebruikt om een product of dienst te promoten",
        "generator.format_tooltip": "Uitvoerformaat van uw bericht",
        "generator.include_related_tooltip": "Voeg gerelateerde onderwerpen toe om de inhoud gevarieerder te maken",
        "generator.size": "Titelgrootte",
        "generator.size_short": "Kort",
        "generator.size_medium": "Medium",
        "generator.size_long": "Lang",
        "generator.include_profile": "Gerelateerd aan mijn bedrijf",
        "generator.include_profile_tooltip": "Kies of de gegenereerde berichten gerelateerd moeten zijn aan uw bedrijf of meer generiek moeten zijn",
        "error.media_in_use": "Deze afbeelding wordt gebruikt in een bericht en kan niet worden verwijderd",
        "success.cancel_account": "Account succesvol geannuleerd!",
        "error.fill_required_fields": "Vul alle verplichte velden in",
        "generator.media_format": "Postbestandstype",
        "generator.media_format_image": "Afbeelding",
        "generator.media_format_video": "Video",
        "generator.hasCaption": "Heb je een onderschrift gemaakt?",
        "generator.post_format": "Formaat",
        "generator.post_format_post": "Na",
        "generator.post_format_reels": "Rollen",
        "generator.post_format_story": "Story",
        "error.format_post_not_support_media": "Het geselecteerde berichtformaat ondersteunt dit type media niet",
        "error.limit_posts_per_format": "Het geselecteerde berichtformaat ondersteunt niet zoveel bestanden",
        "label.content_already_generated": "Je bericht heeft al content gegenereerd. Wil je de carrouselpagina's overschrijven? De eerste pagina blijft behouden.",
        "error.post_duration_exceeded": "De berichtduur overschreed de maximumlimiet van %s seconden."
    },
    "da": {
        "instagram.handle.error": "Instagram-profilen kunne ikke findes",
        "error.generating.content": "Kunne ikke generere indhold",
        "error.saving.post": "Kunne ikke gemme indlægget",
        "success.saving.post": "Indlægget blev gemt",
        "error.validation.context": "Udfyld venligst alle felterne",
        "error.validation.email": "Udfyld venligst en gyldig e-mail",
        "error.imageLoading": "Vent lidt, vi indlæser postbilledet",
        "instagram.handle.at_removed": "Intet behov for @, kun profilnavnet",
        "info.config.show": "Klik på postbilledet for at redigere farver, skrifttyper og andre detaljer",
        "error.invalid.image": "Fejl under upload af billede",
        "success.trial_started": "Velkommen til prøveversionen af Magic Editor 🥳",
        "error.starting_trial": "Kunne ikke starte prøveversionen",
        "category.all": "Alle",
        "category.images": "Billeder",
        "category.cover": "Dække over",
        "category.slide": "Glide",
        "category.news": "Nyheder",
        "category.social": "Social",
        "category.quote": "Citere",
        "category.question": "Spørgsmål",
        "category.list": "Liste",
        "category.number": "Liste",
        "category.checklist": "Tjekliste",
        "category.before-after": "Før og efter",
        "category.trivia": "Trivia",
        "error.invalid.image_must_be_png": "Billedet skal være PNG med gennemsigtig baggrund",
        "error.project.create": "Projektet kunne ikke oprettes",
        "source.Save Post": "Gem indlæg",
        "source.Preview Post": "Forhåndsvisning af indlæg",
        "source.Download Post": "Download indlæg",
        "source.Refresh Keywords": "Opdater søgeord",
        "source.Upload Logo": "Upload logo",
        "source.Upload Social Logo": "Upload profilbillede",
        "source.Publish Item": "Udgiv vare",
        "source.Edit Item": "Rediger element",
        "source.Save Item": "Gem vare",
        "source.Captions Item": "Generer billedtekster",
        "source.Generated once but not logged in": "Generer flere indlæg",
        "source.Generated once but not customer": "Generer flere indlæg",
        "source.Max projects reached": "Tilføj flere projekter",
        "source.Publish Post Directly": "Udgiv indlæg direkte på Instagram",
        "source.Schedule Posts": "Planlæg indlæg til Instagram",
        "source.Generate Audience": "Generer publikum",
        "source.Generate Audience Needs": "Generer publikumsbehov",
        "source.Generate Audience Goals": "Generer målgruppemål",
        "source.Generate Captions": "Generer billedtekster",
        "source.Create Scratch": "Opret indlæg fra bunden",
        "source.Custom Fonts": "Upload tilpassede skrifttyper",
        "source.Use my medias": "Brug mine billeder",
        "source.Edit Themes": "Rediger temaer",
        "source.Bulk Edit": "Masseredigering af indlæg",
        "source.Save Replan": "Planlægning af Gem indlæg",
        "source.Remove Schedule": "Fjern tidsplan",
        "source.Pin Post": "Favoritindlæg",
        "source.Finish Theme Selection": "Afslut emnevalg",
        "source.Regenerate Post": "Gendan post",
        "source.Change Calendar Range": "Skift kalenderområde",
        "source.Remove Post": "Fjern indlæg",
        "source.Edit Post": "Rediger indlæg",
        "source.Skip Day": "Spring over dag",
        "source.Publish Reels": "Opret og udgiv ruller",
        "source.Add more products": "Tilføj flere produkter",
        "source.Save Post Calendar": "Gem indlæg",
        "source.Select Audio": "Vælg Musik",
        "source.Select Video": "Vælg Video",
        "plan.filter.monthly": "Månedlige",
        "plan.filter.annual": "Årligt",
        "features.infinite_ideas": "Ubegrænsede indlægsideer",
        "features.custom_style": "Indlæg tilpasning",
        "features.integrated_publishing": "Automatisk udgivelse",
        "features.unlimited_accounts": "Ubegrænsede konti",
        "features.1_account": "1 social konto",
        "features.accounts": "virksomheder",
        "features.reels": "Spor og indlæg animationer",
        "features.audio": "Musik i indlæg",
        "features.custom_videos": "Videobibliotek",
        "features.unlimited_posts": "Ubegrænsede indlæg",
        "label.plans_trial_days": "14 dages gratis prøveperiode",
        "label.plans_cancel_anytime": "Annuller når som helst",
        "error.upgrade_plan": "Fejl under opgradering af plan. Prøv igen",
        "error.not_possible_find_instagram_account": "Fandt du ikke din Instagram-konto?",
        "label.to_connect_you_need": "At forbinde:",
        "label.no_instagram_enabled": "Denne side har ikke Instagram tilknyttet",
        "error.please_select_page": "Vælg venligst en side",
        "error.please_select_target": "Vælg hvor du vil udgive",
        "error.please_select_format": "Vælg opslagsformatet",
        "error.scheduling_post": "Kunne ikke planlægge indlæg. Prøv igen",
        "error.creating_scratch": "Fejl ved oprettelse af indlæg",
        "error.authenticating_facebook": "Kunne ikke godkende med Facebook. Prøv igen",
        "success.scheduling_post": "Post planlagt!",
        "success.scheduling_post_limit": "Post planlagt! Selvom vi ikke har skemagrænser, kan planlægning af mange opslag på samme dag på Instagram/Facebook forårsage begrænsninger på din profil. Vi anbefaler at planlægge op til maksimalt 3 indlæg om dagen.",
        "scratch.post1.title": "Titlen på dit indlæg om <b>ethvert emne</b>, du ønsker",
        "scratch.post1.description": "Skriv på næste linje for at blive beskrivelsen",
        "scratch.post2.title": "Efterlad plads på en ny linje for at starte et nyt billede",
        "scratch.post3.title": "Markér med <b>fed skrift</b> for at fremhæve",
        "scratch.post4.title": "<b>1.</b> Marker med fede tal i begyndelsen for at oprette en liste",
        "scratch.post5.title": "<b>2.</b> Klik på et billede for at redigere billeder, layout, skrifttyper og farver",
        "error_publish.too_many_items": "Instagram tillader maksimalt 10 opslag pr. karrusel. Fjern noget indhold for at fortsætte.",
        "error_publish.no_content": "Du skal tilføje indhold til indlægget for at fortsætte.",
        "error_publish.caption_too_long": "Indlægsteksten må ikke være mere end 2000 tegn.",
        "error_publish.too_many_hashtags": "Du kan maksimalt tilføje 30 hashtags pr. indlæg.",
        "error_publish.no_caption": "Du skal tilføje en billedtekst til indlægget",
        "error_publish.already_scheduled": "Dette indlæg er allerede blevet offentliggjort på denne side",
        "instagram.handle.too_long": "Instagram-håndtaget er for langt. Er du sikker på, at det er korrekt?",
        "success.canceling_publish": "Indlægget blev annulleret!",
        "error.canceling_publish": "Kunne ikke annullere indlægget. Prøv igen",
        "label.how_to_connect_instagram": "Klik her for at lære, hvordan du forbinder din Instagram-konto til Galilai",
        "plan.upgraded": "Planen blev opgraderet!",
        "tags.all": "Vis alt",
        "tags.base": "ingen baggrund",
        "tags.blob": "klat",
        "tags.lines": "linjer",
        "tags.waves": "bølger",
        "tags.swipe": "swipe",
        "tags.circles": "cirkler",
        "tags.points": "point",
        "tags.corner": "hjørne",
        "elements.h1": "Titel",
        "elements.p": "Beskrivelse",
        "elements.image": "Billede",
        "elements.overlay": "Element",
        "elements.span": "Tekst",
        "elements.rect": "Rektangel",
        "elements.circle": "Cirkel",
        "elements.trapezoid": "Trapez",
        "elements.svg": "Grafisk",
        "icons.suggested.arrow": "pil",
        "icons.suggested.heart": "hjerte",
        "icons.suggested.bubble": "boble",
        "icons.suggested.shopping": "handle ind",
        "icons.suggested.phone": "telefon",
        "icons.suggested.local": "lokal",
        "icons.suggested.star": "stjerne",
        "error.publish_reels_not_supported": "Hjuler er ikke understøttet endnu",
        "error.you_need_to_reconnect_for_facebook_permissions": "Du skal oprette forbindelse til din Facebook-konto igen for at få tilladelserne til at udgive",
        "label.already_caption_filled": "Der er allerede oprettet en billedtekst, vil du overskrive den?",
        "label.type_search": "Skriv for at søge",
        "label.colors_theme": "Temaer",
        "label.colors_custom": "Brugerdefinerede",
        "label.colors_picker": "Vælg fra mit logo",
        "label.main_color": "Hovedfarve",
        "label.text_color": "Tekstfarve",
        "label.accent_color": "Accent farve",
        "label.project": "Projekt",
        "button.upload_file_detect_color": "Send et billede for at identificere farverne",
        "label.click_to_edit_color": "Rediger farve",
        "label.click_to_select_color": "Vælg farve",
        "error.please_add_caption": "Du skal tilføje en billedtekst til indlægget",
        "label.month_long_1": "Januar",
        "label.month_long_2": "Februar",
        "label.month_long_3": "Marts",
        "label.month_long_4": "April",
        "label.month_long_5": "Kan",
        "label.month_long_6": "Juni",
        "label.month_long_7": "Juli",
        "label.month_long_8": "August",
        "label.month_long_9": "September",
        "label.month_long_10": "Oktober",
        "label.month_long_11": "November",
        "label.month_long_12": "December",
        "label.month_short_1": "Jan",
        "label.month_short_2": "Feb",
        "label.month_short_3": "Mar",
        "label.month_short_4": "Apr",
        "label.month_short_5": "Kan",
        "label.month_short_6": "Jun",
        "label.month_short_7": "Jul",
        "label.month_short_8": "Aug",
        "label.month_short_9": "Sep",
        "label.month_short_10": "Okt",
        "label.month_short_11": "Nov",
        "label.month_short_12": "Dec",
        "error.empty_post_text_caption": "Dit indlæg er tomt. Tilføj en tekst for at generere en billedtekst",
        "label.publish_status_pending": "Afventer redigering",
        "label.publish_status_initial": "Planlagt",
        "label.publish_status_published": "Udgivet",
        "label.publish_status_error": "Fejl ved udgivelse",
        "error.calendar_full": "Kalenderen er fuld, gå til næste måned for at planlægge flere indlæg eller ændre dine indstillinger for postplanlægning.",
        "label.calendar_other_themes": "andre emner",
        "label.calendar_other_theme": "andet emne",
        "label.calendar_replan_success": "Indlæg blev opdateret",
        "error.calendar_replan_error": "Fejl under opdatering af indlæg",
        "error.calendar_no_posts": "Ingen indlæg at redigere. Klik på Generer for at oprette indlæg.",
        "error.calendar_no_topics": "Vælg mindst ét emne for at generere indlæg",
        "error.generate_empty_profile": "Din profil er tom, beskriv lidt om din virksomhed",
        "error.not_logged_in": "Du er ikke logget ind, log ind for at fortsætte",
        "error.loading.post": "Fejl ved indlæsning af indlæg, prøv venligst igen",
        "error.calendar_drop_past": "Du kan ikke trække indlæg til tidligere datoer",
        "error.calendar_topic_exists": "Dette emne findes allerede",
        "label.today": "I dag",
        "label.help_modal": "Hjælpecenter",
        "error_publish.media_error": "Der opstod en fejl under upload af dine billeder. Prøv igen.",
        "error_publish.invalid_images": "Der opstod en fejl under upload af dine billeder. Prøv igen.",
        "error_publish.invalid_page": "Den valgte side er ikke gyldig. Ændrede du forbindelsen til Facebook? For eksempel: Hvis du loggede ind med en ny Facebook-konto, vil de tidligere tilsluttede sider ikke længere være tilgængelige.",
        "error_publish.carousel_error": "Der opstod en fejl under udgivelsen af karrusellen. Prøv igen.",
        "error_publish.invalid_caption": "Billedteksten er for lang eller har mere end 40 hashtags. Rediger billedteksten og prøv igen.",
        "error_publish.invalid_instagram_account": "Ugyldig Instagram-konto, eller det er ikke en virksomhedstype. Ændrede du forbindelsen til Facebook? For eksempel: Hvis du loggede ind med en ny Facebook-konto, vil de tidligere tilsluttede sider ikke længere være tilgængelige.",
        "error_publish.instagram_business_error": "Instagram-konto er ikke en virksomhedskonto. Konverter venligst din konto til en virksomhedskonto for at fortsætte.",
        "error_publish.user_restricted": "Din Instagram- eller Facebook-konto kan være begrænset. Få adgang til <a target='_blank' href='https://www.facebook.com/business-support-home/?landing_page=overview'>dette link</a> for at kontrollere begrænsningerne, og hvordan du låser din konto op",
        "error_publish.rate_limit": "Selvom vi ikke har en grænse for opslag, har Instagram/Facebook en grænse. Hvis du fortsætter med at skrive mange indlæg om dagen, kan det resultere i en blokering af din konto. Vi foreslår, at du stopper med at skrive i dag og prøver igen i morgen og med et mindre antal indlæg, indtil begrænsningen er fjernet.",
        "error_publish.publish_error": "Der opstod en fejl under udgivelsen. Prøv igen.",
        "error_publish.publish_error_story": "Der opstod en fejl under udgivelsen af historien. Prøv igen.",
        "error_publish.publish_error_carousel": "Der opstod en fejl under udgivelsen af karrusellen. Prøv igen.",
        "error_publish.reauth_required": "Du skal oprette forbindelse til din Facebook-konto igen. Klik venligst på 'Forbind mine sider' og følg instruktionerne.",
        "error.generic": "Uforventet fejl. Prøv igen",
        "error.calendar_topic_length": "Emnet skal have mellem 3 og 150 tegn",
        "label.post_type_carousel": "Karrusel",
        "label.post_type_single": "Enkelt indlæg",
        "label.import_tabs_image": "Billeder",
        "label.import_tabs_text": "Tekster",
        "label.import_tabs_background": "Former",
        "label.import_tabs_colors": "Farver",
        "label.import_tabs_fonts": "Skrifttyper",
        "label.import_option_title": "Titel",
        "label.import_option_description": "Beskrivelse",
        "label.import_option_fixed_text": "Fast tekst",
        "label.import_option_main_image": "Hovedbillede",
        "label.import_option_fixed_image": "Fast billede",
        "label.import_option_email": "E-mail",
        "label.import_option_address": "Adresse",
        "label.import_option_phone": "Telefon",
        "label.import_option_website": "Internet side",
        "label.import_option_person_image": "Person billede",
        "label.import_option_list_item": "Listevare",
        "label.import_option_list_cta": "Opfordring til handling",
        "label.import_option_main_color": "Hovedfarve",
        "label.import_option_text_color": "Tekst farve",
        "label.import_option_highlight_color": "Fremhæv farve",
        "label.import_option_font_title": "Titelskrifttype",
        "label.import_option_font_body": "Brødskrift",
        "label.import_option_font_subtitle": "Undertekst skrifttype",
        "label.import_hide": "Skjule",
        "label.import_main_color": "Hovedfarve",
        "label.import_number": "Nummer",
        "label.import_author_handle": "Håndtere",
        "label.remove_project_confirm": "Er du sikker på, at du vil fjerne projektet? Alle indlæg fra dette projekt vil blive fjernet.",
        "error.remove_project_last": "Du kan ikke fjerne dit eneste projekt",
        "label.import_layout_success": "Layoutet blev importeret",
        "label.import_option_contextual_fixed_image": "Fast billede (kontekstuelt)",
        "label.success_generic": "Succes!",
        "success.generic": "Succes!",
        "label.are_you_sure": "Er du sikker?",
        "label.professional_area": "Jeg arbejder inden for området",
        "label.profile_handle": "@min profil",
        "label.profile_name": "Mit navn",
        "area_business.medicine": "Medicin",
        "area_business.psychology": "Psykologi",
        "area_business.law": "Lov",
        "area_business.wellness": "Sundhed og velvære",
        "area_business.education": "Uddannelse",
        "area_business.personal_care": "Personlig pleje",
        "area_business.cosmetics": "Kosmetik",
        "area_business.fitness": "Fitness",
        "area_business.finance": "Finansiere",
        "area_business.accounting": "Regnskab",
        "area_business.construction": "Konstruktion",
        "area_business.real_estate": "Ejendom",
        "area_business.architecture": "Arkitektur",
        "area_business.tech": "Teknologi",
        "area_business.pets": "Kæledyr",
        "area_business.coaching": "Coaching",
        "area_business.clothing": "Mode",
        "area_business.restaurant": "Restaurant",
        "area_business.automotive": "Automotive",
        "area_business.transport": "Transportere",
        "label.media_select_image": "Vælg et billede",
        "label.media_select_audio": "Vælg en lyd",
        "label.media_select_video": "Vælg en video",
        "label.media_select_elements": "Vælg et element",
        "label.media_select_fonts": "Vælg en skrifttype",
        "label.media_select_product": "Vælg et produkt eller en tjeneste",
        "tab.media_icons_database": "Ikoner",
        "tab.media_images_database": "Billeddatabase",
        "tab.media_audio_database": "Musik Database",
        "tab.media_video_database": "Video database",
        "tab.media_my_fonts": "Mine skrifttyper",
        "tab.media_my_images": "Mine billeder",
        "tab.media_my_audio": "Mit musik",
        "tab.media_my_video": "Mine videoer",
        "tab.media_my_products": "Mine produkter og tjenester",
        "btn.remove_bg": "Fjern baggrund",
        "btn.remove": "Fjerne",
        "btn.select": "Vælg",
        "label.folder_home": "Alle",
        "tag.audio_all": "Alle",
        "tag.audio_upbeat": "Optimistisk",
        "tag.audio_happy": "Lykkelig",
        "tag.audio_inspiring": "Inspirerende",
        "tag.audio_chill": "Chill",
        "label.need_to_increase_quantity": "du skal øge antallet af virksomheder i din plan",
        "label.multiple_pages": "Flere sider",
        "label.one_page": "En side",
        "error.rendering_post": "Fejl ved download af indlæg. Prøv igen",
        "label.otp_verified_mobile": "Dit login lykkedes! Vend tilbage til appen for at fortsætte.",
        "label.otp_verified": "Dit login lykkedes!",
        "success.connected_facebook_app": "Du har tilsluttet dine sociale konti! Vend venligst tilbage til mobilappen for at fortsætte.",
        "label.app_update_available": "En ny version af appen er tilgængelig. Opdater for at få adgang til nye funktioner.",
        "label.app_update_available_required": "En ny version af appen er tilgængelig. Opdater for at fortsætte med at bruge appen.",
        "tab.favorites": "Favoritter",
        "error.missing_project_favorite": "Gå til fanen Favoritter, og vælg først et projekt",
        "label.my_text": "Min tekst",
        "label.remove_generic": "Er du sikker på, at du vil fjerne?",
        "label.confirm_reset_layout": "Er du sikker på, at du vil fjerne formateringen? Layoutet vender tilbage til dets standard.",
        "error.invalid.file_type": "Ugyldig filtype",
        "success.copy_clipboard": "Kopieret til udklipsholder!",
        "label.remove_all_posts_confirm": "Er du sikker på, at du vil fjerne alle indlæg? Du vil ikke være i stand til at gendanne dem.",
        "label.post_should_be_tall": "Den posttype, du valgte, skal bruge en lodret størrelse, ellers vil den blive beskåret, når den sendes. Vil du alligevel ændre dig?",
        "label.my_palletes": "Mine paletter",
        "label.my_colors": "Mine farver",
        "label.generic_add": "Tilføje",
        "label.generic_edit": "Redigere",
        "label.generic_save": "Gemme",
        "label.generic_remove": "Fjerne",
        "label.generic_cancel": "Afbestille",
        "label.add_new_pallete": "Tilføj ny palette",
        "label.apply_pallete": "Brug Palette",
        "label.title_font_header": "Titel",
        "label.description_font_header": "Beskrivelse",
        "label.text_min_size": "Minimum størrelse",
        "label.text_max_size": "Maksimal størrelse",
        "label.font_size_info": "Skriftstørrelser justeres automatisk for at sikre den bedste læsbarhed. For at tilpasse skal du justere minimums- og maksimumværdierne. For at indstille en bestemt størrelse skal du klikke på teksten og justere direkte.",
        "label.text_min_size_tooltip": "Minimum skriftstørrelse, når der er meget tekst, og den skal reduceres for at passe til den tilgængelige plads.",
        "label.text_max_size_tooltip": "Standard og maksimal størrelse, som skrifttypen kan justeres.",
        "label.feature_contact_support": "Kontakt support for at aktivere denne funktion. Vil du starte en chat?",
        "label.iap_info_ios": "Abonnementer vil blive debiteret dit kreditkort via din iTunes-konto. Abonnementer fornyes automatisk, medmindre de annulleres inden for 24 timer før udgangen af den aktuelle periode. Du kan annullere når som helst med dine iTunes-kontoindstillinger.",
        "error.iap_other_account": "Du har et aktivt abonnement med en anden e-mail. Log venligst ind med den korrekte e-mail.",
        "error.invalid.product": "Navn og billeder er påkrævet.",
        "error.invalid.product.name": "Navn er påkrævet.",
        "error.invalid.product.price": "Pris er påkrævet.",
        "error.invalid.product.url": "Billede er påkrævet.",
        "error.invalid.product.project": "Du skal vælge et projekt for at tilføje et produkt.",
        "error.select_product": "Vælg mindst ét produkt/tjeneste.",
        "error.select_media": "Vælg mindst ét billede.",
        "error.select_themes": "Vælg mindst ét emne.",
        "error.select_a_post": "Vælg mindst ét indlæg.",
        "error.type_context": "Indtast en instruktion for at generere indlæg.",
        "error.max_media_items": "Du kan kun vælge op til 5 elementer.",
        "error.save_posts": "Fejl ved lagring af indlæg.",
        "label.mode_themes": "Vælg emner",
        "label.mode_themes_description": "Vælg de emner, du vil tage op",
        "label.mode_product": "Produkt eller Service",
        "label.mode_product_description": "Vælg et produkt eller en tjeneste at tale om",
        "label.mode_dates": "Mindedage",
        "label.mode_dates_description": "Vælg en erindringsdato",
        "label.mode_media": "Billede",
        "label.mode_media_description": "Vælg et eller flere billeder",
        "label.mode_instruction": "Instruktion",
        "label.mode_instruction_description": "Beskriv hvad du har brug for",
        "label.mode_link": "Forbindelse",
        "label.mode_link_description": "Indsæt et link for at generere et indlæg",
        "label.mode_empty": "Blankt indlæg",
        "label.mode_empty_description": "Opret et indlæg fra bunden",
        "label.mode_existing": "Planlæg indlæg",
        "label.mode_existing_description": "Planlæg et billede/video",
        "layout.smart_any": "Enhver",
        "layout.smart_title_grid": "Gitter",
        "layout.smart_vertical": "Lodret",
        "layout.smart_horizontal": "Vandret",
        "layout.smart_title_style": "Stil",
        "layout.smart_geometric": "Geometrisk",
        "layout.smart_rounded": "Afrundet",
        "layout.smart_title_shader": "Udseende",
        "layout.smart_flat": "Flad",
        "layout.smart_gradient": "Gradient",
        "layout.smart_pattern": "Mønster",
        "layout.smart_3d": "3D",
        "layout.smart_title_orientation": "Billedposition",
        "layout.smart_begin": "Begynde",
        "layout.smart_end": "Ende",
        "layout.smart_title_alignment": "Justering",
        "layout.smart_left": "Venstre",
        "layout.smart_center": "Centrum",
        "layout.smart_right": "Højre",
        "layout.smart_title_focus": "Fokus",
        "layout.smart_text": "Tekst",
        "layout.smart_balanced": "Balanceret",
        "layout.smart_fullscreen": "Fuldskærm",
        "layout.smart_title_decorative": "Dekorative",
        "layout.smart_yes": "Ja",
        "layout.smart_no": "Ingen",
        "layout.smart_title_include_shapes": "Former",
        "error.generator_no_content": "Kunne ikke finde indhold i dette link",
        "error.generator_no_link": "Indsæt venligst et link",
        "gen.product.objective": "Objektiv",
        "gen.product.price": "Pris",
        "gen.product.info": "Information",
        "gen.product.cta": "Opfordring til handling",
        "gen.product.discount": "Rabat",
        "tab.media_my_videos": "Mine videoer",
        "tab.media_videos_database": "Video database",
        "error.invalid.max_size": "Den maksimale filstørrelse skal være %s.",
        "label.too_long_video": "Indlæg må højst være %s minutter lange.",
        "label.affiliate_created": "Opret din affiliate kode",
        "label.affiliate_message": "Indtast kun koden, den ser sådan ud, når du deler:",
        "label.affiliate_code_name": "DIN KODE",
        "error.affiliate.code_exists": "Affiliate kode i brug, vælg venligst en anden",
        "generic.no": "Ingen",
        "generic.yes": "Ja",
        "generator.include_related": "Vil du inkludere relaterede emner?",
        "generator.tone": "Tone i stemmen",
        "generator.tone_normal": "Normal",
        "generator.tone_formal": "Formel",
        "generator.tone_fun": "Sjov",
        "generator.tone_informal": "Uformel",
        "generator.tone_informative": "Informativ",
        "generator.tone_inspiring": "Inspirerende",
        "generator.tone_polemic": "Polemik",
        "generator.tone_curious": "Nysgerrighed",
        "generator.objective": "Objektiv",
        "generator.objective_authority": "Myndighed",
        "generator.objective_sales": "Salg",
        "generator.objective_custom": "Brugerdefinerede",
        "generator.authority_list": "Liste",
        "generator.authority_opinion": "Udtalelse",
        "generator.authority_question": "Spørgsmål",
        "generator.authority_checklist": "Tjekliste",
        "generator.authority_news": "Nyheder",
        "generator.authority_trivia": "Trivia",
        "generator.content_type": "Indholdstype",
        "generator.authority_faq": "Spørgsmål og svar",
        "generator.authority_tips": "Tips",
        "generator.authority_tutorial": "Selvstudier",
        "generator.authority_myths": "Myter og sandheder",
        "generator.authority_errors": "Almindelige fejl",
        "generator.authority_trends": "Trends",
        "generator.sales_hooks": "Salgskroge",
        "generator.sales_benefits": "Fordele",
        "generator.sales_features": "Funktioner",
        "generator.sales_offers": "Tilbud",
        "generator.sales_cta": "Opfordring til handling",
        "generator.sales_social_proof": "Socialt bevis",
        "generator.tone_tooltip": "Tonen i dine indlæg",
        "generator.objective_tooltip": "Myndighedsposter er med til at vise din viden på området. Salgsindlæg bruges til at promovere et produkt eller en service",
        "generator.format_tooltip": "Outputformat for dit indlæg",
        "generator.include_related_tooltip": "Medtag relaterede emner for at tilføje indholdsvariation",
        "generator.size": "Titelstørrelse",
        "generator.size_short": "Kort",
        "generator.size_medium": "Medium",
        "generator.size_long": "Lang",
        "generator.include_profile": "Relateret til min virksomhed",
        "generator.include_profile_tooltip": "Vælg, om de genererede indlæg skal være relateret til din virksomhed eller mere generiske",
        "error.media_in_use": "Dette billede bliver brugt i et indlæg og kan ikke fjernes",
        "success.cancel_account": "Kontoen er blevet annulleret!",
        "error.fill_required_fields": "Udfyld venligst alle obligatoriske felter",
        "generator.media_format": "Post filtype",
        "generator.media_format_image": "Billede",
        "generator.media_format_video": "Video",
        "generator.hasCaption": "Har du oprettet en billedtekst?",
        "generator.post_format": "Format",
        "generator.post_format_post": "Stolpe",
        "generator.post_format_reels": "Hjul",
        "generator.post_format_story": "Story",
        "error.format_post_not_support_media": "Det valgte postformat understøtter ikke denne type medier",
        "error.limit_posts_per_format": "Det valgte postformat understøtter ikke så mange filer",
        "label.content_already_generated": "Dit indlæg har allerede genereret indhold. Vil du overskrive karruselsiderne? Den første side vil blive gemt.",
        "error.post_duration_exceeded": "Opslagets varighed overskred den maksimale grænse på %s sekunder."
    },
    "sv": {
        "instagram.handle.error": "Kunde inte hitta Instagram-profilen",
        "error.generating.content": "Det gick inte att skapa innehåll",
        "error.saving.post": "Det gick inte att spara inlägget",
        "success.saving.post": "Inlägget har sparats",
        "error.validation.context": "Vänligen fyll i alla fält",
        "error.validation.email": "Vänligen fyll i en giltig e-post",
        "error.imageLoading": "Vänta lite, vi laddar inläggsbilden",
        "instagram.handle.at_removed": "Inget behov av @, bara profilnamnet",
        "info.config.show": "Klicka på inläggsbilden för att redigera färger, typsnitt och andra detaljer",
        "error.invalid.image": "Det gick inte att ladda upp bilden",
        "success.trial_started": "Välkommen till provversionen av Magic Editor 🥳",
        "error.starting_trial": "Det gick inte att starta provversionen",
        "category.all": "Allt",
        "category.images": "Bilder",
        "category.cover": "Omslag",
        "category.slide": "Glida",
        "category.news": "Nyheter",
        "category.social": "Social",
        "category.quote": "Citat",
        "category.question": "Fråga",
        "category.list": "Lista",
        "category.number": "Lista",
        "category.checklist": "Checklista",
        "category.before-after": "Före och efter",
        "category.trivia": "Trivia",
        "error.invalid.image_must_be_png": "Bilden måste vara PNG med transparent bakgrund",
        "error.project.create": "Det gick inte att skapa projektet",
        "source.Save Post": "Spara inlägget",
        "source.Preview Post": "Förhandsgranska inlägg",
        "source.Download Post": "Ladda ner Post",
        "source.Refresh Keywords": "Uppdatera sökord",
        "source.Upload Logo": "Ladda upp logotyp",
        "source.Upload Social Logo": "Ladda upp profilbild",
        "source.Publish Item": "Publicera objekt",
        "source.Edit Item": "Redigera objekt",
        "source.Save Item": "Spara objekt",
        "source.Captions Item": "Skapa bildtexter",
        "source.Generated once but not logged in": "Skapa fler inlägg",
        "source.Generated once but not customer": "Skapa fler inlägg",
        "source.Max projects reached": "Lägg till fler projekt",
        "source.Publish Post Directly": "Publicera inlägg direkt på Instagram",
        "source.Schedule Posts": "Schemalägg inlägg på Instagram",
        "source.Generate Audience": "Skapa målgrupp",
        "source.Generate Audience Needs": "Generera publikbehov",
        "source.Generate Audience Goals": "Skapa målgruppsmål",
        "source.Generate Captions": "Skapa bildtexter",
        "source.Create Scratch": "Skapa inlägg från grunden",
        "source.Custom Fonts": "Ladda upp anpassade teckensnitt",
        "source.Use my medias": "Använd mina bilder",
        "source.Edit Themes": "Redigera teman",
        "source.Bulk Edit": "Massredigera inlägg",
        "source.Save Replan": "Spara inlägg planering",
        "source.Remove Schedule": "Ta bort schema",
        "source.Pin Post": "Favoritinlägg",
        "source.Finish Theme Selection": "Avsluta val av ämnen",
        "source.Regenerate Post": "Återskapa inlägg",
        "source.Change Calendar Range": "Ändra kalenderintervall",
        "source.Remove Post": "Ta bort inlägg",
        "source.Edit Post": "Redigera inlägg",
        "source.Skip Day": "Hoppa över dag",
        "source.Publish Reels": "Skapa och publicera rullar",
        "source.Add more products": "Lägg till fler produkter",
        "source.Save Post Calendar": "Spara inlägget",
        "source.Select Audio": "Välj Musik",
        "source.Select Video": "Välj Video",
        "plan.filter.monthly": "En gång i månaden",
        "plan.filter.annual": "Årlig",
        "features.infinite_ideas": "Obegränsade inläggsidéer",
        "features.custom_style": "Anpassning av inlägg",
        "features.integrated_publishing": "Automatisk publicering",
        "features.unlimited_accounts": "Obegränsade konton",
        "features.1_account": "1 socialt konto",
        "features.accounts": "företag",
        "features.reels": "Rullar och inläggsanimationer",
        "features.audio": "Musik i inlägg",
        "features.custom_videos": "Videobibliotek",
        "features.unlimited_posts": "Obegränsade inlägg",
        "label.plans_trial_days": "14 dagars gratis provperiod",
        "label.plans_cancel_anytime": "Avbryt när som helst",
        "error.upgrade_plan": "Det gick inte att uppgradera planen, försök igen",
        "error.not_possible_find_instagram_account": "Hittade du inte ditt Instagramkonto?",
        "label.to_connect_you_need": "Att ansluta:",
        "label.no_instagram_enabled": "Den här sidan är inte kopplad till Instagram",
        "error.please_select_page": "Välj en sida",
        "error.please_select_target": "Välj var du vill publicera",
        "error.please_select_format": "Välj inläggsformat",
        "error.scheduling_post": "Det gick inte att schemalägga inlägget, försök igen",
        "error.creating_scratch": "Det gick inte att skapa inlägget",
        "error.authenticating_facebook": "Det gick inte att autentisera med Facebook, försök igen",
        "success.scheduling_post": "Inlägget har schemalagts!",
        "success.scheduling_post_limit": "Inlägget har schemalagts! Även om vi inte har schemaläggningsgränser, kan schemaläggning av många inlägg på samma dag på Instagram/Facebook orsaka begränsningar för din profil. Vi rekommenderar att du schemalägger upp till max 3 inlägg per dag.",
        "scratch.post1.title": "Titeln på ditt inlägg om <b>vilket ämne</b> du vill ha",
        "scratch.post1.description": "Skriv på nästa rad för att bli beskrivningen",
        "scratch.post2.title": "Lämna utrymme på en ny rad för att starta en ny bild",
        "scratch.post3.title": "Markera med <b>relevanta delar i fetstil</b> för att markera",
        "scratch.post4.title": "<b>1.</b> Markera med fet stil i början för att skapa en lista",
        "scratch.post5.title": "<b>2.</b> Klicka på en bild för att redigera bilder, layout, typsnitt och färger",
        "error_publish.too_many_items": "Instagram tillåter maximalt 10 inlägg per karusell. Ta bort visst innehåll för att fortsätta.",
        "error_publish.no_content": "Du måste lägga till innehåll i inlägget för att fortsätta.",
        "error_publish.caption_too_long": "Inläggstexten får inte vara mer än 2000 tecken.",
        "error_publish.too_many_hashtags": "Du kan lägga till maximalt 30 hashtags per inlägg.",
        "error_publish.no_caption": "Du måste lägga till en bildtext till inlägget",
        "error_publish.already_scheduled": "Detta inlägg har redan publicerats på denna sida",
        "instagram.handle.too_long": "Instagram-handtaget är för långt. Är du säker på att det stämmer?",
        "success.canceling_publish": "Inlägget avbröts!",
        "error.canceling_publish": "Det gick inte att avbryta inlägget, försök igen",
        "label.how_to_connect_instagram": "Klicka här för att lära dig hur du kopplar ditt Instagram-konto till Galilai",
        "plan.upgraded": "Planen har uppgraderats!",
        "tags.all": "visa allt",
        "tags.base": "ingen bakgrund",
        "tags.blob": "klick",
        "tags.lines": "rader",
        "tags.waves": "vågor",
        "tags.swipe": "hårt slag",
        "tags.circles": "cirklar",
        "tags.points": "poäng",
        "tags.corner": "hörn",
        "elements.h1": "Titel",
        "elements.p": "Beskrivning",
        "elements.image": "Bild",
        "elements.overlay": "Element",
        "elements.span": "Text",
        "elements.rect": "Rektangel",
        "elements.circle": "Cirkel",
        "elements.trapezoid": "Trapets",
        "elements.svg": "Grafisk",
        "icons.suggested.arrow": "pil",
        "icons.suggested.heart": "hjärta",
        "icons.suggested.bubble": "bubbla",
        "icons.suggested.shopping": "handla",
        "icons.suggested.phone": "telefon",
        "icons.suggested.local": "lokal",
        "icons.suggested.star": "stjärna",
        "error.publish_reels_not_supported": "Rullar stöds inte ännu",
        "error.you_need_to_reconnect_for_facebook_permissions": "Du måste återansluta ditt Facebook-konto för att få behörighet att publicera",
        "label.already_caption_filled": "En bildtext har redan skapats, vill du skriva över den?",
        "label.type_search": "Skriv för att söka",
        "label.colors_theme": "Teman",
        "label.colors_custom": "Beställnings",
        "label.colors_picker": "Välj från min logotyp",
        "label.main_color": "Huvudfärg",
        "label.text_color": "Text färg",
        "label.accent_color": "Accentfärg",
        "label.project": "Projekt",
        "button.upload_file_detect_color": "Skicka en bild för att identifiera färgerna",
        "label.click_to_edit_color": "Redigera färg",
        "label.click_to_select_color": "Välj färg",
        "error.please_add_caption": "Du måste lägga till en bildtext till inlägget",
        "label.month_long_1": "Januari",
        "label.month_long_2": "Februari",
        "label.month_long_3": "Mars",
        "label.month_long_4": "April",
        "label.month_long_5": "Maj",
        "label.month_long_6": "Juni",
        "label.month_long_7": "Juli",
        "label.month_long_8": "Augusti",
        "label.month_long_9": "September",
        "label.month_long_10": "Oktober",
        "label.month_long_11": "November",
        "label.month_long_12": "December",
        "label.month_short_1": "Jan",
        "label.month_short_2": "Feb",
        "label.month_short_3": "Mar",
        "label.month_short_4": "Apr",
        "label.month_short_5": "Maj",
        "label.month_short_6": "Jun",
        "label.month_short_7": "Jul",
        "label.month_short_8": "Aug",
        "label.month_short_9": "Sep",
        "label.month_short_10": "Okt",
        "label.month_short_11": "Nov",
        "label.month_short_12": "Dec",
        "error.empty_post_text_caption": "Ditt inlägg är tomt, lägg till en text för att skapa en bildtext",
        "label.publish_status_pending": "Väntar på redigering",
        "label.publish_status_initial": "Schemalagt",
        "label.publish_status_published": "Publicerad",
        "label.publish_status_error": "Fel vid publicering",
        "error.calendar_full": "Kalendern är full, gå till nästa månad för att schemalägga fler inlägg eller ändra dina inläggsplaneringsinställningar.",
        "label.calendar_other_themes": "andra ämnen",
        "label.calendar_other_theme": "annat ämne",
        "label.calendar_replan_success": "Inläggen har uppdaterats",
        "error.calendar_replan_error": "Fel vid uppdatering av inlägg",
        "error.calendar_no_posts": "Inga inlägg att redigera, klicka på Generera för att skapa inlägg.",
        "error.calendar_no_topics": "Välj minst ett ämne för att skapa inlägg",
        "error.generate_empty_profile": "Din profil är tom, beskriv lite om din verksamhet",
        "error.not_logged_in": "Du är inte inloggad, logga in för att fortsätta",
        "error.loading.post": "Det gick inte att läsa in inlägget, försök igen",
        "error.calendar_drop_past": "Du kan inte dra inlägg till tidigare datum",
        "error.calendar_topic_exists": "Det här ämnet finns redan",
        "label.today": "I dag",
        "label.help_modal": "Hjälpcenter",
        "error_publish.media_error": "Ett fel uppstod när dina bilder laddades upp. Var god försök igen.",
        "error_publish.invalid_images": "Ett fel uppstod när dina bilder laddades upp. Var god försök igen.",
        "error_publish.invalid_page": "Den valda sidan är inte giltig. Ändrade du kopplingen till Facebook? Till exempel: om du loggat in med ett nytt Facebook-konto kommer de tidigare anslutna sidorna inte längre att vara tillgängliga.",
        "error_publish.carousel_error": "Ett fel uppstod när karusellen skulle publiceras. Var god försök igen.",
        "error_publish.invalid_caption": "Bildtexten är för lång eller har fler än 40 hashtags. Vänligen redigera bildtexten och försök igen.",
        "error_publish.invalid_instagram_account": "Ogiltigt Instagram-konto eller så är det inte företagstyp. Ändrade du kopplingen till Facebook? Till exempel: om du loggat in med ett nytt Facebook-konto kommer de tidigare anslutna sidorna inte längre att vara tillgängliga.",
        "error_publish.instagram_business_error": "Instagram-kontot är inte ett företagskonto. Vänligen konvertera ditt konto till ett företagskonto för att fortsätta.",
        "error_publish.user_restricted": "Ditt Instagram- eller Facebook-konto kan vara begränsat. Gå till <a target='_blank' href='https://www.facebook.com/business-support-home/?landing_page=overview'>denna länk</a> för att kontrollera begränsningarna och hur du låser upp ditt konto",
        "error_publish.rate_limit": "Även om vi inte har någon gräns på inlägg så har Instagram/Facebook en gräns. Om du fortsätter att posta många inlägg per dag kan det leda till att ditt konto blockeras. Vi föreslår att du slutar publicera för idag och försöker igen imorgon och med en lägre volym av inlägg, tills begränsningen tas bort.",
        "error_publish.publish_error": "Ett fel uppstod vid publicering. Var god försök igen.",
        "error_publish.publish_error_story": "Ett fel uppstod när berättelsen skulle publiceras. Var god försök igen.",
        "error_publish.publish_error_carousel": "Ett fel uppstod när karusellen skulle publiceras. Var god försök igen.",
        "error_publish.reauth_required": "Du måste återansluta ditt Facebook-konto. Klicka på \"Anslut mina sidor\" och följ instruktionerna.",
        "error.generic": "Oväntat fel. Var god försök igen",
        "error.calendar_topic_length": "Ämnet måste innehålla mellan 3 och 150 tecken",
        "label.post_type_carousel": "Karusell",
        "label.post_type_single": "Enstaka inlägg",
        "label.import_tabs_image": "Bilder",
        "label.import_tabs_text": "Texter",
        "label.import_tabs_background": "Former",
        "label.import_tabs_colors": "Färger",
        "label.import_tabs_fonts": "Teckensnitt",
        "label.import_option_title": "Titel",
        "label.import_option_description": "Beskrivning",
        "label.import_option_fixed_text": "Fast text",
        "label.import_option_main_image": "Huvudbild",
        "label.import_option_fixed_image": "Fast bild",
        "label.import_option_email": "E-post",
        "label.import_option_address": "Adress",
        "label.import_option_phone": "Telefon",
        "label.import_option_website": "Hemsida",
        "label.import_option_person_image": "Personbild",
        "label.import_option_list_item": "Listobjekt",
        "label.import_option_list_cta": "Uppmaning till handling",
        "label.import_option_main_color": "Huvudfärg",
        "label.import_option_text_color": "Text färg",
        "label.import_option_highlight_color": "Markeringsfärg",
        "label.import_option_font_title": "Titel teckensnitt",
        "label.import_option_font_body": "Kroppstypsnitt",
        "label.import_option_font_subtitle": "Textningstypsnitt",
        "label.import_hide": "Dölj",
        "label.import_main_color": "Huvudfärg",
        "label.import_number": "Siffra",
        "label.import_author_handle": "Hantera",
        "label.remove_project_confirm": "Är du säker på att du vill ta bort projektet? Alla inlägg från detta projekt kommer att tas bort.",
        "error.remove_project_last": "Du kan inte ta bort ditt enda projekt",
        "label.import_layout_success": "Layouten har importerats",
        "label.import_option_contextual_fixed_image": "Fast bild (kontextuell)",
        "label.success_generic": "Framgång!",
        "success.generic": "Framgång!",
        "label.are_you_sure": "Är du säker?",
        "label.professional_area": "Jag arbetar inom området",
        "label.profile_handle": "@min profil",
        "label.profile_name": "Mitt namn",
        "area_business.medicine": "Medicin",
        "area_business.psychology": "Psykologi",
        "area_business.law": "Lag",
        "area_business.wellness": "Hälsa & välbefinnande",
        "area_business.education": "Utbildning",
        "area_business.personal_care": "Personlig vård",
        "area_business.cosmetics": "Kosmetika",
        "area_business.fitness": "Kondition",
        "area_business.finance": "Finansiera",
        "area_business.accounting": "Bokföring",
        "area_business.construction": "Konstruktion",
        "area_business.real_estate": "Fastighet",
        "area_business.architecture": "Arkitektur",
        "area_business.tech": "Teknologi",
        "area_business.pets": "Husdjur",
        "area_business.coaching": "Coaching",
        "area_business.clothing": "Mode",
        "area_business.restaurant": "Restaurang",
        "area_business.automotive": "Bil",
        "area_business.transport": "Transport",
        "label.media_select_image": "Välj en bild",
        "label.media_select_audio": "Välj ett ljud",
        "label.media_select_video": "Välj en video",
        "label.media_select_elements": "Välj ett element",
        "label.media_select_fonts": "Välj ett teckensnitt",
        "label.media_select_product": "Välj en produkt eller tjänst",
        "tab.media_icons_database": "Ikoner",
        "tab.media_images_database": "Bilddatabas",
        "tab.media_audio_database": "Musikdatabas",
        "tab.media_video_database": "Videodatabas",
        "tab.media_my_fonts": "Mina teckensnitt",
        "tab.media_my_images": "Mina bilder",
        "tab.media_my_audio": "Min musik",
        "tab.media_my_video": "Mina videor",
        "tab.media_my_products": "Mina produkter och tjänster",
        "btn.remove_bg": "Ta bort bakgrund",
        "btn.remove": "Avlägsna",
        "btn.select": "Välj",
        "label.folder_home": "Allt",
        "tag.audio_all": "Allt",
        "tag.audio_upbeat": "Optimistisk",
        "tag.audio_happy": "Lycklig",
        "tag.audio_inspiring": "Inspirerande",
        "tag.audio_chill": "Kyla",
        "label.need_to_increase_quantity": "du måste öka antalet företag i din plan",
        "label.multiple_pages": "Flera sidor",
        "label.one_page": "En sida",
        "error.rendering_post": "Fel vid nedladdning av inlägg. Var god försök igen",
        "label.otp_verified_mobile": "Din inloggning lyckades! Gå tillbaka till appen för att fortsätta.",
        "label.otp_verified": "Din inloggning lyckades!",
        "success.connected_facebook_app": "Du har framgångsrikt kopplat dina sociala konton! Gå tillbaka till mobilappen för att fortsätta.",
        "label.app_update_available": "En ny version av appen är tillgänglig. Uppdatera för att komma åt nya funktioner.",
        "label.app_update_available_required": "En ny version av appen är tillgänglig. Uppdatera för att fortsätta använda appen.",
        "tab.favorites": "Favoriter",
        "error.missing_project_favorite": "Gå till favoritfliken och välj ett projekt först",
        "label.my_text": "Min text",
        "label.remove_generic": "Är du säker på att du vill ta bort?",
        "label.confirm_reset_layout": "Är du säker på att du vill ta bort formateringen? Layouten återgår till standardinställningen.",
        "error.invalid.file_type": "Ogiltig filtyp",
        "success.copy_clipboard": "Kopierat till urklipp!",
        "label.remove_all_posts_confirm": "Är du säker på att du vill ta bort alla inlägg? Du kommer inte att kunna återställa dem.",
        "label.post_should_be_tall": "Inläggstypen du valde bör använda en vertikal storlek, annars kommer den att beskäras när den publiceras. Vill du ändra dig ändå?",
        "label.my_palletes": "Mina paletter",
        "label.my_colors": "Mina färger",
        "label.generic_add": "Lägg till",
        "label.generic_edit": "Redigera",
        "label.generic_save": "Spara",
        "label.generic_remove": "Avlägsna",
        "label.generic_cancel": "Annullera",
        "label.add_new_pallete": "Lägg till ny palett",
        "label.apply_pallete": "Använd palett",
        "label.title_font_header": "Titel",
        "label.description_font_header": "Beskrivning",
        "label.text_min_size": "Minsta storlek",
        "label.text_max_size": "Maximal storlek",
        "label.font_size_info": "Teckenstorlekar justeras automatiskt för att säkerställa bästa läsbarhet. För att anpassa, justera lägsta och högsta värden. För att ställa in en specifik storlek, klicka på texten och justera direkt.",
        "label.text_min_size_tooltip": "Minsta teckenstorlek när det är mycket text och det måste minskas för att passa det tillgängliga utrymmet.",
        "label.text_max_size_tooltip": "Standard och maximal storlek som teckensnittet kan justeras.",
        "label.feature_contact_support": "Kontakta supporten för att aktivera den här funktionen. Vill du starta en chatt?",
        "label.iap_info_ios": "Prenumerationer kommer att debiteras ditt kreditkort via ditt iTunes-konto. Prenumerationer förnyas automatiskt om de inte avbryts inom 24 timmar före slutet av den aktuella perioden. Du kan avbryta när som helst med dina iTunes-kontoinställningar.",
        "error.iap_other_account": "Du har en aktiv prenumeration med en annan e-post. Logga in med rätt e-postadress.",
        "error.invalid.product": "Namn och bilder krävs.",
        "error.invalid.product.name": "Namn krävs.",
        "error.invalid.product.price": "Pris krävs.",
        "error.invalid.product.url": "Bild krävs.",
        "error.invalid.product.project": "Du måste välja ett projekt för att lägga till en produkt.",
        "error.select_product": "Välj minst en produkt/tjänst.",
        "error.select_media": "Välj minst en bild.",
        "error.select_themes": "Välj minst ett ämne.",
        "error.select_a_post": "Välj minst ett inlägg.",
        "error.type_context": "Skriv en instruktion för att skapa inlägg.",
        "error.max_media_items": "Du kan bara välja upp till 5 objekt.",
        "error.save_posts": "Det gick inte att spara inlägg.",
        "label.mode_themes": "Välj ämnen",
        "label.mode_themes_description": "Välj de ämnen du vill ta upp",
        "label.mode_product": "Produkt eller tjänst",
        "label.mode_product_description": "Välj en produkt eller tjänst att prata om",
        "label.mode_dates": "Jubileumsdatum",
        "label.mode_dates_description": "Välj ett minnesdatum",
        "label.mode_media": "Bild",
        "label.mode_media_description": "Välj en eller flera bilder",
        "label.mode_instruction": "Instruktion",
        "label.mode_instruction_description": "Beskriv vad du behöver",
        "label.mode_link": "Länk",
        "label.mode_link_description": "Klistra in en länk för att skapa ett inlägg",
        "label.mode_empty": "Tomt inlägg",
        "label.mode_empty_description": "Skapa ett inlägg från grunden",
        "label.mode_existing": "Schemalägg inlägg",
        "label.mode_existing_description": "Schemalägg en bild/video",
        "layout.smart_any": "Några",
        "layout.smart_title_grid": "Rutnät",
        "layout.smart_vertical": "Vertikal",
        "layout.smart_horizontal": "Horisontell",
        "layout.smart_title_style": "Stil",
        "layout.smart_geometric": "Geometrisk",
        "layout.smart_rounded": "Avrundad",
        "layout.smart_title_shader": "Utseende",
        "layout.smart_flat": "Platt",
        "layout.smart_gradient": "Lutning",
        "layout.smart_pattern": "Mönster",
        "layout.smart_3d": "3D",
        "layout.smart_title_orientation": "Bildposition",
        "layout.smart_begin": "Börja",
        "layout.smart_end": "Avsluta",
        "layout.smart_title_alignment": "Inriktning",
        "layout.smart_left": "Vänster",
        "layout.smart_center": "Centrum",
        "layout.smart_right": "Höger",
        "layout.smart_title_focus": "Fokus",
        "layout.smart_text": "Text",
        "layout.smart_balanced": "Balanserad",
        "layout.smart_fullscreen": "Helskärm",
        "layout.smart_title_decorative": "Dekorativ",
        "layout.smart_yes": "Ja",
        "layout.smart_no": "Inga",
        "layout.smart_title_include_shapes": "Former",
        "error.generator_no_content": "Det gick inte att hitta innehållet i denna länk",
        "error.generator_no_link": "Snälla, infoga en länk",
        "gen.product.objective": "Mål",
        "gen.product.price": "Pris",
        "gen.product.info": "Information",
        "gen.product.cta": "Uppmaning till handling",
        "gen.product.discount": "Rabatt",
        "tab.media_my_videos": "Mina videor",
        "tab.media_videos_database": "Videodatabas",
        "error.invalid.max_size": "Den maximala filstorleken måste vara %s.",
        "label.too_long_video": "Inlägg får vara högst %s minuter långa.",
        "label.affiliate_created": "Skapa din affiliatekod",
        "label.affiliate_message": "Ange bara koden, den ser ut så här när du delar:",
        "label.affiliate_code_name": "DIN KOD",
        "error.affiliate.code_exists": "Affiliate-kod som används, välj en annan",
        "generic.no": "Inga",
        "generic.yes": "Ja",
        "generator.include_related": "Inkludera relaterade ämnen?",
        "generator.tone": "Tonfall",
        "generator.tone_normal": "Normal",
        "generator.tone_formal": "Formell",
        "generator.tone_fun": "Gyckel",
        "generator.tone_informal": "Informell",
        "generator.tone_informative": "Informativ",
        "generator.tone_inspiring": "Inspirerande",
        "generator.tone_polemic": "Polemisk",
        "generator.tone_curious": "Nyfikenhet",
        "generator.objective": "Mål",
        "generator.objective_authority": "Myndighet",
        "generator.objective_sales": "Försäljning",
        "generator.objective_custom": "Beställnings",
        "generator.authority_list": "Lista",
        "generator.authority_opinion": "Omdöme",
        "generator.authority_question": "Fråga",
        "generator.authority_checklist": "Checklista",
        "generator.authority_news": "Nyheter",
        "generator.authority_trivia": "Trivia",
        "generator.content_type": "Innehållstyp",
        "generator.authority_faq": "Frågor och svar",
        "generator.authority_tips": "Tips",
        "generator.authority_tutorial": "Handledningar",
        "generator.authority_myths": "Myter och sanningar",
        "generator.authority_errors": "Vanliga fel",
        "generator.authority_trends": "Trender",
        "generator.sales_hooks": "Försäljningskrokar",
        "generator.sales_benefits": "Fördelar",
        "generator.sales_features": "Drag",
        "generator.sales_offers": "Erbjudanden",
        "generator.sales_cta": "Uppmaning till handling",
        "generator.sales_social_proof": "Socialt bevis",
        "generator.tone_tooltip": "Tonfallet i dina inlägg",
        "generator.objective_tooltip": "Myndighetsinlägg hjälper till att visa din kunskap inom området. Säljinlägg används för att marknadsföra en produkt eller tjänst",
        "generator.format_tooltip": "Utdataformat för ditt inlägg",
        "generator.include_related_tooltip": "Inkludera relaterade ämnen för att lägga till innehållsvariation",
        "generator.size": "Titelstorlek",
        "generator.size_short": "Kort",
        "generator.size_medium": "Medium",
        "generator.size_long": "Lång",
        "generator.include_profile": "Relaterat till min verksamhet",
        "generator.include_profile_tooltip": "Välj om de genererade inläggen ska vara relaterade till ditt företag eller mer generiska",
        "error.media_in_use": "Den här bilden används i ett inlägg och kan inte tas bort",
        "success.cancel_account": "Kontot har avslutats!",
        "error.fill_required_fields": "Vänligen fyll i alla obligatoriska fält",
        "generator.media_format": "Post filtyp",
        "generator.media_format_image": "Bild",
        "generator.media_format_video": "Video",
        "generator.hasCaption": "Har du skapat en bildtext?",
        "generator.post_format": "Formatera",
        "generator.post_format_post": "Posta",
        "generator.post_format_reels": "Rullar",
        "generator.post_format_story": "Story",
        "error.format_post_not_support_media": "Det valda inläggsformatet stöder inte denna typ av media",
        "error.limit_posts_per_format": "Det valda inläggsformatet stöder inte så många filer",
        "label.content_already_generated": "Ditt inlägg har redan genererat innehåll, vill du skriva över karusellsidorna? Den första sidan kommer att behållas.",
        "error.post_duration_exceeded": "Inläggets längd överskred den maximala gränsen på %s sekunder."
    },
    "pl": {
        "instagram.handle.error": "Nie można znaleźć profilu na Instagramie",
        "error.generating.content": "Nie można wygenerować treści",
        "error.saving.post": "Nie udało się zapisać wpisu",
        "success.saving.post": "Post został zapisany pomyślnie",
        "error.validation.context": "Proszę wypełnić wszystkie pola",
        "error.validation.email": "Proszę wypełnić prawidłowy adres e-mail",
        "error.imageLoading": "Poczekaj chwilę, ładujemy obraz posta",
        "instagram.handle.at_removed": "Nie potrzeba @, wystarczy nazwa profilu",
        "info.config.show": "Kliknij obraz wpisu, aby edytować kolory, czcionki i inne szczegóły",
        "error.invalid.image": "Błąd podczas przesyłania obrazu",
        "success.trial_started": "Witamy w wersji próbnej Magic Editor 🥳",
        "error.starting_trial": "Nie można rozpocząć okresu próbnego",
        "category.all": "Wszystko",
        "category.images": "Obrazy",
        "category.cover": "Okładka",
        "category.slide": "Slajd",
        "category.news": "Aktualności",
        "category.social": "Społeczny",
        "category.quote": "Cytat",
        "category.question": "Pytanie",
        "category.list": "Lista",
        "category.number": "Lista",
        "category.checklist": "Lista kontrolna",
        "category.before-after": "Przed i po",
        "category.trivia": "Drobnostki",
        "error.invalid.image_must_be_png": "Obraz musi być w formacie PNG z przezroczystym tłem",
        "error.project.create": "Nie można utworzyć projektu",
        "source.Save Post": "Zapisz Post",
        "source.Preview Post": "Podgląd postu",
        "source.Download Post": "Pobierz wpis",
        "source.Refresh Keywords": "Odśwież słowa kluczowe",
        "source.Upload Logo": "Prześlij logo",
        "source.Upload Social Logo": "Prześlij zdjęcie profilowe",
        "source.Publish Item": "Opublikuj element",
        "source.Edit Item": "Edytuj rzecz",
        "source.Save Item": "Zapisz element",
        "source.Captions Item": "Generuj napisy",
        "source.Generated once but not logged in": "Wygeneruj więcej postów",
        "source.Generated once but not customer": "Wygeneruj więcej postów",
        "source.Max projects reached": "Dodaj więcej projektów",
        "source.Publish Post Directly": "Opublikuj post bezpośrednio na Instagramie",
        "source.Schedule Posts": "Zaplanuj posty na Instagramie",
        "source.Generate Audience": "Generuj publiczność",
        "source.Generate Audience Needs": "Generuj potrzeby odbiorców",
        "source.Generate Audience Goals": "Generuj cele odbiorców",
        "source.Generate Captions": "Generuj napisy",
        "source.Create Scratch": "Utwórz post od zera",
        "source.Custom Fonts": "Prześlij niestandardowe czcionki",
        "source.Use my medias": "Skorzystaj z moich obrazów",
        "source.Edit Themes": "Edytuj motywy",
        "source.Bulk Edit": "Zbiorcza edycja postów",
        "source.Save Replan": "Zapisz planowanie postów",
        "source.Remove Schedule": "Usuń harmonogram",
        "source.Pin Post": "Ulubiony post",
        "source.Finish Theme Selection": "Zakończ wybór tematów",
        "source.Regenerate Post": "Zregeneruj pocztę",
        "source.Change Calendar Range": "Zmień zakres kalendarza",
        "source.Remove Post": "Usuń wpis",
        "source.Edit Post": "Edytuj post",
        "source.Skip Day": "Dzień pomijania",
        "source.Publish Reels": "Twórz i publikuj krążki",
        "source.Add more products": "Dodaj więcej produktów",
        "source.Save Post Calendar": "Zapisz Post",
        "source.Select Audio": "Wybierz opcję Muzyka",
        "source.Select Video": "Wybierz wideo",
        "plan.filter.monthly": "Miesięczny",
        "plan.filter.annual": "Coroczny",
        "features.infinite_ideas": "Nieograniczone pomysły na posty",
        "features.custom_style": "Dostosowywanie postów",
        "features.integrated_publishing": "Automatyczne publikowanie",
        "features.unlimited_accounts": "Nielimitowane konta",
        "features.1_account": "1 konto społecznościowe",
        "features.accounts": "firmy",
        "features.reels": "Animacje rolek i postów",
        "features.audio": "Muzyka w postach",
        "features.custom_videos": "Biblioteka wideo",
        "features.unlimited_posts": "Nieograniczona liczba postów",
        "label.plans_trial_days": "14-dniowy bezpłatny okres próbny",
        "label.plans_cancel_anytime": "Anuluj w dowolnym momencie",
        "error.upgrade_plan": "Błąd aktualizacji planu, spróbuj ponownie",
        "error.not_possible_find_instagram_account": "Nie znalazłeś swojego konta na Instagramie?",
        "label.to_connect_you_need": "Połączyć:",
        "label.no_instagram_enabled": "Z tą stroną nie jest powiązany Instagram",
        "error.please_select_page": "Wybierz stronę",
        "error.please_select_target": "Wybierz miejsce, w którym chcesz opublikować",
        "error.please_select_format": "Wybierz format posta",
        "error.scheduling_post": "Nie udało się zaplanować publikacji. Spróbuj ponownie",
        "error.creating_scratch": "Błąd podczas tworzenia posta",
        "error.authenticating_facebook": "Nie udało się uwierzytelnić na Facebooku. Spróbuj ponownie",
        "success.scheduling_post": "Post został zaplanowany pomyślnie!",
        "success.scheduling_post_limit": "Post zaplanowany pomyślnie! Chociaż nie mamy limitów planowania, planowanie wielu postów tego samego dnia na Instagramie/Facebooku może powodować ograniczenia w Twoim profilu. Zalecamy planowanie maksymalnie 3 postów dziennie.",
        "scratch.post1.title": "Tytuł Twojego posta na <b>dowolny temat</b>, jaki chcesz",
        "scratch.post1.description": "Napisz w następnej linii, aby stać się opisem",
        "scratch.post2.title": "Zostaw miejsce w nowej linii, aby rozpocząć nowy obraz",
        "scratch.post3.title": "Zaznacz <b>pogrubione odpowiednie fragmenty</b>, aby je wyróżnić",
        "scratch.post4.title": "<b>1.</b> Zaznacz na początku pogrubioną czcionką, aby utworzyć listę",
        "scratch.post5.title": "<b>2.</b> Kliknij dowolny obraz, aby edytować obrazy, układ, czcionki i kolory",
        "error_publish.too_many_items": "Instagram pozwala na maksymalnie 10 postów na karuzelę. Aby kontynuować, usuń część zawartości.",
        "error_publish.no_content": "Aby kontynuować, musisz dodać treść do posta.",
        "error_publish.caption_too_long": "Tytuł posta nie może mieć więcej niż 2000 znaków.",
        "error_publish.too_many_hashtags": "Możesz dodać maksymalnie 30 hashtagów na post.",
        "error_publish.no_caption": "Musisz dodać podpis do posta",
        "error_publish.already_scheduled": "Ten post był już opublikowany na tej stronie",
        "instagram.handle.too_long": "Uchwyt na Instagramie jest za długi. Czy na pewno jest to prawidłowe?",
        "success.canceling_publish": "Post anulowany pomyślnie!",
        "error.canceling_publish": "Nie można anulować publikacji. Spróbuj ponownie",
        "label.how_to_connect_instagram": "Kliknij tutaj, aby dowiedzieć się, jak połączyć swoje konto na Instagramie z Galilai",
        "plan.upgraded": "Plan został uaktualniony pomyślnie!",
        "tags.all": "Pokaż wszystko",
        "tags.base": "bez tła",
        "tags.blob": "kropelka",
        "tags.lines": "linie",
        "tags.waves": "fale",
        "tags.swipe": "trzepnąć",
        "tags.circles": "koła",
        "tags.points": "zwrotnica",
        "tags.corner": "narożnik",
        "elements.h1": "Tytuł",
        "elements.p": "Opis",
        "elements.image": "Obraz",
        "elements.overlay": "Element",
        "elements.span": "Tekst",
        "elements.rect": "Prostokąt",
        "elements.circle": "Koło",
        "elements.trapezoid": "Trapez",
        "elements.svg": "Graficzny",
        "icons.suggested.arrow": "strzałka",
        "icons.suggested.heart": "serce",
        "icons.suggested.bubble": "bańka",
        "icons.suggested.shopping": "zakupy",
        "icons.suggested.phone": "telefon",
        "icons.suggested.local": "lokalny",
        "icons.suggested.star": "gwiazda",
        "error.publish_reels_not_supported": "Bębny nie są jeszcze obsługiwane",
        "error.you_need_to_reconnect_for_facebook_permissions": "Aby uzyskać uprawnienia do publikowania, musisz ponownie połączyć swoje konto na Facebooku",
        "label.already_caption_filled": "Utworzono już podpis. Czy chcesz go zastąpić?",
        "label.type_search": "Wpisz aby wyszukać",
        "label.colors_theme": "Motywy",
        "label.colors_custom": "Zwyczaj",
        "label.colors_picker": "Wybierz z mojego logo",
        "label.main_color": "Głównym kolor",
        "label.text_color": "Kolor tekstu",
        "label.accent_color": "Kolor akcentujący",
        "label.project": "Projekt",
        "button.upload_file_detect_color": "Wyślij obraz, aby zidentyfikować kolory",
        "label.click_to_edit_color": "Edytuj kolor",
        "label.click_to_select_color": "Wybierz kolor",
        "error.please_add_caption": "Musisz dodać podpis do posta",
        "label.month_long_1": "Styczeń",
        "label.month_long_2": "Luty",
        "label.month_long_3": "Marsz",
        "label.month_long_4": "Kwiecień",
        "label.month_long_5": "Móc",
        "label.month_long_6": "Czerwiec",
        "label.month_long_7": "Lipiec",
        "label.month_long_8": "Sierpień",
        "label.month_long_9": "Wrzesień",
        "label.month_long_10": "Październik",
        "label.month_long_11": "Listopad",
        "label.month_long_12": "Grudzień",
        "label.month_short_1": "Styczeń",
        "label.month_short_2": "Luty",
        "label.month_short_3": "Zniszczyć",
        "label.month_short_4": "Kwiecień",
        "label.month_short_5": "Móc",
        "label.month_short_6": "Czerwca",
        "label.month_short_7": "Lipiec",
        "label.month_short_8": "Sierpień",
        "label.month_short_9": "Wrzesień",
        "label.month_short_10": "Paź",
        "label.month_short_11": "Listopad",
        "label.month_short_12": "Grudzień",
        "error.empty_post_text_caption": "Twój post jest pusty. Dodaj tekst, aby wygenerować podpis",
        "label.publish_status_pending": "Oczekująca edycja",
        "label.publish_status_initial": "Zaplanowany",
        "label.publish_status_published": "Opublikowany",
        "label.publish_status_error": "Błąd podczas publikowania",
        "error.calendar_full": "Kalendarz jest zapełniony, przejdź do następnego miesiąca, aby zaplanować więcej postów lub zmienić ustawienia planowania postów.",
        "label.calendar_other_themes": "inne tematy",
        "label.calendar_other_theme": "inny temat",
        "label.calendar_replan_success": "Posty zostały pomyślnie zaktualizowane",
        "error.calendar_replan_error": "Błąd podczas aktualizowania postów",
        "error.calendar_no_posts": "Brak postów do edycji. Kliknij Generuj, aby utworzyć posty.",
        "error.calendar_no_topics": "Wybierz co najmniej jeden temat, aby wygenerować posty",
        "error.generate_empty_profile": "Twój profil jest pusty, opisz trochę czym się zajmujesz",
        "error.not_logged_in": "Nie jesteś zalogowany, zaloguj się, aby kontynuować",
        "error.loading.post": "Błąd podczas ładowania wpisu. Spróbuj ponownie",
        "error.calendar_drop_past": "Nie możesz przeciągać postów do przeszłych dat",
        "error.calendar_topic_exists": "Ten temat już istnieje",
        "label.today": "Dzisiaj",
        "label.help_modal": "Centrum pomocy",
        "error_publish.media_error": "Wystąpił błąd podczas przesyłania zdjęć. Proszę spróbuj ponownie.",
        "error_publish.invalid_images": "Wystąpił błąd podczas przesyłania zdjęć. Proszę spróbuj ponownie.",
        "error_publish.invalid_page": "Wybrana strona jest nieprawidłowa. Czy zmodyfikowałeś połączenie z Facebookiem? Na przykład: jeśli zalogowałeś się na nowe konto na Facebooku, wcześniej połączone strony nie będą już dostępne.",
        "error_publish.carousel_error": "Wystąpił błąd podczas publikowania karuzeli. Proszę spróbuj ponownie.",
        "error_publish.invalid_caption": "Podpis jest za długi lub zawiera więcej niż 40 hashtagów. Zmień podpis i spróbuj ponownie.",
        "error_publish.invalid_instagram_account": "Nieprawidłowe konto na Instagramie lub nie jest to typ biznesowy. Czy zmodyfikowałeś połączenie z Facebookiem? Na przykład: jeśli zalogowałeś się na nowe konto na Facebooku, wcześniej połączone strony nie będą już dostępne.",
        "error_publish.instagram_business_error": "Konto na Instagramie nie jest kontem firmowym. Aby kontynuować, przekształć swoje konto w konto firmowe.",
        "error_publish.user_restricted": "Twoje konto na Instagramie lub Facebooku może być ograniczone. Wejdź na <a target='_blank' href='https://www.facebook.com/business-support-home/?landing_page=overview'>ten link</a>, aby sprawdzić ograniczenia i sposób odblokowania konta",
        "error_publish.rate_limit": "Chociaż nie mamy limitu postów, Instagram/Facebook mają limit. Dalsze publikowanie wielu postów dziennie może skutkować zablokowaniem konta. Sugerujemy zaprzestanie publikowania dzisiaj i ponowną próbę jutro z mniejszą liczbą postów, aż ograniczenie zostanie zniesione.",
        "error_publish.publish_error": "Wystąpił błąd podczas publikowania. Proszę spróbuj ponownie.",
        "error_publish.publish_error_story": "Wystąpił błąd podczas publikowania historii. Proszę spróbuj ponownie.",
        "error_publish.publish_error_carousel": "Wystąpił błąd podczas publikowania karuzeli. Proszę spróbuj ponownie.",
        "error_publish.reauth_required": "Musisz ponownie połączyć swoje konto na Facebooku. Kliknij „Połącz moje strony” i postępuj zgodnie z instrukcjami.",
        "error.generic": "Niespodziewany błąd. Proszę spróbuj ponownie",
        "error.calendar_topic_length": "Temat musi mieć od 3 do 150 znaków",
        "label.post_type_carousel": "Karuzela",
        "label.post_type_single": "Pojedynczy post",
        "label.import_tabs_image": "Obrazy",
        "label.import_tabs_text": "Teksty",
        "label.import_tabs_background": "Kształty",
        "label.import_tabs_colors": "Zabarwienie",
        "label.import_tabs_fonts": "Czcionki",
        "label.import_option_title": "Tytuł",
        "label.import_option_description": "Opis",
        "label.import_option_fixed_text": "Naprawiono tekst",
        "label.import_option_main_image": "Główny obraz",
        "label.import_option_fixed_image": "Naprawiono obraz",
        "label.import_option_email": "E-mail",
        "label.import_option_address": "Adres",
        "label.import_option_phone": "Telefon",
        "label.import_option_website": "Strona internetowa",
        "label.import_option_person_image": "Obraz Osoby",
        "label.import_option_list_item": "Element listy",
        "label.import_option_list_cta": "Wezwanie do działania",
        "label.import_option_main_color": "Głównym kolor",
        "label.import_option_text_color": "Kolor tekstu",
        "label.import_option_highlight_color": "Podświetlony kolor",
        "label.import_option_font_title": "Czcionka tytułu",
        "label.import_option_font_body": "Czcionka ciała",
        "label.import_option_font_subtitle": "Czcionka napisów",
        "label.import_hide": "Ukrywać",
        "label.import_main_color": "Głównym kolor",
        "label.import_number": "Numer",
        "label.import_author_handle": "Uchwyt",
        "label.remove_project_confirm": "Czy na pewno chcesz usunąć projekt? Wszystkie posty z tego projektu zostaną usunięte.",
        "error.remove_project_last": "Nie możesz usunąć swojego jedynego projektu",
        "label.import_layout_success": "Układ został zaimportowany pomyślnie",
        "label.import_option_contextual_fixed_image": "Naprawiono obraz (kontekstowy)",
        "label.success_generic": "Powodzenie!",
        "success.generic": "Powodzenie!",
        "label.are_you_sure": "Jesteś pewny?",
        "label.professional_area": "Pracuję na terenie",
        "label.profile_handle": "@mój profil",
        "label.profile_name": "Moje imię",
        "area_business.medicine": "Medycyna",
        "area_business.psychology": "Psychologia",
        "area_business.law": "Prawo",
        "area_business.wellness": "Zdrowie i dobre samopoczucie",
        "area_business.education": "Edukacja",
        "area_business.personal_care": "Higieny osobistej",
        "area_business.cosmetics": "Kosmetyki",
        "area_business.fitness": "Zdatność",
        "area_business.finance": "Finanse",
        "area_business.accounting": "Księgowość",
        "area_business.construction": "Budowa",
        "area_business.real_estate": "Nieruchomość",
        "area_business.architecture": "Architektura",
        "area_business.tech": "Technologia",
        "area_business.pets": "Zwierzęta",
        "area_business.coaching": "Coaching",
        "area_business.clothing": "Moda",
        "area_business.restaurant": "Restauracja",
        "area_business.automotive": "Automobilowy",
        "area_business.transport": "Transport",
        "label.media_select_image": "Wybierz obraz",
        "label.media_select_audio": "Wybierz dźwięk",
        "label.media_select_video": "Wybierz film",
        "label.media_select_elements": "Wybierz element",
        "label.media_select_fonts": "Wybierz czcionkę",
        "label.media_select_product": "Wybierz produkt lub usługę",
        "tab.media_icons_database": "Ikony",
        "tab.media_images_database": "Baza danych obrazów",
        "tab.media_audio_database": "Baza danych muzyki",
        "tab.media_video_database": "Baza danych wideo",
        "tab.media_my_fonts": "Moje czcionki",
        "tab.media_my_images": "Moje obrazy",
        "tab.media_my_audio": "Moja muzyka",
        "tab.media_my_video": "Moje filmy",
        "tab.media_my_products": "Moje produkty i usługi",
        "btn.remove_bg": "Usuń tło",
        "btn.remove": "Usunąć",
        "btn.select": "Wybierać",
        "label.folder_home": "Wszystko",
        "tag.audio_all": "Wszystko",
        "tag.audio_upbeat": "Optymistyczny",
        "tag.audio_happy": "Szczęśliwy",
        "tag.audio_inspiring": "Inspirujące",
        "tag.audio_chill": "Chłod",
        "label.need_to_increase_quantity": "musisz zwiększyć liczbę firm w swoim planie",
        "label.multiple_pages": "Wiele stron",
        "label.one_page": "Jedna strona",
        "error.rendering_post": "Błąd podczas pobierania posta. Proszę spróbuj ponownie",
        "label.otp_verified_mobile": "Logowanie powiodło się! Wróć do aplikacji, aby kontynuować.",
        "label.otp_verified": "Logowanie powiodło się!",
        "success.connected_facebook_app": "Pomyślnie połączyłeś swoje konta społecznościowe! Aby kontynuować, wróć do aplikacji mobilnej.",
        "label.app_update_available": "Dostępna jest nowa wersja aplikacji. Zaktualizuj, aby uzyskać dostęp do nowych funkcji.",
        "label.app_update_available_required": "Dostępna jest nowa wersja aplikacji. Zaktualizuj, aby kontynuować korzystanie z aplikacji.",
        "tab.favorites": "Ulubione",
        "error.missing_project_favorite": "Przejdź do zakładki ulubione i najpierw wybierz projekt",
        "label.my_text": "Mój tekst",
        "label.remove_generic": "Czy na pewno chcesz usunąć?",
        "label.confirm_reset_layout": "Czy na pewno chcesz usunąć formatowanie? Układ powróci do domyślnego.",
        "error.invalid.file_type": "Nieprawidłowy typ pliku",
        "success.copy_clipboard": "Skopiowano do schowka!",
        "label.remove_all_posts_confirm": "Czy na pewno chcesz usunąć wszystkie posty? Nie będziesz w stanie ich odzyskać.",
        "label.post_should_be_tall": "Wybrany typ posta powinien używać rozmiaru pionowego, w przeciwnym razie zostanie przycięty po opublikowaniu. Czy chcesz mimo wszystko zmienić?",
        "label.my_palletes": "Moje palety",
        "label.my_colors": "Moje kolory",
        "label.generic_add": "Dodać",
        "label.generic_edit": "Edytować",
        "label.generic_save": "Ratować",
        "label.generic_remove": "Usunąć",
        "label.generic_cancel": "Anulować",
        "label.add_new_pallete": "Dodaj nową paletę",
        "label.apply_pallete": "Użyj palety",
        "label.title_font_header": "Tytuł",
        "label.description_font_header": "Opis",
        "label.text_min_size": "Minimalny rozmiar",
        "label.text_max_size": "Maksymalny rozmiar",
        "label.font_size_info": "Rozmiary czcionek są automatycznie dostosowywane, aby zapewnić najlepszą czytelność. Aby dostosować, dostosuj wartości minimalne i maksymalne. Aby ustawić konkretny rozmiar, kliknij tekst i dostosuj bezpośrednio.",
        "label.text_min_size_tooltip": "Minimalny rozmiar czcionki, stosowany w przypadku dużej ilości tekstu i konieczności jego zmniejszenia w celu dopasowania do dostępnej przestrzeni.",
        "label.text_max_size_tooltip": "Domyślny i maksymalny rozmiar, jaki można dostosować do rozmiaru czcionki.",
        "label.feature_contact_support": "Skontaktuj się z pomocą techniczną, aby włączyć tę funkcję. Czy chcesz rozpocząć czat?",
        "label.iap_info_ios": "Subskrypcje zostaną obciążone Twoją kartą kredytową za pośrednictwem Twojego konta iTunes. Subskrypcje zostaną automatycznie odnowione, chyba że zostaną anulowane w ciągu 24 godzin przed końcem bieżącego okresu. Możesz anulować w dowolnym momencie za pomocą ustawień konta iTunes.",
        "error.iap_other_account": "Masz aktywną subskrypcję z innym adresem e-mail. Zaloguj się za pomocą prawidłowego adresu e-mail.",
        "error.invalid.product": "Podanie imienia i zdjęcia jest wymagane.",
        "error.invalid.product.name": "Imię jest wymagane.",
        "error.invalid.product.price": "Cena jest wymagana.",
        "error.invalid.product.url": "Obraz jest wymagany.",
        "error.invalid.product.project": "Aby dodać produkt, musisz wybrać projekt.",
        "error.select_product": "Wybierz co najmniej jeden produkt/usługę.",
        "error.select_media": "Wybierz co najmniej jeden obraz.",
        "error.select_themes": "Wybierz co najmniej jeden temat.",
        "error.select_a_post": "Wybierz co najmniej jeden post.",
        "error.type_context": "Wpisz instrukcję generowania postów.",
        "error.max_media_items": "Można wybrać maksymalnie 5 pozycji.",
        "error.save_posts": "Błąd podczas zapisywania postów.",
        "label.mode_themes": "Wybierz tematy",
        "label.mode_themes_description": "Wybierz tematy, które chcesz omówić",
        "label.mode_product": "Produkt lub usługa",
        "label.mode_product_description": "Wybierz produkt lub usługę, o której chcesz porozmawiać",
        "label.mode_dates": "Daty pamiątkowe",
        "label.mode_dates_description": "Wybierz datę upamiętnienia",
        "label.mode_media": "Obraz",
        "label.mode_media_description": "Wybierz jeden lub więcej obrazów",
        "label.mode_instruction": "Instrukcja",
        "label.mode_instruction_description": "Opisz czego potrzebujesz",
        "label.mode_link": "Połączyć",
        "label.mode_link_description": "Wklej link, aby wygenerować post",
        "label.mode_empty": "Pusty Post",
        "label.mode_empty_description": "Utwórz post od podstaw",
        "label.mode_existing": "Zaplanuj post",
        "label.mode_existing_description": "Zaplanuj obraz/wideo",
        "layout.smart_any": "Każdy",
        "layout.smart_title_grid": "Siatka",
        "layout.smart_vertical": "Pionowy",
        "layout.smart_horizontal": "Poziomy",
        "layout.smart_title_style": "Styl",
        "layout.smart_geometric": "Geometryczny",
        "layout.smart_rounded": "Bułczasty",
        "layout.smart_title_shader": "Wygląd",
        "layout.smart_flat": "Płaski",
        "layout.smart_gradient": "Gradient",
        "layout.smart_pattern": "Wzór",
        "layout.smart_3d": "3D",
        "layout.smart_title_orientation": "Pozycja obrazu",
        "layout.smart_begin": "Zaczynać",
        "layout.smart_end": "Koniec",
        "layout.smart_title_alignment": "Wyrównanie",
        "layout.smart_left": "Lewy",
        "layout.smart_center": "Centrum",
        "layout.smart_right": "Prawidłowy",
        "layout.smart_title_focus": "Centrum",
        "layout.smart_text": "Tekst",
        "layout.smart_balanced": "Zrównoważony",
        "layout.smart_fullscreen": "Pełny ekran",
        "layout.smart_title_decorative": "Dekoracyjny",
        "layout.smart_yes": "Tak",
        "layout.smart_no": "NIE",
        "layout.smart_title_include_shapes": "Kształty",
        "error.generator_no_content": "Nie można znaleźć treści w tym linku",
        "error.generator_no_link": "Proszę wstawić link",
        "gen.product.objective": "Cel",
        "gen.product.price": "Cena",
        "gen.product.info": "Informacja",
        "gen.product.cta": "Wezwanie do działania",
        "gen.product.discount": "Rabat",
        "tab.media_my_videos": "Moje filmy",
        "tab.media_videos_database": "Baza danych wideo",
        "error.invalid.max_size": "Maksymalny rozmiar pliku wynosi %s.",
        "label.too_long_video": "Posty mogą mieć długość maksymalnie %s minut.",
        "label.affiliate_created": "Utwórz swój kod partnerski",
        "label.affiliate_message": "Wprowadź tylko kod, podczas udostępniania będzie wyglądał następująco:",
        "label.affiliate_code_name": "TWÓJKOD",
        "error.affiliate.code_exists": "Kod partnerski jest w użyciu, proszę wybrać inny",
        "generic.no": "NIE",
        "generic.yes": "Tak",
        "generator.include_related": "Czy uwzględnić powiązane tematy?",
        "generator.tone": "Ton głosu",
        "generator.tone_normal": "Normalna",
        "generator.tone_formal": "Formalny",
        "generator.tone_fun": "Zabawa",
        "generator.tone_informal": "Nieformalny",
        "generator.tone_informative": "Informacyjny",
        "generator.tone_inspiring": "Inspirujące",
        "generator.tone_polemic": "Polemiczny",
        "generator.tone_curious": "Ciekawość",
        "generator.objective": "Cel",
        "generator.objective_authority": "Władza",
        "generator.objective_sales": "Obroty",
        "generator.objective_custom": "Zwyczaj",
        "generator.authority_list": "Lista",
        "generator.authority_opinion": "Opinia",
        "generator.authority_question": "Pytanie",
        "generator.authority_checklist": "Lista kontrolna",
        "generator.authority_news": "Aktualności",
        "generator.authority_trivia": "Drobnostki",
        "generator.content_type": "Typ zawartości",
        "generator.authority_faq": "Pytania i odpowiedzi",
        "generator.authority_tips": "Porady",
        "generator.authority_tutorial": "Samouczki",
        "generator.authority_myths": "Mity i prawdy",
        "generator.authority_errors": "Typowe błędy",
        "generator.authority_trends": "Trendy",
        "generator.sales_hooks": "Haczyki sprzedażowe",
        "generator.sales_benefits": "Korzyści",
        "generator.sales_features": "Cechy",
        "generator.sales_offers": "Oferty",
        "generator.sales_cta": "Wezwanie do działania",
        "generator.sales_social_proof": "Dowód społeczny",
        "generator.tone_tooltip": "Ton głosu Twoich postów",
        "generator.objective_tooltip": "Posty autorytetu pomagają pokazać Twoją wiedzę w tej dziedzinie. Posty sprzedażowe są używane do promowania produktu lub usługi",
        "generator.format_tooltip": "Format wyjściowy Twojego posta",
        "generator.include_related_tooltip": "Dodaj powiązane tematy, aby zwiększyć różnorodność treści",
        "generator.size": "Rozmiar tytułu",
        "generator.size_short": "Krótki",
        "generator.size_medium": "Średni",
        "generator.size_long": "Długi",
        "generator.include_profile": "Związane z moją działalnością gospodarczą",
        "generator.include_profile_tooltip": "Wybierz, czy generowane posty mają być związane z Twoją firmą, czy bardziej ogólne",
        "error.media_in_use": "Ten obraz jest używany w poście i nie można go usunąć",
        "success.cancel_account": "Konto zostało pomyślnie anulowane!",
        "error.fill_required_fields": "Proszę wypełnić wszystkie wymagane pola",
        "generator.media_format": "Typ pliku post",
        "generator.media_format_image": "Obraz",
        "generator.media_format_video": "Wideo",
        "generator.hasCaption": "Czy masz stworzony podpis?",
        "generator.post_format": "Format",
        "generator.post_format_post": "Post",
        "generator.post_format_reels": "Bębny",
        "generator.post_format_story": "Story",
        "error.format_post_not_support_media": "Wybrany format posta nie obsługuje tego typu multimediów",
        "error.limit_posts_per_format": "Wybrany format posta nie obsługuje tak wielu plików",
        "label.content_already_generated": "Twój post już wygenerował treść, czy chcesz nadpisać strony karuzeli? Pierwsza strona zostanie zachowana.",
        "error.post_duration_exceeded": "Czas trwania posta przekroczył maksymalny limit %s sekund."
    }
}

const _trans = {
    ideas: {
        profileMessages: {
            'pt': [
                'Carregando seu perfil...',
                'Entendendo sobre seu negócio...',
                'Escolhendo as melhores cores...',
                'Selecionando as fontes para você...',
                'Quase lá...',
                'Falta pouco...',
                'Estamos quase terminando...',
                'Só mais um pouquinho...',
            ],
            'en': [
                'Loading your profile...',
                'Understanding your business...',
                'Choosing the best colors...',
                'Selecting the fonts for you...',
                'Almost there...',
                'Just a little more...',
                'We are almost done...',
                'Just a little more...',
            ],
            'es': [
                'Cargando tu perfil...',
                'Entendiendo sobre tu negocio...',
                'Seleccionando los mejores colores...',
                'Seleccionando las fuentes para ti...',
                'Casi allí...',
                'Falta poco...',
                'Estamos casi terminando...',
                'Solo un poquito más...',
            ],
            'fr': [
                'Chargement de votre profil...',
                'Comprendre votre entreprise...',
                'Choisir les meilleures couleurs...',
                'Sélection des polices pour vous...',
                'Presque là...',
                'Encore un peu...',
                'Nous y sommes presque...',
                'Encore un peu...',
            ],
            'de': [
                'Laden Sie Ihr Profil...',
                'Verstehen Sie Ihr Geschäft...',
                'Wählen Sie die besten Farben...',
                'Wählen Sie die Schriftarten für Sie aus...',
                'Fast da...',
                'Nur noch ein wenig...',
                'Wir sind fast fertig...',
                'Nur noch ein wenig...',
            ],
            'it': [
                'Caricamento del tuo profilo...',
                'Comprendere la tua attività...',
                'Scegliere i migliori colori...',
                'Selezionare i font per te...',
                'Quasi arrivato...',
                'Solo un po\' di più...',
                'Siamo quasi arrivati...',
                'Solo un po\' di più...',
            ],
            'nl': [
                'Je profiel laden...',
                'Je bedrijf begrijpen...',
                'De beste kleuren kiezen...',
                'De lettertypen voor je selecteren...',
                'Bijna klaar...',
                'Nog maar een beetje...',
                'We zijn er bijna...',
                'Nog maar een beetje...',
            ],
            'da': [
                'Indlæser din profil...',
                'Forstå din virksomhed...',
                'Vælger de bedste farver...',
                'Vælger skrifttyperne for dig...',
                'Næsten der...',
                'Bare lidt mere...',
                'Vi er næsten færdige...',
                'Bare lidt mere...',
            ],
            'sv': [
                'Laddar din profil...',
                'Förstå din verksamhet...',
                'Väljer de bästa färgerna...',
                'Väljer typsnitten för dig...',
                'Nästan där...',
                'Bara lite till...',
                'Vi är nästan klara...',
                'Bara lite till...',
            ],
            'pl': [
                'Ładowanie profilu...',
                'Rozumienie twojej działalności...',
                'Wybieranie najlepszych kolorów...',
                'Wybieranie czcionek dla ciebie...',
                'Już prawie...',
                'Trochę więcej...',
                'Jesteśmy prawie gotowi...',
                'Trochę więcej...',
            ],
        }
    },
    publish: {
        helpInstagram: {
            'pt': 'https://galilai.tawk.help/article/como-conectar-instagram-no-galilai'
        },
        instructions: {
            'pt': [
                `Que sua conta do Instagram seja <a href="https://business.instagram.com/getting-started?locale=pt_BR" target="_blank">uma conta empresarial</a>`,
                `Que a conta do Instagram esteja <a href="https://pt-br.facebook.com/business/help/connect-instagram-to-page" target="_blank">conectada a uma página do Facebook</a>`,
                `Que você seja administrador da página do Facebook conectada ao Instagram`,
                `Que você tenha aceitado as permissões do GalilAI. <a id="try-again-galilai" href="javascript:void(0)"> Tente aqui novamente</a>`
            ],
            'en': [
                `Your Instagram account must be <a href="https://business.instagram.com/getting-started?locale=en_US" target="_blank">a business account</a>`,
                `Your Instagram account must be <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">connected to a Facebook page</a>`,
                `You must be an administrator of the Facebook page connected to Instagram`,
                `You must have accepted GalilAI permissions. <a id="try-again-galilai" href="javascript:void(0)"> Try here again</a>`
            ],
            'es': [
                `Su cuenta de Instagram debe ser <a href="https://business.instagram.com/getting-started?locale=es_ES" target="_blank">una cuenta empresarial</a>`,
                `Su cuenta de Instagram debe estar <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">conectada a una página de Facebook</a>`,
                `Debe ser administrador de la página de Facebook conectada a Instagram`,
                `Debe haber aceptado los permisos de GalilAI. <a id="try-again-galilai" href="javascript:void(0)"> Intente aquí nuevamente</a>`
            ],
            'fr': [
                `Votre compte Instagram doit être <a href="https://business.instagram.com/getting-started?locale=fr_FR" target="_blank">un compte professionnel</a>`,
                `Votre compte Instagram doit être <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">connecté à une page Facebook</a>`,
                `Vous devez être administrateur de la page Facebook connectée à Instagram`,
                `Vous devez avoir accepté les autorisations de GalilAI. <a id="try-again-galilai" href="javascript:void(0)"> Réessayez ici</a>`
            ],
            'de': [
                `Ihr Instagram-Konto muss <a href="https://business.instagram.com/getting-started?locale=de_DE" target="_blank">ein Geschäftskonto sein</a>`,
                `Ihr Instagram-Konto muss <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">mit einer Facebook-Seite verbunden sein</a>`,
                `Sie müssen ein Administrator der mit Instagram verbundenen Facebook-Seite sein`,
                `Sie müssen die GalilAI-Berechtigungen akzeptiert haben. <a id="try-again-galilai" href="javascript:void(0)"> Versuchen Sie es hier erneut</a>`
            ],
            'it': [
                `Il tuo account Instagram deve essere <a href="https://business.instagram.com/getting-started?locale=it_IT" target="_blank">un account aziendale</a>`,
                `Il tuo account Instagram deve essere <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">collegato a una pagina Facebook</a>`,
                `Devi essere un amministratore della pagina Facebook collegata a Instagram`,
                `Devi aver accettato i permessi di GalilAI. <a id="try-again-galilai" href="javascript:void(0)"> Riprova qui</a>`
            ],
            'nl': [
                `Je Instagram-account moet <a href="https://business.instagram.com/getting-started?locale=nl_NL" target="_blank">een zakelijk account</a> zijn`,
                `Je Instagram-account moet <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">verbonden zijn met een Facebook-pagina</a>`,
                `Je moet een beheerder zijn van de Facebook-pagina die is verbonden met Instagram`,
                `Je moet de GalilAI-machtigingen hebben geaccepteerd. <a id="try-again-galilai" href="javascript:void(0)"> Probeer hier opnieuw</a>`
            ],
            'da': [
                `Din Instagram-konto skal være <a href="https://business.instagram.com/getting-started?locale=da_DK" target="_blank">en forretningskonto</a>`,
                `Din Instagram-konto skal være <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">tilsluttet en Facebook-side</a>`,
                `Du skal være administrator af den Facebook-side, der er tilsluttet Instagram`,
                `Du skal have accepteret GalilAI-tilladelserne. <a id="try-again-galilai" href="javascript:void(0)"> Prøv her igen</a>`
            ],
            'sv': [
                `Ditt Instagram-konto måste vara <a href="https://business.instagram.com/getting-started?locale=sv_SE" target="_blank">ett företagskonto</a>`,
                `Ditt Instagram-konto måste vara <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">kopplat till en Facebook-sida</a>`,
                `Du måste vara administratör för den Facebook-sida som är kopplad till Instagram`,
                `Du måste ha accepterat GalilAI-behörigheter. <a id="try-again-galilai" href="javascript:void(0)"> Försök här igen</a>`
            ],
            'pl': [
                `Twoje konto na Instagramie musi być <a href="https://business.instagram.com/getting-started?locale=pl_PL" target="_blank">kontem firmowym</a>`,
                `Twoje konto na Instagramie musi być <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">połączone z stroną na Facebooku</a>`,
                `Musisz być administratorem strony na Facebooku połączonej z Instagramem`,
                `Musisz zaakceptować uprawnienia GalilAI. <a id="try-again-galilai" href="javascript:void(0)"> Spróbuj tutaj ponownie</a>`
            ]
        }
    },
    trial: {
        features: {
            'pt': [
                'Aumente sua autoridade e cresça seu perfil',
                'Milhares de ideias para posts todos os dias',
                'Edite cores, fontes, imagens e muito mais',
                'Legendas em um clique para seus posts',
            ],
            'en': [
                'Increase your authority and grow your Instagram profile',
                'Thousands of post ideas every day',
                'Edit colors, fonts, images and more',
                'One-click captions for your posts'
            ],
            'es': [
                'Aumenta tu autoridad y crece tu perfil',
                'Miles de ideas de posts todos los días',
                'Edita colores, fuentes, imágenes y mucho más',
                'Leyendas en un clic para tus posts'
            ],
            'fr': [
                'Augmentez votre autorité et développez votre profil',
                'Des milliers d\'idées de posts tous les jours',
                'Modifiez les couleurs, les polices, les images et plus encore',
                'Légendes en un clic pour vos posts'
            ],
            'de': [
                'Erhöhen Sie Ihre Autorität und wachsen Sie Ihr Profil',
                'Tausende von Post-Ideen jeden Tag',
                'Bearbeiten Sie Farben, Schriftarten, Bilder und mehr',
                'Ein-Klick-Untertitel für Ihre Posts'
            ],
            'it': [
                'Aumenta la tua autorità e fai crescere il tuo profilo',
                'Migliaia di idee di post ogni giorno',
                'Modifica colori, font, immagini e altro',
                'Sottotitoli in un clic per i tuoi post'
            ],
            'nl': [
                'Verhoog uw autoriteit en groei uw profiel',
                'Duizenden postideeën elke dag',
                'Bewerk kleuren, lettertypen, afbeeldingen en meer',
                'Eén-klik onderschriften voor uw posts'
            ],
            'da': [
                'Øg din autoritet og vækst din profil',
                'Tusindvis af postideer hver dag',
                'Rediger farver, skrifttyper, billeder og mere',
                'Én-klik billedtekster til dine indlæg'
            ],
            'sv': [
                'Öka din auktoritet och väx din profil',
                'Tusentals postidéer varje dag',
                'Redigera färger, typsnitt, bilder och mer',
                'Ett klick bildtexter för dina inlägg'
            ],
            'pl': [
                'Zwiększ swoją władzę i rozwijaj swój profil',
                'Tysiące pomysłów na posty każdego dnia',
                'Edytuj kolory, czcionki, obrazy i więcej',
                'Podpisy w jednym kliknięciu dla twoich postów'
            ]
        }
    },
    support: {
        url: {
            'en': 'https://galil.ai/contact',
            'pt': 'https://galilai.com.br/contato',
            'es': 'https://galilai.es/contacto',
            'fr': 'https://galilai.fr/contact',
            'de': 'https://galilai.de/kontakt',
            'it': 'https://galilai.it/contatto',
            'nl': 'https://galilai.nl/contact',
            'da': 'https://galilai.dk/kontakt',
            'sv': 'https://galilai.se/kontakt',
            'pl': 'https://galilai.pl/kontakt',
        },
    }
}

const countriesToCurrency = {
    "US": { name: "United States", currency: "$" },
    "CN": { name: "China", currency: "¥" },
    "JP": { name: "Japan", currency: "¥" },
    "DE": { name: "Germany", currency: "€" },
    "IN": { name: "India", currency: "₹" },
    "GB": { name: "United Kingdom", currency: "£" },
    "FR": { name: "France", currency: "€" },
    "CA": { name: "Canada", currency: "C$" },
    "IT": { name: "Italy", currency: "€" },
    "BR": { name: "Brazil", currency: "R$" },
    "RU": { name: "Russia", currency: "₽" },
    "KR": { name: "South Korea", currency: "₩" },
    "AU": { name: "Australia", currency: "A$" },
    "ES": { name: "Spain", currency: "€" },
    "MX": { name: "Mexico", currency: "MX$" },
    "ID": { name: "Indonesia", currency: "Rp" },
    "NL": { name: "Netherlands", currency: "€" },
    "SA": { name: "Saudi Arabia", currency: "﷼" },
    "TR": { name: "Türkiye (Turkey)", currency: "₺" },
    "CH": { name: "Switzerland", currency: "Fr." },
    "AR": { name: "Argentina", currency: "$" },
    "SE": { name: "Sweden", currency: "kr" },
    "PL": { name: "Poland", currency: "zł" },
    "BE": { name: "Belgium", currency: "€" },
    "TH": { name: "Thailand", currency: "฿" },
    "IE": { name: "Ireland", currency: "€" },
    "NG": { name: "Nigeria", currency: "₦" },
    "IL": { name: "Israel", currency: "₪" },
    "AT": { name: "Austria", currency: "€" },
    "NO": { name: "Norway", currency: "kr" },
    "AE": { name: "United Arab Emirates", currency: "د.إ" },
    "HK": { name: "Hong Kong (China)", currency: "HK$" },
    "MY": { name: "Malaysia", currency: "RM" },
    "SG": { name: "Singapore", currency: "S$" },
    "PH": { name: "Philippines", currency: "₱" },
    "ZA": { name: "South Africa", currency: "R" },
    "DK": { name: "Denmark", currency: "kr" },
    "CO": { name: "Colombia", currency: "$" }, // TODO - this is buggy
    "BD": { name: "Bangladesh", currency: "৳" },
    "EG": { name: "Egypt", currency: "E£" },
    "CL": { name: "Chile", currency: "$" },
    "FI": { name: "Finland", currency: "€" },
    "VN": { name: "Vietnam", currency: "₫" },
    "PT": { name: "Portugal", currency: "€" },
    "CZ": { name: "Czech Republic", currency: "Kč" },
    "RO": { name: "Romania", currency: "lei" },
    "NZ": { name: "New Zealand", currency: "NZ$" },
    "PE": { name: "Peru", currency: "S/." },
    "GR": { name: "Greece", currency: "€" },
    "IQ": { name: "Iraq", currency: "ع.د" },
    "QA": { name: "Qatar", currency: "QR" },
    "DZ": { name: "Algeria", currency: "دج" },
    "KZ": { name: "Kazakhstan", currency: "₸" },
    "HU": { name: "Hungary", currency: "Ft" },
    "AO": { name: "Angola", currency: "Kz" },
    "KW": { name: "Kuwait", currency: "KD" },
    "MA": { name: "Morocco", currency: "MAD" },
    "UA": { name: "Ukraine", currency: "₴" },
    "EC": { name: "Ecuador", currency: "$" },
    "SK": { name: "Slovakia", currency: "€" },
    "LK": { name: "Sri Lanka", currency: "Rs" },
    "KE": { name: "Kenya", currency: "KSh" },
    "PR": { name: "Puerto Rico", currency: "$" },
    "PA": { name: "Panama", currency: "B/." },
    "DO": { name: "Dominican Republic", currency: "RD$" },
    "ET": { name: "Ethiopia", currency: "Br" },
    "GT": { name: "Guatemala", currency: "Q" },
    "OM": { name: "Oman", currency: "ر.ع." },
    "LU": { name: "Luxembourg", currency: "€" },
    "GH": { name: "Ghana", currency: "GH₵" },
    "UZ": { name: "Uzbekistan", currency: "so’m" },
    "BG": { name: "Bulgaria", currency: "лв" },
    "MM": { name: "Myanmar", currency: "K" },
    "HR": { name: "Croatia", currency: "€" },
    "TZ": { name: "Tanzania", currency: "TSh" },
    "BY": { name: "Belarus", currency: "Br" },
    "CR": { name: "Costa Rica", currency: "₡" },
    "SI": { name: "Slovenia", currency: "€" },
    "LT": { name: "Lithuania", currency: "€" },
    "MO": { name: "Macao (China)", currency: "MOP$" },
    "TN": { name: "Tunisia", currency: "د.ت" },
    "RS": { name: "Serbia", currency: "дин." },
    "TM": { name: "Turkmenistan", currency: "T" },
    "JO": { name: "Jordan", currency: "JD" },
    "UG": { name: "Uganda", currency: "USh" },
    "CI": { name: "Côte d'Ivoire", currency: "CFA" },
    "AZ": { name: "Azerbaijan", currency: "₼" },
    "LY": { name: "Libya", currency: "ل.د" },
    "CD": { name: "Congo, Dem. Rep.", currency: "FC" },
    "BO": { name: "Bolivia", currency: "Bs." },
    "BH": { name: "Bahrain", currency: ".د.ب" },
    "CM": { name: "Cameroon", currency: "CFA" },
    "PY": { name: "Paraguay", currency: "₲" },
    "LV": { name: "Latvia", currency: "€" },
    "EE": { name: "Estonia", currency: "€" },
    "ZM": { name: "Zambia", currency: "K" },
    "NP": { name: "Nepal", currency: "रु" },
    "HN": { name: "Honduras", currency: "L" },
    "CY": { name: "Cyprus", currency: "€" },
    "AF": { name: "Afghanistan", currency: "؋" }
}

function HistoryManager(initialState) {
    // Initialize stacks for undo and redo history
    var undoStack = [];
    var redoStack = [];

    // Set the initial state
    var currentState = JSON.parse(JSON.stringify(initialState));

    let debounceTimeout = null;
    const debounceTimer = 300;
    const DEBUG = window.location.hostname === 'localhost';
    // Method to perform an action and update state
    this.add = function (newState, debounce = false) {

        function add() {
            // Push the current state to the undo stack
            undoStack.push(JSON.parse(JSON.stringify(currentState)));

            // Clear the redo stack on new action
            redoStack = [];

            // Update the current state with new values
            currentState = JSON.parse(JSON.stringify(newState));
            if (DEBUG) {
                console.log("Performed action, new state:", currentState);
            }
        }

        if (debounce) {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => {
                add();
            }, debounceTimer);
        } else {
            add();
        }
    };


    // Method to undo the last action
    this.undo = function () {
        if (undoStack.length > 0) {
            // Push the current state to the redo stack
            redoStack.push(JSON.parse(JSON.stringify(currentState)));

            // Pop the last state from the undo stack
            currentState = undoStack.pop();
            if (DEBUG) {
                console.log("Undo performed, current state:", currentState);
            }
        }
    };

    // Method to redo the last undone action
    this.redo = function () {
        if (redoStack.length > 0) {
            // Push the current state to the undo stack
            undoStack.push(JSON.parse(JSON.stringify(currentState)));

            // Pop the last state from the redo stack
            currentState = redoStack.pop();
            if (DEBUG) {
                console.log("Redo performed, current state:", currentState);
            }
        }
    };

    this.canUndo = function () {
        return undoStack.length > 0;
    };

    this.canRedo = function () {
        return redoStack.length > 0;
    }

    // Method to get the current state
    this.getState = function () {
        return JSON.parse(JSON.stringify(currentState));
    };
}